import { Fragment as ie, reactive as Le, computed as h, watchEffect as Te, toRefs as Un, capitalize as Kn, isVNode as so, Comment as ro, unref as ke, warn as dn, ref as D, provide as we, inject as ue, shallowRef as z, defineComponent as uo, camelize as gl, h as xt, getCurrentInstance as co, onBeforeUnmount as Ie, watch as H, readonly as Yn, onDeactivated as fo, onActivated as vo, onMounted as He, onScopeDispose as Ce, effectScope as qn, toRaw as Ye, createVNode as u, TransitionGroup as mo, Transition as Ke, mergeProps as q, onBeforeMount as Xn, nextTick as de, withDirectives as Ve, resolveDirective as qe, vShow as pt, isRef as Lt, toRef as K, Text as go, resolveDynamicComponent as ho, Teleport as yo, cloneVNode as bo, createTextVNode as hl, vModelText as So } from "vue";
function F(e, n) {
  return (t) => Object.keys(e).reduce((a, l) => {
    const o = typeof e[l] == "object" && e[l] != null && !Array.isArray(e[l]) ? e[l] : {
      type: e[l]
    };
    return t && l in t ? a[l] = {
      ...o,
      default: t[l]
    } : a[l] = o, n && !a[l].source && (a[l].source = n), a;
  }, {});
}
const ne = F({
  class: [String, Array],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component"), se = typeof window < "u", Zn = se && "IntersectionObserver" in window, wo = se && ("ontouchstart" in window || window.navigator.maxTouchPoints > 0), tc = se && "EyeDropper" in window;
function Va(e, n, t) {
  Co(e, n), n.set(e, t);
}
function Co(e, n) {
  if (n.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function xo(e, n, t) {
  var a = yl(e, n, "set");
  return po(e, a, t), t;
}
function po(e, n, t) {
  if (n.set)
    n.set.call(e, t);
  else {
    if (!n.writable)
      throw new TypeError("attempted to set read only private field");
    n.value = t;
  }
}
function nt(e, n) {
  var t = yl(e, n, "get");
  return ko(e, t);
}
function yl(e, n, t) {
  if (!n.has(e))
    throw new TypeError("attempted to " + t + " private field on non-instance");
  return n.get(e);
}
function ko(e, n) {
  return n.get ? n.get.call(e) : n.value;
}
function bl(e, n, t) {
  const a = n.length - 1;
  if (a < 0)
    return e === void 0 ? t : e;
  for (let l = 0; l < a; l++) {
    if (e == null)
      return t;
    e = e[n[l]];
  }
  return e == null || e[n[a]] === void 0 ? t : e[n[a]];
}
function kt(e, n) {
  if (e === n)
    return !0;
  if (e instanceof Date && n instanceof Date && e.getTime() !== n.getTime() || e !== Object(e) || n !== Object(n))
    return !1;
  const t = Object.keys(e);
  return t.length !== Object.keys(n).length ? !1 : t.every((a) => kt(e[a], n[a]));
}
function Tn(e, n, t) {
  return e == null || !n || typeof n != "string" ? t : e[n] !== void 0 ? e[n] : (n = n.replace(/\[(\w+)\]/g, ".$1"), n = n.replace(/^\./, ""), bl(e, n.split("."), t));
}
function Oe(e, n, t) {
  if (n === !0)
    return e === void 0 ? t : e;
  if (n == null || typeof n == "boolean")
    return t;
  if (e !== Object(e)) {
    if (typeof n != "function")
      return t;
    const l = n(e, t);
    return typeof l > "u" ? t : l;
  }
  if (typeof n == "string")
    return Tn(e, n, t);
  if (Array.isArray(n))
    return bl(e, n, t);
  if (typeof n != "function")
    return t;
  const a = n(e, t);
  return typeof a > "u" ? t : a;
}
function Vo(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Array.from({
    length: e
  }, (t, a) => n + a);
}
function j(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${n}` : void 0;
}
function En(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Et(e) {
  if (e && "$el" in e) {
    const n = e.$el;
    return (n == null ? void 0 : n.nodeType) === Node.TEXT_NODE ? n.nextElementSibling : n;
  }
  return e;
}
const Pa = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
}), nc = Object.freeze({
  enter: "Enter",
  tab: "Tab",
  delete: "Delete",
  esc: "Escape",
  space: "Space",
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  end: "End",
  home: "Home",
  del: "Delete",
  backspace: "Backspace",
  insert: "Insert",
  pageup: "PageUp",
  pagedown: "PageDown",
  shift: "Shift"
});
function ac(e) {
  return Object.keys(e);
}
function wn(e, n) {
  return n.every((t) => e.hasOwnProperty(t));
}
function Sl(e, n) {
  const t = {}, a = new Set(Object.keys(e));
  for (const l of n)
    a.has(l) && (t[l] = e[l]);
  return t;
}
function Ia(e, n, t) {
  const a = /* @__PURE__ */ Object.create(null), l = /* @__PURE__ */ Object.create(null);
  for (const i in e)
    n.some((o) => o instanceof RegExp ? o.test(i) : o === i) && !(t != null && t.some((o) => o === i)) ? a[i] = e[i] : l[i] = e[i];
  return [a, l];
}
function Xe(e, n) {
  const t = {
    ...e
  };
  return n.forEach((a) => delete t[a]), t;
}
function lc(e, n) {
  const t = {};
  return n.forEach((a) => t[a] = e[a]), t;
}
const wl = /^on[^a-z]/, Jn = (e) => wl.test(e), Po = ["onAfterscriptexecute", "onAnimationcancel", "onAnimationend", "onAnimationiteration", "onAnimationstart", "onAuxclick", "onBeforeinput", "onBeforescriptexecute", "onChange", "onClick", "onCompositionend", "onCompositionstart", "onCompositionupdate", "onContextmenu", "onCopy", "onCut", "onDblclick", "onFocusin", "onFocusout", "onFullscreenchange", "onFullscreenerror", "onGesturechange", "onGestureend", "onGesturestart", "onGotpointercapture", "onInput", "onKeydown", "onKeypress", "onKeyup", "onLostpointercapture", "onMousedown", "onMousemove", "onMouseout", "onMouseover", "onMouseup", "onMousewheel", "onPaste", "onPointercancel", "onPointerdown", "onPointerenter", "onPointerleave", "onPointermove", "onPointerout", "onPointerover", "onPointerup", "onReset", "onSelect", "onSubmit", "onTouchcancel", "onTouchend", "onTouchmove", "onTouchstart", "onTransitioncancel", "onTransitionend", "onTransitionrun", "onTransitionstart", "onWheel"], Io = ["ArrowUp", "ArrowDown", "ArrowRight", "ArrowLeft", "Enter", "Escape", "Tab", " "];
function ic(e) {
  return e.isComposing && Io.includes(e.key);
}
function fn(e) {
  const [n, t] = Ia(e, [wl]), a = Xe(n, Po), [l, i] = Ia(t, ["class", "style", "id", /^data-/]);
  return Object.assign(l, n), Object.assign(i, a), [l, i];
}
function Ae(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function _o(e, n) {
  let t = 0;
  const a = function() {
    for (var l = arguments.length, i = new Array(l), o = 0; o < l; o++)
      i[o] = arguments[o];
    clearTimeout(t), t = setTimeout(() => e(...i), ke(n));
  };
  return a.clear = () => {
    clearTimeout(t);
  }, a.immediate = e, a;
}
function lt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(n, Math.min(t, e));
}
function oc(e) {
  const n = e.toString().trim();
  return n.includes(".") ? n.length - n.indexOf(".") - 1 : 0;
}
function _a(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + t.repeat(Math.max(0, n - e.length));
}
function sc(e, n) {
  return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0").repeat(Math.max(0, n - e.length)) + e;
}
function Ao(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const t = [];
  let a = 0;
  for (; a < e.length; )
    t.push(e.substr(a, n)), a += n;
  return t;
}
function rc(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
  if (e < n)
    return `${e} B`;
  const t = n === 1024 ? ["Ki", "Mi", "Gi"] : ["k", "M", "G"];
  let a = -1;
  for (; Math.abs(e) >= n && a < t.length - 1; )
    e /= n, ++a;
  return `${e.toFixed(1)} ${t[a]}B`;
}
function Me() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 ? arguments[2] : void 0;
  const a = {};
  for (const l in e)
    a[l] = e[l];
  for (const l in n) {
    const i = e[l], o = n[l];
    if (En(i) && En(o)) {
      a[l] = Me(i, o, t);
      continue;
    }
    if (Array.isArray(i) && Array.isArray(o) && t) {
      a[l] = t(i, o);
      continue;
    }
    a[l] = o;
  }
  return a;
}
function Cl(e) {
  return e.map((n) => n.type === ie ? Cl(n.children) : n).flat();
}
function it() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (it.cache.has(e))
    return it.cache.get(e);
  const n = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return it.cache.set(e, n), n;
}
it.cache = /* @__PURE__ */ new Map();
function Tt(e, n) {
  if (!n || typeof n != "object")
    return [];
  if (Array.isArray(n))
    return n.map((t) => Tt(e, t)).flat(1);
  if (Array.isArray(n.children))
    return n.children.map((t) => Tt(e, t)).flat(1);
  if (n.component) {
    if (Object.getOwnPropertySymbols(n.component.provides).includes(e))
      return [n.component];
    if (n.component.subTree)
      return Tt(e, n.component.subTree).flat(1);
  }
  return [];
}
var jt = /* @__PURE__ */ new WeakMap(), mt = /* @__PURE__ */ new WeakMap();
class To {
  constructor(n) {
    Va(this, jt, {
      writable: !0,
      value: []
    }), Va(this, mt, {
      writable: !0,
      value: 0
    }), this.size = n;
  }
  push(n) {
    nt(this, jt)[nt(this, mt)] = n, xo(this, mt, (nt(this, mt) + 1) % this.size);
  }
  values() {
    return nt(this, jt).slice(nt(this, mt)).concat(nt(this, jt).slice(0, nt(this, mt)));
  }
}
function uc(e) {
  return "touches" in e ? {
    clientX: e.touches[0].clientX,
    clientY: e.touches[0].clientY
  } : {
    clientX: e.clientX,
    clientY: e.clientY
  };
}
function Qn(e) {
  const n = Le({}), t = h(e);
  return Te(() => {
    for (const a in t.value)
      n[a] = t.value[a];
  }, {
    flush: "sync"
  }), Un(n);
}
function Zt(e, n) {
  return e.includes(n);
}
function xl(e) {
  return e[2].toLowerCase() + e.slice(3);
}
const De = () => [Function, Array];
function Aa(e, n) {
  return n = "on" + Kn(n), !!(e[n] || e[`${n}Once`] || e[`${n}Capture`] || e[`${n}OnceCapture`] || e[`${n}CaptureOnce`]);
}
function pl(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    t[a - 1] = arguments[a];
  if (Array.isArray(e))
    for (const l of e)
      l(...t);
  else
    typeof e == "function" && e(...t);
}
function Bn(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const t = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((a) => `${a}${n ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...e.querySelectorAll(t)];
}
function kl(e, n, t) {
  let a, l = e.indexOf(document.activeElement);
  const i = n === "next" ? 1 : -1;
  do
    l += i, a = e[l];
  while ((!a || a.offsetParent == null || !((t == null ? void 0 : t(a)) ?? !0)) && l < e.length && l >= 0);
  return a;
}
function Jt(e, n) {
  var a, l, i, o;
  const t = Bn(e);
  if (!n)
    (e === document.activeElement || !e.contains(document.activeElement)) && ((a = t[0]) == null || a.focus());
  else if (n === "first")
    (l = t[0]) == null || l.focus();
  else if (n === "last")
    (i = t.at(-1)) == null || i.focus();
  else if (typeof n == "number")
    (o = t[n]) == null || o.focus();
  else {
    const s = kl(t, n);
    s ? s.focus() : Jt(e, n === "next" ? "first" : "last");
  }
}
function cc(e) {
  return e == null || typeof e == "string" && e.trim() === "";
}
function Eo() {
}
function bt(e, n) {
  if (!(se && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${n})`)))
    return null;
  try {
    return !!e && e.matches(n);
  } catch {
    return null;
  }
}
function ea(e) {
  return e.some((n) => so(n) ? n.type === ro ? !1 : n.type !== ie || ea(n.children) : !0) ? e : null;
}
function Bo(e, n) {
  if (!se || e === 0)
    return n(), () => {
    };
  const t = window.setTimeout(n, e);
  return () => window.clearTimeout(t);
}
const Vl = ["top", "bottom"], $o = ["start", "end", "left", "right"];
function $n(e, n) {
  let [t, a] = e.split(" ");
  return a || (a = Zt(Vl, t) ? "start" : Zt($o, t) ? "top" : "center"), {
    side: Fn(t, n),
    align: Fn(a, n)
  };
}
function Fn(e, n) {
  return e === "start" ? n ? "right" : "left" : e === "end" ? n ? "left" : "right" : e;
}
function Cn(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function xn(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function Ta(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function Ea(e) {
  return Zt(Vl, e.side) ? "y" : "x";
}
class ot {
  constructor(n) {
    let {
      x: t,
      y: a,
      width: l,
      height: i
    } = n;
    this.x = t, this.y = a, this.width = l, this.height = i;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function Ba(e, n) {
  return {
    x: {
      before: Math.max(0, n.left - e.left),
      after: Math.max(0, e.right - n.right)
    },
    y: {
      before: Math.max(0, n.top - e.top),
      after: Math.max(0, e.bottom - n.bottom)
    }
  };
}
function Pl(e) {
  return Array.isArray(e) ? new ot({
    x: e[0],
    y: e[1],
    width: 0,
    height: 0
  }) : e.getBoundingClientRect();
}
function ta(e) {
  const n = e.getBoundingClientRect(), t = getComputedStyle(e), a = t.transform;
  if (a) {
    let l, i, o, s, r;
    if (a.startsWith("matrix3d("))
      l = a.slice(9, -1).split(/, /), i = +l[0], o = +l[5], s = +l[12], r = +l[13];
    else if (a.startsWith("matrix("))
      l = a.slice(7, -1).split(/, /), i = +l[0], o = +l[3], s = +l[4], r = +l[5];
    else
      return new ot(n);
    const f = t.transformOrigin, v = n.x - s - (1 - i) * parseFloat(f), d = n.y - r - (1 - o) * parseFloat(f.slice(f.indexOf(" ") + 1)), c = i ? n.width / i : e.offsetWidth + 1, m = o ? n.height / o : e.offsetHeight + 1;
    return new ot({
      x: v,
      y: d,
      width: c,
      height: m
    });
  } else
    return new ot(n);
}
function yt(e, n, t) {
  if (typeof e.animate > "u")
    return {
      finished: Promise.resolve()
    };
  let a;
  try {
    a = e.animate(n, t);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof a.finished > "u" && (a.finished = new Promise((l) => {
    a.onfinish = () => {
      l(a);
    };
  })), a;
}
const Yt = /* @__PURE__ */ new WeakMap();
function Fo(e, n) {
  Object.keys(n).forEach((t) => {
    if (Jn(t)) {
      const a = xl(t), l = Yt.get(e);
      if (n[t] == null)
        l == null || l.forEach((i) => {
          const [o, s] = i;
          o === a && (e.removeEventListener(a, s), l.delete(i));
        });
      else if (!l || ![...l].some((i) => i[0] === a && i[1] === n[t])) {
        e.addEventListener(a, n[t]);
        const i = l || /* @__PURE__ */ new Set();
        i.add([a, n[t]]), Yt.has(e) || Yt.set(e, i);
      }
    } else
      n[t] == null ? e.removeAttribute(t) : e.setAttribute(t, n[t]);
  });
}
function Lo(e, n) {
  Object.keys(n).forEach((t) => {
    if (Jn(t)) {
      const a = xl(t), l = Yt.get(e);
      l == null || l.forEach((i) => {
        const [o, s] = i;
        o === a && (e.removeEventListener(a, s), l.delete(i));
      });
    } else
      e.removeAttribute(t);
  });
}
const gt = 2.4, $a = 0.2126729, Fa = 0.7151522, La = 0.072175, Oo = 0.55, Mo = 0.58, Ro = 0.57, Do = 0.62, Wt = 0.03, Oa = 1.45, No = 5e-4, zo = 1.25, Ho = 1.25, Ma = 0.078, Ra = 12.82051282051282, Gt = 0.06, Da = 1e-3;
function Na(e, n) {
  const t = (e.r / 255) ** gt, a = (e.g / 255) ** gt, l = (e.b / 255) ** gt, i = (n.r / 255) ** gt, o = (n.g / 255) ** gt, s = (n.b / 255) ** gt;
  let r = t * $a + a * Fa + l * La, f = i * $a + o * Fa + s * La;
  if (r <= Wt && (r += (Wt - r) ** Oa), f <= Wt && (f += (Wt - f) ** Oa), Math.abs(f - r) < No)
    return 0;
  let v;
  if (f > r) {
    const d = (f ** Oo - r ** Mo) * zo;
    v = d < Da ? 0 : d < Ma ? d - d * Ra * Gt : d - Gt;
  } else {
    const d = (f ** Do - r ** Ro) * Ho;
    v = d > -Da ? 0 : d > -Ma ? d - d * Ra * Gt : d + Gt;
  }
  return v * 100;
}
function st(e) {
  dn(`Vuetify: ${e}`);
}
function Ln(e) {
  dn(`Vuetify error: ${e}`);
}
function jo(e, n) {
  n = Array.isArray(n) ? n.slice(0, -1).map((t) => `'${t}'`).join(", ") + ` or '${n.at(-1)}'` : `'${n}'`, dn(`[Vuetify UPGRADE] '${e}' is deprecated, use ${n} instead.`);
}
const Qt = 0.20689655172413793, Wo = (e) => e > Qt ** 3 ? Math.cbrt(e) : e / (3 * Qt ** 2) + 4 / 29, Go = (e) => e > Qt ? e ** 3 : 3 * Qt ** 2 * (e - 4 / 29);
function Il(e) {
  const n = Wo, t = n(e[1]);
  return [116 * t - 16, 500 * (n(e[0] / 0.95047) - t), 200 * (t - n(e[2] / 1.08883))];
}
function _l(e) {
  const n = Go, t = (e[0] + 16) / 116;
  return [n(t + e[1] / 500) * 0.95047, n(t), n(t - e[2] / 200) * 1.08883];
}
const Uo = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.204, 1.057]], Ko = (e) => e <= 31308e-7 ? e * 12.92 : 1.055 * e ** (1 / 2.4) - 0.055, Yo = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]], qo = (e) => e <= 0.04045 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
function Al(e) {
  const n = Array(3), t = Ko, a = Uo;
  for (let l = 0; l < 3; ++l)
    n[l] = Math.round(lt(t(a[l][0] * e[0] + a[l][1] * e[1] + a[l][2] * e[2])) * 255);
  return {
    r: n[0],
    g: n[1],
    b: n[2]
  };
}
function na(e) {
  let {
    r: n,
    g: t,
    b: a
  } = e;
  const l = [0, 0, 0], i = qo, o = Yo;
  n = i(n / 255), t = i(t / 255), a = i(a / 255);
  for (let s = 0; s < 3; ++s)
    l[s] = o[s][0] * n + o[s][1] * t + o[s][2] * a;
  return l;
}
function On(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function Xo(e) {
  return On(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const za = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, Zo = {
  rgb: (e, n, t, a) => ({
    r: e,
    g: n,
    b: t,
    a
  }),
  rgba: (e, n, t, a) => ({
    r: e,
    g: n,
    b: t,
    a
  }),
  hsl: (e, n, t, a) => Ha({
    h: e,
    s: n,
    l: t,
    a
  }),
  hsla: (e, n, t, a) => Ha({
    h: e,
    s: n,
    l: t,
    a
  }),
  hsv: (e, n, t, a) => rt({
    h: e,
    s: n,
    v: t,
    a
  }),
  hsva: (e, n, t, a) => rt({
    h: e,
    s: n,
    v: t,
    a
  })
};
function Re(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && st(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && za.test(e)) {
    const {
      groups: n
    } = e.match(za), {
      fn: t,
      values: a
    } = n, l = a.split(/,\s*/).map((i) => i.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(t) ? parseFloat(i) / 100 : parseFloat(i));
    return Zo[t](...l);
  } else if (typeof e == "string") {
    let n = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(n.length) ? n = n.split("").map((a) => a + a).join("") : [6, 8].includes(n.length) || st(`'${e}' is not a valid hex(a) color`);
    const t = parseInt(n, 16);
    return (isNaN(t) || t < 0 || t > 4294967295) && st(`'${e}' is not a valid hex(a) color`), Bl(n);
  } else if (typeof e == "object") {
    if (wn(e, ["r", "g", "b"]))
      return e;
    if (wn(e, ["h", "s", "l"]))
      return rt(Tl(e));
    if (wn(e, ["h", "s", "v"]))
      return rt(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function rt(e) {
  const {
    h: n,
    s: t,
    v: a,
    a: l
  } = e, i = (s) => {
    const r = (s + n / 60) % 6;
    return a - a * t * Math.max(Math.min(r, 4 - r, 1), 0);
  }, o = [i(5), i(3), i(1)].map((s) => Math.round(s * 255));
  return {
    r: o[0],
    g: o[1],
    b: o[2],
    a: l
  };
}
function Ha(e) {
  return rt(Tl(e));
}
function Jo(e) {
  if (!e)
    return {
      h: 0,
      s: 1,
      v: 1,
      a: 1
    };
  const n = e.r / 255, t = e.g / 255, a = e.b / 255, l = Math.max(n, t, a), i = Math.min(n, t, a);
  let o = 0;
  l !== i && (l === n ? o = 60 * (0 + (t - a) / (l - i)) : l === t ? o = 60 * (2 + (a - n) / (l - i)) : l === a && (o = 60 * (4 + (n - t) / (l - i)))), o < 0 && (o = o + 360);
  const s = l === 0 ? 0 : (l - i) / l, r = [o, s, l];
  return {
    h: r[0],
    s: r[1],
    v: r[2],
    a: e.a
  };
}
function dc(e) {
  const {
    h: n,
    s: t,
    v: a,
    a: l
  } = e, i = a - a * t / 2, o = i === 1 || i === 0 ? 0 : (a - i) / Math.min(i, 1 - i);
  return {
    h: n,
    s: o,
    l: i,
    a: l
  };
}
function Tl(e) {
  const {
    h: n,
    s: t,
    l: a,
    a: l
  } = e, i = a + t * Math.min(a, 1 - a), o = i === 0 ? 0 : 2 - 2 * a / i;
  return {
    h: n,
    s: o,
    v: i,
    a: l
  };
}
function Qo(e) {
  let {
    r: n,
    g: t,
    b: a,
    a: l
  } = e;
  return l === void 0 ? `rgb(${n}, ${t}, ${a})` : `rgba(${n}, ${t}, ${a}, ${l})`;
}
function fc(e) {
  return Qo(rt(e));
}
function Ut(e) {
  const n = Math.round(e).toString(16);
  return ("00".substr(0, 2 - n.length) + n).toUpperCase();
}
function El(e) {
  let {
    r: n,
    g: t,
    b: a,
    a: l
  } = e;
  return `#${[Ut(n), Ut(t), Ut(a), l !== void 0 ? Ut(Math.round(l * 255)) : ""].join("")}`;
}
function Bl(e) {
  e = es(e);
  let [n, t, a, l] = Ao(e, 2).map((i) => parseInt(i, 16));
  return l = l === void 0 ? l : l / 255, {
    r: n,
    g: t,
    b: a,
    a: l
  };
}
function vc(e) {
  const n = Bl(e);
  return Jo(n);
}
function mc(e) {
  return El(rt(e));
}
function es(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((n) => n + n).join("")), e.length !== 6 && (e = _a(_a(e, 6), 8, "F")), e;
}
function ts(e, n) {
  const t = Il(na(e));
  return t[0] = t[0] + n * 10, Al(_l(t));
}
function ns(e, n) {
  const t = Il(na(e));
  return t[0] = t[0] - n * 10, Al(_l(t));
}
function Mn(e) {
  const n = Re(e);
  return na(n)[1];
}
function gc(e, n) {
  const t = Mn(e), a = Mn(n), l = Math.max(t, a), i = Math.min(t, a);
  return (l + 0.05) / (i + 0.05);
}
function $l(e) {
  const n = Math.abs(Na(Re(0), Re(e)));
  return Math.abs(Na(Re(16777215), Re(e))) > Math.min(n, 50) ? "#fff" : "#000";
}
const en = Symbol.for("vuetify:defaults");
function hc(e) {
  return D(e);
}
function aa() {
  const e = ue(en);
  if (!e)
    throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function ut(e, n) {
  const t = aa(), a = D(e), l = h(() => {
    if (ke(n == null ? void 0 : n.disabled))
      return t.value;
    const o = ke(n == null ? void 0 : n.scoped), s = ke(n == null ? void 0 : n.reset), r = ke(n == null ? void 0 : n.root);
    if (a.value == null && !(o || s || r))
      return t.value;
    let f = Me(a.value, {
      prev: t.value
    });
    if (o)
      return f;
    if (s || r) {
      const v = Number(s || 1 / 0);
      for (let d = 0; d <= v && !(!f || !("prev" in f)); d++)
        f = f.prev;
      return f && typeof r == "string" && r in f && (f = Me(Me(f, {
        prev: f
      }), f[r])), f;
    }
    return f.prev ? Me(f.prev, f) : f;
  });
  return we(en, l), l;
}
function as(e, n) {
  var t, a;
  return typeof ((t = e.props) == null ? void 0 : t[n]) < "u" || typeof ((a = e.props) == null ? void 0 : a[it(n)]) < "u";
}
function ls() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : aa();
  const a = fe("useDefaults");
  if (n = n ?? a.type.name ?? a.type.__name, !n)
    throw new Error("[Vuetify] Could not determine component name");
  const l = h(() => {
    var r;
    return (r = t.value) == null ? void 0 : r[e._as ?? n];
  }), i = new Proxy(e, {
    get(r, f) {
      var d, c, m, g;
      const v = Reflect.get(r, f);
      return f === "class" || f === "style" ? [(d = l.value) == null ? void 0 : d[f], v].filter((y) => y != null) : typeof f == "string" && !as(a.vnode, f) ? ((c = l.value) == null ? void 0 : c[f]) ?? ((g = (m = t.value) == null ? void 0 : m.global) == null ? void 0 : g[f]) ?? v : v;
    }
  }), o = z();
  Te(() => {
    if (l.value) {
      const r = Object.entries(l.value).filter((f) => {
        let [v] = f;
        return v.startsWith(v[0].toUpperCase());
      });
      o.value = r.length ? Object.fromEntries(r) : void 0;
    } else
      o.value = void 0;
  });
  function s() {
    const r = rs(en, a);
    we(en, h(() => o.value ? Me((r == null ? void 0 : r.value) ?? {}, o.value) : r == null ? void 0 : r.value));
  }
  return {
    props: i,
    provideSubDefaults: s
  };
}
function Ot(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return st("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = F(e.props ?? {}, e.name)();
    const n = Object.keys(e.props).filter((t) => t !== "class" && t !== "style");
    e.filterProps = function(a) {
      return Sl(a, n);
    }, e.props._as = String, e.setup = function(a, l) {
      const i = aa();
      if (!i.value)
        return e._setup(a, l);
      const {
        props: o,
        provideSubDefaults: s
      } = ls(a, a._as ?? e.name, i), r = e._setup(o, l);
      return s(), r;
    };
  }
  return e;
}
function W() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (n) => (e ? Ot : uo)(n);
}
function yc(e, n) {
  return n.props = e, n;
}
function Fl(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", t = arguments.length > 2 ? arguments[2] : void 0;
  return W()({
    name: t ?? Kn(gl(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: n
      },
      ...ne()
    },
    setup(a, l) {
      let {
        slots: i
      } = l;
      return () => {
        var o;
        return xt(a.tag, {
          class: [e, a.class],
          style: a.style
        }, (o = i.default) == null ? void 0 : o.call(i));
      };
    }
  });
}
function Ll(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; )
      e = e.parentNode;
    return e !== document ? null : document;
  }
  const n = e.getRootNode();
  return n !== document && n.getRootNode({
    composed: !0
  }) !== document ? null : n;
}
const tn = "cubic-bezier(0.4, 0, 0.2, 1)", is = "cubic-bezier(0.0, 0, 0.2, 1)", os = "cubic-bezier(0.4, 0, 1, 1)";
function fe(e, n) {
  const t = co();
  if (!t)
    throw new Error(`[Vuetify] ${e} ${n || "must be called from inside a setup function"}`);
  return t;
}
function je() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const n = fe(e).type;
  return it((n == null ? void 0 : n.aliasName) || (n == null ? void 0 : n.name));
}
let Ol = 0, qt = /* @__PURE__ */ new WeakMap();
function Be() {
  const e = fe("getUid");
  if (qt.has(e))
    return qt.get(e);
  {
    const n = Ol++;
    return qt.set(e, n), n;
  }
}
Be.reset = () => {
  Ol = 0, qt = /* @__PURE__ */ new WeakMap();
};
function Ml(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; e; ) {
    if (n ? ss(e) : la(e))
      return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function nn(e, n) {
  const t = [];
  if (n && e && !n.contains(e))
    return t;
  for (; e && (la(e) && t.push(e), e !== n); )
    e = e.parentElement;
  return t;
}
function la(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const n = window.getComputedStyle(e);
  return n.overflowY === "scroll" || n.overflowY === "auto" && e.scrollHeight > e.clientHeight;
}
function ss(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const n = window.getComputedStyle(e);
  return ["scroll", "auto"].includes(n.overflowY);
}
function rs(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe("injectSelf");
  const {
    provides: t
  } = n;
  if (t && e in t)
    return t[e];
}
function us(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function Z(e) {
  const n = fe("useRender");
  n.render = e;
}
function vn(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const t = D(), a = D();
  if (se) {
    const l = new ResizeObserver((i) => {
      e == null || e(i, l), i.length && (n === "content" ? a.value = i[0].contentRect : a.value = i[0].target.getBoundingClientRect());
    });
    Ie(() => {
      l.disconnect();
    }), H(t, (i, o) => {
      o && (l.unobserve(Et(o)), a.value = void 0), i && l.observe(Et(i));
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: t,
    contentRect: Yn(a)
  };
}
const an = Symbol.for("vuetify:layout"), Rl = Symbol.for("vuetify:layout-item"), ja = 1e3, cs = F({
  overlaps: {
    type: Array,
    default: () => []
  },
  fullHeight: Boolean
}, "layout"), ds = F({
  name: {
    type: String
  },
  order: {
    type: [Number, String],
    default: 0
  },
  absolute: Boolean
}, "layout-item");
function fs() {
  const e = ue(an);
  if (!e)
    throw new Error("[Vuetify] Could not find injected layout");
  return {
    getLayoutItem: e.getLayoutItem,
    mainRect: e.mainRect,
    mainStyles: e.mainStyles
  };
}
function vs(e) {
  const n = ue(an);
  if (!n)
    throw new Error("[Vuetify] Could not find injected layout");
  const t = e.id ?? `layout-item-${Be()}`, a = fe("useLayoutItem");
  we(Rl, {
    id: t
  });
  const l = z(!1);
  fo(() => l.value = !0), vo(() => l.value = !1);
  const {
    layoutItemStyles: i,
    layoutItemScrimStyles: o
  } = n.register(a, {
    ...e,
    active: h(() => l.value ? !1 : e.active.value),
    id: t
  });
  return Ie(() => n.unregister(t)), {
    layoutItemStyles: i,
    layoutRect: n.layoutRect,
    layoutItemScrimStyles: o
  };
}
const ms = (e, n, t, a) => {
  let l = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const i = [{
    id: "",
    layer: {
      ...l
    }
  }];
  for (const o of e) {
    const s = n.get(o), r = t.get(o), f = a.get(o);
    if (!s || !r || !f)
      continue;
    const v = {
      ...l,
      [s.value]: parseInt(l[s.value], 10) + (f.value ? parseInt(r.value, 10) : 0)
    };
    i.push({
      id: o,
      layer: v
    }), l = v;
  }
  return i;
};
function gs(e) {
  const n = ue(an, null), t = h(() => n ? n.rootZIndex.value - 100 : ja), a = D([]), l = Le(/* @__PURE__ */ new Map()), i = Le(/* @__PURE__ */ new Map()), o = Le(/* @__PURE__ */ new Map()), s = Le(/* @__PURE__ */ new Map()), r = Le(/* @__PURE__ */ new Map()), {
    resizeRef: f,
    contentRect: v
  } = vn(), d = h(() => {
    const x = /* @__PURE__ */ new Map(), S = e.overlaps ?? [];
    for (const P of S.filter((k) => k.includes(":"))) {
      const [k, I] = P.split(":");
      if (!a.value.includes(k) || !a.value.includes(I))
        continue;
      const T = l.get(k), $ = l.get(I), E = i.get(k), L = i.get(I);
      !T || !$ || !E || !L || (x.set(I, {
        position: T.value,
        amount: parseInt(E.value, 10)
      }), x.set(k, {
        position: $.value,
        amount: -parseInt(L.value, 10)
      }));
    }
    return x;
  }), c = h(() => {
    const x = [...new Set([...o.values()].map((P) => P.value))].sort((P, k) => P - k), S = [];
    for (const P of x) {
      const k = a.value.filter((I) => {
        var T;
        return ((T = o.get(I)) == null ? void 0 : T.value) === P;
      });
      S.push(...k);
    }
    return ms(S, l, i, s);
  }), m = h(() => !Array.from(r.values()).some((x) => x.value)), g = h(() => c.value[c.value.length - 1].layer), y = h(() => ({
    "--v-layout-left": j(g.value.left),
    "--v-layout-right": j(g.value.right),
    "--v-layout-top": j(g.value.top),
    "--v-layout-bottom": j(g.value.bottom),
    ...m.value ? void 0 : {
      transition: "none"
    }
  })), b = h(() => c.value.slice(1).map((x, S) => {
    let {
      id: P
    } = x;
    const {
      layer: k
    } = c.value[S], I = i.get(P), T = l.get(P);
    return {
      id: P,
      ...k,
      size: Number(I.value),
      position: T.value
    };
  })), w = (x) => b.value.find((S) => S.id === x), C = fe("createLayout"), V = z(!1);
  He(() => {
    V.value = !0;
  }), we(an, {
    register: (x, S) => {
      let {
        id: P,
        order: k,
        position: I,
        layoutSize: T,
        elementSize: $,
        active: E,
        disableTransitions: L,
        absolute: N
      } = S;
      o.set(P, k), l.set(P, I), i.set(P, T), s.set(P, E), L && r.set(P, L);
      const J = Tt(Rl, C == null ? void 0 : C.vnode).indexOf(x);
      J > -1 ? a.value.splice(J, 0, P) : a.value.push(P);
      const _ = h(() => b.value.findIndex((ee) => ee.id === P)), B = h(() => t.value + c.value.length * 2 - _.value * 2), O = h(() => {
        const ee = I.value === "left" || I.value === "right", R = I.value === "right", Y = I.value === "bottom", te = {
          [I.value]: 0,
          zIndex: B.value,
          transform: `translate${ee ? "X" : "Y"}(${(E.value ? 0 : -110) * (R || Y ? -1 : 1)}%)`,
          position: N.value || t.value !== ja ? "absolute" : "fixed",
          ...m.value ? void 0 : {
            transition: "none"
          }
        };
        if (!V.value)
          return te;
        const U = b.value[_.value];
        if (!U)
          throw new Error(`[Vuetify] Could not find layout item "${P}"`);
        const le = d.value.get(P);
        return le && (U[le.position] += le.amount), {
          ...te,
          height: ee ? `calc(100% - ${U.top}px - ${U.bottom}px)` : $.value ? `${$.value}px` : void 0,
          left: R ? void 0 : `${U.left}px`,
          right: R ? `${U.right}px` : void 0,
          top: I.value !== "bottom" ? `${U.top}px` : void 0,
          bottom: I.value !== "top" ? `${U.bottom}px` : void 0,
          width: ee ? $.value ? `${$.value}px` : void 0 : `calc(100% - ${U.left}px - ${U.right}px)`
        };
      }), G = h(() => ({
        zIndex: B.value - 1
      }));
      return {
        layoutItemStyles: O,
        layoutItemScrimStyles: G,
        zIndex: B
      };
    },
    unregister: (x) => {
      o.delete(x), l.delete(x), i.delete(x), s.delete(x), r.delete(x), a.value = a.value.filter((S) => S !== x);
    },
    mainRect: g,
    mainStyles: y,
    getLayoutItem: w,
    items: b,
    layoutRect: v,
    rootZIndex: t
  });
  const A = h(() => ["v-layout", {
    "v-layout--full-height": e.fullHeight
  }]), p = h(() => ({
    zIndex: n ? t.value : void 0,
    position: n ? "relative" : void 0,
    overflow: n ? "hidden" : void 0
  }));
  return {
    layoutClasses: A,
    layoutStyles: p,
    getLayoutItem: w,
    items: b,
    layoutRect: v,
    layoutRef: f
  };
}
const hs = {
  badge: "Badge",
  open: "Open",
  close: "Close",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "No matching records found",
    loadingText: "Loading items..."
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending."
    },
    sortBy: "Sort by"
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    range: {
      title: "Select dates",
      header: "Enter dates"
    },
    title: "Select date",
    header: "Enter date",
    input: {
      placeholder: "Enter date"
    }
  },
  noDataText: "No data available",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} more",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM"
  },
  pagination: {
    ariaLabel: {
      root: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Go to page {0}",
      currentPage: "Page {0}, Current page",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "Rating {0} of {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  }
}, ys = {
  af: !1,
  ar: !0,
  bg: !1,
  ca: !1,
  ckb: !1,
  cs: !1,
  de: !1,
  el: !1,
  en: !1,
  es: !1,
  et: !1,
  fa: !0,
  fi: !1,
  fr: !1,
  hr: !1,
  hu: !1,
  he: !0,
  id: !1,
  it: !1,
  ja: !1,
  ko: !1,
  lv: !1,
  lt: !1,
  nl: !1,
  no: !1,
  pl: !1,
  pt: !1,
  ro: !1,
  ru: !1,
  sk: !1,
  sl: !1,
  srCyrl: !1,
  srLatn: !1,
  sv: !1,
  th: !1,
  tr: !1,
  az: !1,
  uk: !1,
  vi: !1,
  zhHans: !1,
  zhHant: !1
};
function Ne(e, n) {
  let t;
  function a() {
    t = qn(), t.run(() => n.length ? n(() => {
      t == null || t.stop(), a();
    }) : n());
  }
  H(e, (l) => {
    l && !t ? a() : l || (t == null || t.stop(), t = void 0);
  }, {
    immediate: !0
  }), Ce(() => {
    t == null || t.stop();
  });
}
function oe(e, n, t) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (d) => d, l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (d) => d;
  const i = fe("useProxiedModel"), o = D(e[n] !== void 0 ? e[n] : t), s = it(n), f = s !== n ? h(() => {
    var d, c, m, g;
    return e[n], !!(((d = i.vnode.props) != null && d.hasOwnProperty(n) || (c = i.vnode.props) != null && c.hasOwnProperty(s)) && ((m = i.vnode.props) != null && m.hasOwnProperty(`onUpdate:${n}`) || (g = i.vnode.props) != null && g.hasOwnProperty(`onUpdate:${s}`)));
  }) : h(() => {
    var d, c;
    return e[n], !!((d = i.vnode.props) != null && d.hasOwnProperty(n) && ((c = i.vnode.props) != null && c.hasOwnProperty(`onUpdate:${n}`)));
  });
  Ne(() => !f.value, () => {
    H(() => e[n], (d) => {
      o.value = d;
    });
  });
  const v = h({
    get() {
      const d = e[n];
      return a(f.value ? d : o.value);
    },
    set(d) {
      const c = l(d), m = Ye(f.value ? e[n] : o.value);
      m === c || a(m) === d || (o.value = c, i == null || i.emit(`update:${n}`, c));
    }
  });
  return Object.defineProperty(v, "externalValue", {
    get: () => f.value ? e[n] : o.value
  }), v;
}
const Wa = "$vuetify.", Ga = (e, n) => e.replace(/\{(\d+)\}/g, (t, a) => String(n[+a])), Dl = (e, n, t) => function(a) {
  for (var l = arguments.length, i = new Array(l > 1 ? l - 1 : 0), o = 1; o < l; o++)
    i[o - 1] = arguments[o];
  if (!a.startsWith(Wa))
    return Ga(a, i);
  const s = a.replace(Wa, ""), r = e.value && t.value[e.value], f = n.value && t.value[n.value];
  let v = Tn(r, s, null);
  return v || (st(`Translation key "${a}" not found in "${e.value}", trying fallback locale`), v = Tn(f, s, null)), v || (Ln(`Translation key "${a}" not found in fallback`), v = a), typeof v != "string" && (Ln(`Translation key "${a}" has a non-string value`), v = a), Ga(v, i);
};
function Nl(e, n) {
  return (t, a) => new Intl.NumberFormat([e.value, n.value], a).format(t);
}
function pn(e, n, t) {
  const a = oe(e, n, e[n] ?? t.value);
  return a.value = e[n] ?? t.value, H(t, (l) => {
    e[n] == null && (a.value = t.value);
  }), a;
}
function zl(e) {
  return (n) => {
    const t = pn(n, "locale", e.current), a = pn(n, "fallback", e.fallback), l = pn(n, "messages", e.messages);
    return {
      name: "vuetify",
      current: t,
      fallback: a,
      messages: l,
      t: Dl(t, a, l),
      n: Nl(t, a),
      provide: zl({
        current: t,
        fallback: a,
        messages: l
      })
    };
  };
}
function bs(e) {
  const n = z((e == null ? void 0 : e.locale) ?? "en"), t = z((e == null ? void 0 : e.fallback) ?? "en"), a = D({
    en: hs,
    ...e == null ? void 0 : e.messages
  });
  return {
    name: "vuetify",
    current: n,
    fallback: t,
    messages: a,
    t: Dl(n, t, a),
    n: Nl(n, t),
    provide: zl({
      current: n,
      fallback: t,
      messages: a
    })
  };
}
const ln = Symbol.for("vuetify:locale");
function Ss(e) {
  return e.name != null;
}
function bc(e) {
  const n = e != null && e.adapter && Ss(e == null ? void 0 : e.adapter) ? e == null ? void 0 : e.adapter : bs(e), t = ws(n, e);
  return {
    ...n,
    ...t
  };
}
function mn() {
  const e = ue(ln);
  if (!e)
    throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function Sc(e) {
  const n = ue(ln);
  if (!n)
    throw new Error("[Vuetify] Could not find injected locale instance");
  const t = n.provide(e), a = Cs(t, n.rtl, e), l = {
    ...t,
    ...a
  };
  return we(ln, l), l;
}
function ws(e, n) {
  const t = D((n == null ? void 0 : n.rtl) ?? ys), a = h(() => t.value[e.current.value] ?? !1);
  return {
    isRtl: a,
    rtl: t,
    rtlClasses: h(() => `v-locale--is-${a.value ? "rtl" : "ltr"}`)
  };
}
function Cs(e, n, t) {
  const a = h(() => t.rtl ?? n.value[e.current.value] ?? !1);
  return {
    isRtl: a,
    rtl: n,
    rtlClasses: h(() => `v-locale--is-${a.value ? "rtl" : "ltr"}`)
  };
}
function Ge() {
  const e = ue(ln);
  if (!e)
    throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const Rn = Symbol.for("vuetify:theme"), ve = F({
  theme: String
}, "theme");
function Ua() {
  return {
    defaultTheme: "light",
    variations: {
      colors: [],
      lighten: 0,
      darken: 0
    },
    themes: {
      light: {
        dark: !1,
        colors: {
          background: "#FFFFFF",
          surface: "#FFFFFF",
          "surface-bright": "#FFFFFF",
          "surface-variant": "#424242",
          "on-surface-variant": "#EEEEEE",
          primary: "#1867C0",
          "primary-darken-1": "#1F5592",
          secondary: "#48A9A6",
          "secondary-darken-1": "#018786",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00"
        },
        variables: {
          "border-color": "#000000",
          "border-opacity": 0.12,
          "high-emphasis-opacity": 0.87,
          "medium-emphasis-opacity": 0.6,
          "disabled-opacity": 0.38,
          "idle-opacity": 0.04,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          "activated-opacity": 0.12,
          "pressed-opacity": 0.12,
          "dragged-opacity": 0.08,
          "theme-kbd": "#212529",
          "theme-on-kbd": "#FFFFFF",
          "theme-code": "#F5F5F5",
          "theme-on-code": "#000000"
        }
      },
      dark: {
        dark: !0,
        colors: {
          background: "#121212",
          surface: "#212121",
          "surface-bright": "#ccbfd6",
          "surface-variant": "#a3a3a3",
          "on-surface-variant": "#424242",
          primary: "#2196F3",
          "primary-darken-1": "#277CC1",
          secondary: "#54B6B2",
          "secondary-darken-1": "#48A9A6",
          error: "#CF6679",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00"
        },
        variables: {
          "border-color": "#FFFFFF",
          "border-opacity": 0.12,
          "high-emphasis-opacity": 1,
          "medium-emphasis-opacity": 0.7,
          "disabled-opacity": 0.5,
          "idle-opacity": 0.1,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          "activated-opacity": 0.12,
          "pressed-opacity": 0.16,
          "dragged-opacity": 0.08,
          "theme-kbd": "#212529",
          "theme-on-kbd": "#FFFFFF",
          "theme-code": "#343434",
          "theme-on-code": "#CCCCCC"
        }
      }
    }
  };
}
function xs() {
  var a, l;
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ua();
  const n = Ua();
  if (!e)
    return {
      ...n,
      isDisabled: !0
    };
  const t = {};
  for (const [i, o] of Object.entries(e.themes ?? {})) {
    const s = o.dark || i === "dark" ? (a = n.themes) == null ? void 0 : a.dark : (l = n.themes) == null ? void 0 : l.light;
    t[i] = Me(s, o);
  }
  return Me(n, {
    ...e,
    themes: t
  });
}
function wc(e) {
  const n = xs(e), t = D(n.defaultTheme), a = D(n.themes), l = h(() => {
    const v = {};
    for (const [d, c] of Object.entries(a.value)) {
      const m = v[d] = {
        ...c,
        colors: {
          ...c.colors
        }
      };
      if (n.variations)
        for (const g of n.variations.colors) {
          const y = m.colors[g];
          if (y)
            for (const b of ["lighten", "darken"]) {
              const w = b === "lighten" ? ts : ns;
              for (const C of Vo(n.variations[b], 1))
                m.colors[`${g}-${b}-${C}`] = El(w(Re(y), C));
            }
        }
      for (const g of Object.keys(m.colors)) {
        if (/^on-[a-z]/.test(g) || m.colors[`on-${g}`])
          continue;
        const y = `on-${g}`, b = Re(m.colors[g]);
        m.colors[y] = $l(b);
      }
    }
    return v;
  }), i = h(() => l.value[t.value]), o = h(() => {
    const v = [];
    i.value.dark && at(v, ":root", ["color-scheme: dark"]), at(v, ":root", Ka(i.value));
    for (const [g, y] of Object.entries(l.value))
      at(v, `.v-theme--${g}`, [`color-scheme: ${y.dark ? "dark" : "normal"}`, ...Ka(y)]);
    const d = [], c = [], m = new Set(Object.values(l.value).flatMap((g) => Object.keys(g.colors)));
    for (const g of m)
      /^on-[a-z]/.test(g) ? at(c, `.${g}`, [`color: rgb(var(--v-theme-${g})) !important`]) : (at(d, `.bg-${g}`, [`--v-theme-overlay-multiplier: var(--v-theme-${g}-overlay-multiplier)`, `background-color: rgb(var(--v-theme-${g})) !important`, `color: rgb(var(--v-theme-on-${g})) !important`]), at(c, `.text-${g}`, [`color: rgb(var(--v-theme-${g})) !important`]), at(c, `.border-${g}`, [`--v-border-color: var(--v-theme-${g})`]));
    return v.push(...d, ...c), v.map((g, y) => y === 0 ? g : `    ${g}`).join("");
  });
  function s() {
    return {
      style: [{
        children: o.value,
        id: "vuetify-theme-stylesheet",
        nonce: n.cspNonce || !1
      }]
    };
  }
  function r(v) {
    if (n.isDisabled)
      return;
    const d = v._context.provides.usehead;
    if (d)
      if (d.push) {
        const c = d.push(s);
        se && H(o, () => {
          c.patch(s);
        });
      } else
        se ? (d.addHeadObjs(h(s)), Te(() => d.updateDOM())) : d.addHeadObjs(s());
    else {
      let m = function() {
        if (typeof document < "u" && !c) {
          const g = document.createElement("style");
          g.type = "text/css", g.id = "vuetify-theme-stylesheet", n.cspNonce && g.setAttribute("nonce", n.cspNonce), c = g, document.head.appendChild(c);
        }
        c && (c.innerHTML = o.value);
      }, c = se ? document.getElementById("vuetify-theme-stylesheet") : null;
      se ? H(o, m, {
        immediate: !0
      }) : m();
    }
  }
  const f = h(() => n.isDisabled ? void 0 : `v-theme--${t.value}`);
  return {
    install: r,
    isDisabled: n.isDisabled,
    name: t,
    themes: a,
    current: i,
    computedThemes: l,
    themeClasses: f,
    styles: o,
    global: {
      name: t,
      current: i
    }
  };
}
function be(e) {
  fe("provideTheme");
  const n = ue(Rn, null);
  if (!n)
    throw new Error("Could not find Vuetify theme injection");
  const t = h(() => e.theme ?? n.name.value), a = h(() => n.themes.value[t.value]), l = h(() => n.isDisabled ? void 0 : `v-theme--${t.value}`), i = {
    ...n,
    name: t,
    current: a,
    themeClasses: l
  };
  return we(Rn, i), i;
}
function Cc() {
  fe("useTheme");
  const e = ue(Rn, null);
  if (!e)
    throw new Error("Could not find Vuetify theme injection");
  return e;
}
function at(e, n, t) {
  e.push(`${n} {
`, ...t.map((a) => `  ${a};
`), `}
`);
}
function Ka(e) {
  const n = e.dark ? 2 : 1, t = e.dark ? 1 : 2, a = [];
  for (const [l, i] of Object.entries(e.colors)) {
    const o = Re(i);
    a.push(`--v-theme-${l}: ${o.r},${o.g},${o.b}`), l.startsWith("on-") || a.push(`--v-theme-${l}-overlay-multiplier: ${Mn(i) > 0.18 ? n : t}`);
  }
  for (const [l, i] of Object.entries(e.variables)) {
    const o = typeof i == "string" && i.startsWith("#") ? Re(i) : void 0, s = o ? `${o.r}, ${o.g}, ${o.b}` : void 0;
    a.push(`--v-${l}: ${s ?? i}`);
  }
  return a;
}
const ps = F({
  ...ne(),
  ...cs({
    fullHeight: !0
  }),
  ...ve()
}, "VApp"), xc = W()({
  name: "VApp",
  props: ps(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = be(e), {
      layoutClasses: l,
      getLayoutItem: i,
      items: o,
      layoutRef: s
    } = gs(e), {
      rtlClasses: r
    } = Ge();
    return Z(() => {
      var f;
      return u("div", {
        ref: s,
        class: ["v-application", a.themeClasses.value, l.value, r.value, e.class],
        style: [e.style]
      }, [u("div", {
        class: "v-application__wrap"
      }, [(f = t.default) == null ? void 0 : f.call(t)])]);
    }), {
      getLayoutItem: i,
      items: o,
      theme: a
    };
  }
});
const ge = F({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), ks = F({
  text: String,
  ...ne(),
  ...ge()
}, "VToolbarTitle"), Vs = W()({
  name: "VToolbarTitle",
  props: ks(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return Z(() => {
      const a = !!(t.default || t.text || e.text);
      return u(e.tag, {
        class: ["v-toolbar-title", e.class],
        style: e.style
      }, {
        default: () => {
          var l;
          return [a && u("div", {
            class: "v-toolbar-title__placeholder"
          }, [t.text ? t.text() : e.text, (l = t.default) == null ? void 0 : l.call(t)])];
        }
      });
    }), {};
  }
}), Ps = F({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function _e(e, n, t) {
  return W()({
    name: e,
    props: Ps({
      mode: t,
      origin: n
    }),
    setup(a, l) {
      let {
        slots: i
      } = l;
      const o = {
        onBeforeEnter(s) {
          a.origin && (s.style.transformOrigin = a.origin);
        },
        onLeave(s) {
          if (a.leaveAbsolute) {
            const {
              offsetTop: r,
              offsetLeft: f,
              offsetWidth: v,
              offsetHeight: d
            } = s;
            s._transitionInitialStyles = {
              position: s.style.position,
              top: s.style.top,
              left: s.style.left,
              width: s.style.width,
              height: s.style.height
            }, s.style.position = "absolute", s.style.top = `${r}px`, s.style.left = `${f}px`, s.style.width = `${v}px`, s.style.height = `${d}px`;
          }
          a.hideOnLeave && s.style.setProperty("display", "none", "important");
        },
        onAfterLeave(s) {
          if (a.leaveAbsolute && (s != null && s._transitionInitialStyles)) {
            const {
              position: r,
              top: f,
              left: v,
              width: d,
              height: c
            } = s._transitionInitialStyles;
            delete s._transitionInitialStyles, s.style.position = r || "", s.style.top = f || "", s.style.left = v || "", s.style.width = d || "", s.style.height = c || "";
          }
        }
      };
      return () => {
        const s = a.group ? mo : Ke;
        return xt(s, {
          name: a.disabled ? "" : e,
          css: !a.disabled,
          ...a.group ? void 0 : {
            mode: a.mode
          },
          ...a.disabled ? {} : o
        }, i.default);
      };
    }
  });
}
function Hl(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return W()({
    name: e,
    props: {
      mode: {
        type: String,
        default: t
      },
      disabled: Boolean
    },
    setup(a, l) {
      let {
        slots: i
      } = l;
      return () => xt(Ke, {
        name: a.disabled ? "" : e,
        css: !a.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...a.disabled ? {} : n
      }, i.default);
    }
  });
}
function jl() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const t = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", a = gl(`offset-${t}`);
  return {
    onBeforeEnter(o) {
      o._parent = o.parentNode, o._initialStyle = {
        transition: o.style.transition,
        overflow: o.style.overflow,
        [t]: o.style[t]
      };
    },
    onEnter(o) {
      const s = o._initialStyle;
      o.style.setProperty("transition", "none", "important"), o.style.overflow = "hidden";
      const r = `${o[a]}px`;
      o.style[t] = "0", o.offsetHeight, o.style.transition = s.transition, e && o._parent && o._parent.classList.add(e), requestAnimationFrame(() => {
        o.style[t] = r;
      });
    },
    onAfterEnter: i,
    onEnterCancelled: i,
    onLeave(o) {
      o._initialStyle = {
        transition: "",
        overflow: o.style.overflow,
        [t]: o.style[t]
      }, o.style.overflow = "hidden", o.style[t] = `${o[a]}px`, o.offsetHeight, requestAnimationFrame(() => o.style[t] = "0");
    },
    onAfterLeave: l,
    onLeaveCancelled: l
  };
  function l(o) {
    e && o._parent && o._parent.classList.remove(e), i(o);
  }
  function i(o) {
    const s = o._initialStyle[t];
    o.style.overflow = o._initialStyle.overflow, s != null && (o.style[t] = s), delete o._initialStyle;
  }
}
const Is = F({
  target: [Object, Array]
}, "v-dialog-transition"), Wl = W()({
  name: "VDialogTransition",
  props: Is(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = {
      onBeforeEnter(l) {
        l.style.pointerEvents = "none", l.style.visibility = "hidden";
      },
      async onEnter(l, i) {
        var c;
        await new Promise((m) => requestAnimationFrame(m)), await new Promise((m) => requestAnimationFrame(m)), l.style.visibility = "";
        const {
          x: o,
          y: s,
          sx: r,
          sy: f,
          speed: v
        } = qa(e.target, l), d = yt(l, [{
          transform: `translate(${o}px, ${s}px) scale(${r}, ${f})`,
          opacity: 0
        }, {}], {
          duration: 225 * v,
          easing: is
        });
        (c = Ya(l)) == null || c.forEach((m) => {
          yt(m, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * v,
            easing: tn
          });
        }), d.finished.then(() => i());
      },
      onAfterEnter(l) {
        l.style.removeProperty("pointer-events");
      },
      onBeforeLeave(l) {
        l.style.pointerEvents = "none";
      },
      async onLeave(l, i) {
        var c;
        await new Promise((m) => requestAnimationFrame(m));
        const {
          x: o,
          y: s,
          sx: r,
          sy: f,
          speed: v
        } = qa(e.target, l);
        yt(l, [{}, {
          transform: `translate(${o}px, ${s}px) scale(${r}, ${f})`,
          opacity: 0
        }], {
          duration: 125 * v,
          easing: os
        }).finished.then(() => i()), (c = Ya(l)) == null || c.forEach((m) => {
          yt(m, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * v,
            easing: tn
          });
        });
      },
      onAfterLeave(l) {
        l.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? u(Ke, q({
      name: "dialog-transition"
    }, a, {
      css: !1
    }), t) : u(Ke, {
      name: "dialog-transition"
    }, t);
  }
});
function Ya(e) {
  var t;
  const n = (t = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")) == null ? void 0 : t.children;
  return n && [...n];
}
function qa(e, n) {
  const t = Pl(e), a = ta(n), [l, i] = getComputedStyle(n).transformOrigin.split(" ").map((w) => parseFloat(w)), [o, s] = getComputedStyle(n).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let r = t.left + t.width / 2;
  o === "left" || s === "left" ? r -= t.width / 2 : (o === "right" || s === "right") && (r += t.width / 2);
  let f = t.top + t.height / 2;
  o === "top" || s === "top" ? f -= t.height / 2 : (o === "bottom" || s === "bottom") && (f += t.height / 2);
  const v = t.width / a.width, d = t.height / a.height, c = Math.max(1, v, d), m = v / c || 0, g = d / c || 0, y = a.width * a.height / (window.innerWidth * window.innerHeight), b = y > 0.12 ? Math.min(1.5, (y - 0.12) * 10 + 1) : 1;
  return {
    x: r - (l + a.left),
    y: f - (i + a.top),
    sx: m,
    sy: g,
    speed: b
  };
}
const pc = _e("fab-transition", "center center", "out-in"), kc = _e("dialog-bottom-transition"), Vc = _e("dialog-top-transition"), Pc = _e("fade-transition"), _s = _e("scale-transition"), Ic = _e("scroll-x-transition"), _c = _e("scroll-x-reverse-transition"), Ac = _e("scroll-y-transition"), Tc = _e("scroll-y-reverse-transition"), Ec = _e("slide-x-transition"), Bc = _e("slide-x-reverse-transition"), Gl = _e("slide-y-transition"), $c = _e("slide-y-reverse-transition"), Ul = Hl("expand-transition", jl()), Kl = Hl("expand-x-transition", jl("", !0)), As = F({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), he = W(!1)({
  name: "VDefaultsProvider",
  props: As(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      defaults: a,
      disabled: l,
      reset: i,
      root: o,
      scoped: s
    } = Un(e);
    return ut(a, {
      reset: i,
      root: o,
      scoped: s,
      disabled: l
    }), () => {
      var r;
      return (r = t.default) == null ? void 0 : r.call(t);
    };
  }
});
const Vt = F({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function Pt(e) {
  return {
    dimensionStyles: h(() => ({
      height: j(e.height),
      maxHeight: j(e.maxHeight),
      maxWidth: j(e.maxWidth),
      minHeight: j(e.minHeight),
      minWidth: j(e.minWidth),
      width: j(e.width)
    }))
  };
}
function Ts(e) {
  return {
    aspectStyles: h(() => {
      const n = Number(e.aspectRatio);
      return n ? {
        paddingBottom: String(1 / n * 100) + "%"
      } : void 0;
    })
  };
}
const Yl = F({
  aspectRatio: [String, Number],
  contentClass: String,
  inline: Boolean,
  ...ne(),
  ...Vt()
}, "VResponsive"), Xa = W()({
  name: "VResponsive",
  props: Yl(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      aspectStyles: a
    } = Ts(e), {
      dimensionStyles: l
    } = Pt(e);
    return Z(() => {
      var i;
      return u("div", {
        class: ["v-responsive", {
          "v-responsive--inline": e.inline
        }, e.class],
        style: [l.value, e.style]
      }, [u("div", {
        class: "v-responsive__sizer",
        style: a.value
      }, null), (i = t.additional) == null ? void 0 : i.call(t), t.default && u("div", {
        class: ["v-responsive__content", e.contentClass]
      }, [t.default()])]);
    }), {};
  }
}), It = F({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), Ue = (e, n) => {
  let {
    slots: t
  } = n;
  const {
    transition: a,
    disabled: l,
    ...i
  } = e, {
    component: o = Ke,
    ...s
  } = typeof a == "object" ? a : {};
  return xt(o, q(typeof a == "string" ? {
    name: l ? "" : a
  } : s, i, {
    disabled: l
  }), t);
};
function Es(e, n) {
  if (!Zn)
    return;
  const t = n.modifiers || {}, a = n.value, {
    handler: l,
    options: i
  } = typeof a == "object" ? a : {
    handler: a,
    options: {}
  }, o = new IntersectionObserver(function() {
    var d;
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 ? arguments[1] : void 0;
    const f = (d = e._observe) == null ? void 0 : d[n.instance.$.uid];
    if (!f)
      return;
    const v = s.some((c) => c.isIntersecting);
    l && (!t.quiet || f.init) && (!t.once || v || f.init) && l(v, s, r), v && t.once ? ql(e, n) : f.init = !0;
  }, i);
  e._observe = Object(e._observe), e._observe[n.instance.$.uid] = {
    init: !1,
    observer: o
  }, o.observe(e);
}
function ql(e, n) {
  var a;
  const t = (a = e._observe) == null ? void 0 : a[n.instance.$.uid];
  t && (t.observer.unobserve(e), delete e._observe[n.instance.$.uid]);
}
const ia = {
  mounted: Es,
  unmounted: ql
}, Bs = F({
  alt: String,
  cover: Boolean,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...Yl(),
  ...ne(),
  ...It()
}, "VImg"), Xl = W()({
  name: "VImg",
  directives: {
    intersect: ia
  },
  props: Bs(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, n) {
    let {
      emit: t,
      slots: a
    } = n;
    const l = fe("VImg"), i = z(""), o = D(), s = z(e.eager ? "loading" : "idle"), r = z(), f = z(), v = h(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), d = h(() => v.value.aspect || r.value / f.value || 0);
    H(() => e.src, () => {
      c(s.value !== "idle");
    }), H(d, (k, I) => {
      !k && I && o.value && w(o.value);
    }), Xn(() => c());
    function c(k) {
      if (!(e.eager && k) && !(Zn && !k && !e.eager)) {
        if (s.value = "loading", v.value.lazySrc) {
          const I = new Image();
          I.src = v.value.lazySrc, w(I, null);
        }
        v.value.src && de(() => {
          var I;
          t("loadstart", ((I = o.value) == null ? void 0 : I.currentSrc) || v.value.src), setTimeout(() => {
            var T;
            if (!l.isUnmounted)
              if ((T = o.value) != null && T.complete) {
                if (o.value.naturalWidth || g(), s.value === "error")
                  return;
                d.value || w(o.value, null), s.value === "loading" && m();
              } else
                d.value || w(o.value), y();
          });
        });
      }
    }
    function m() {
      var k;
      l.isUnmounted || (y(), w(o.value), s.value = "loaded", t("load", ((k = o.value) == null ? void 0 : k.currentSrc) || v.value.src));
    }
    function g() {
      var k;
      l.isUnmounted || (s.value = "error", t("error", ((k = o.value) == null ? void 0 : k.currentSrc) || v.value.src));
    }
    function y() {
      const k = o.value;
      k && (i.value = k.currentSrc || k.src);
    }
    let b = -1;
    Ie(() => {
      clearTimeout(b);
    });
    function w(k) {
      let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const T = () => {
        if (clearTimeout(b), l.isUnmounted)
          return;
        const {
          naturalHeight: $,
          naturalWidth: E
        } = k;
        $ || E ? (r.value = E, f.value = $) : !k.complete && s.value === "loading" && I != null ? b = window.setTimeout(T, I) : (k.currentSrc.endsWith(".svg") || k.currentSrc.startsWith("data:image/svg+xml")) && (r.value = 1, f.value = 1);
      };
      T();
    }
    const C = h(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), V = () => {
      var T;
      if (!v.value.src || s.value === "idle")
        return null;
      const k = u("img", {
        class: ["v-img__img", C.value],
        style: {
          objectPosition: e.position
        },
        src: v.value.src,
        srcset: v.value.srcset,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: o,
        onLoad: m,
        onError: g
      }, null), I = (T = a.sources) == null ? void 0 : T.call(a);
      return u(Ue, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [Ve(I ? u("picture", {
          class: "v-img__picture"
        }, [I, k]) : k, [[pt, s.value === "loaded"]])]
      });
    }, A = () => u(Ue, {
      transition: e.transition
    }, {
      default: () => [v.value.lazySrc && s.value !== "loaded" && u("img", {
        class: ["v-img__img", "v-img__img--preload", C.value],
        style: {
          objectPosition: e.position
        },
        src: v.value.lazySrc,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), p = () => a.placeholder ? u(Ue, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(s.value === "loading" || s.value === "error" && !a.error) && u("div", {
        class: "v-img__placeholder"
      }, [a.placeholder()])]
    }) : null, x = () => a.error ? u(Ue, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [s.value === "error" && u("div", {
        class: "v-img__error"
      }, [a.error()])]
    }) : null, S = () => e.gradient ? u("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, P = z(!1);
    {
      const k = H(d, (I) => {
        I && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            P.value = !0;
          });
        }), k());
      });
    }
    return Z(() => {
      const k = Xa.filterProps(e);
      return Ve(u(Xa, q({
        class: ["v-img", {
          "v-img--booting": !P.value
        }, e.class],
        style: [{
          width: j(e.width === "auto" ? r.value : e.width)
        }, e.style]
      }, k, {
        aspectRatio: d.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => u(ie, null, [u(V, null, null), u(A, null, null), u(S, null, null), u(p, null, null), u(x, null, null)]),
        default: a.default
      }), [[qe("intersect"), {
        handler: c,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: i,
      image: o,
      state: s,
      naturalWidth: r,
      naturalHeight: f
    };
  }
}), ct = F({
  border: [Boolean, Number, String]
}, "border");
function dt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  return {
    borderClasses: h(() => {
      const a = Lt(e) ? e.value : e.border, l = [];
      if (a === !0 || a === "")
        l.push(`${n}--border`);
      else if (typeof a == "string" || a === 0)
        for (const i of String(a).split(" "))
          l.push(`border-${i}`);
      return l;
    })
  };
}
function oa(e) {
  return Qn(() => {
    const n = [], t = {};
    if (e.value.background)
      if (On(e.value.background)) {
        if (t.backgroundColor = e.value.background, !e.value.text && Xo(e.value.background)) {
          const a = Re(e.value.background);
          if (a.a == null || a.a === 1) {
            const l = $l(a);
            t.color = l, t.caretColor = l;
          }
        }
      } else
        n.push(`bg-${e.value.background}`);
    return e.value.text && (On(e.value.text) ? (t.color = e.value.text, t.caretColor = e.value.text) : n.push(`text-${e.value.text}`)), {
      colorClasses: n,
      colorStyles: t
    };
  });
}
function ze(e, n) {
  const t = h(() => ({
    text: Lt(e) ? e.value : n ? e[n] : null
  })), {
    colorClasses: a,
    colorStyles: l
  } = oa(t);
  return {
    textColorClasses: a,
    textColorStyles: l
  };
}
function We(e, n) {
  const t = h(() => ({
    background: Lt(e) ? e.value : n ? e[n] : null
  })), {
    colorClasses: a,
    colorStyles: l
  } = oa(t);
  return {
    backgroundColorClasses: a,
    backgroundColorStyles: l
  };
}
const ft = F({
  elevation: {
    type: [Number, String],
    validator(e) {
      const n = parseInt(e);
      return !isNaN(n) && n >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      n <= 24;
    }
  }
}, "elevation");
function vt(e) {
  return {
    elevationClasses: h(() => {
      const t = Lt(e) ? e.value : e.elevation, a = [];
      return t == null || a.push(`elevation-${t}`), a;
    })
  };
}
const $e = F({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  }
}, "rounded");
function Fe(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  return {
    roundedClasses: h(() => {
      const a = Lt(e) ? e.value : e.rounded, l = [];
      if (a === !0 || a === "")
        l.push(`${n}--rounded`);
      else if (typeof a == "string" || a === 0)
        for (const i of String(a).split(" "))
          l.push(`rounded-${i}`);
      return l;
    })
  };
}
const $s = [null, "prominent", "default", "comfortable", "compact"], Fs = F({
  absolute: Boolean,
  collapse: Boolean,
  color: String,
  density: {
    type: String,
    default: "default",
    validator: (e) => $s.includes(e)
  },
  extended: Boolean,
  extensionHeight: {
    type: [Number, String],
    default: 48
  },
  flat: Boolean,
  floating: Boolean,
  height: {
    type: [Number, String],
    default: 64
  },
  image: String,
  title: String,
  ...ct(),
  ...ne(),
  ...ft(),
  ...$e(),
  ...ge({
    tag: "header"
  }),
  ...ve()
}, "VToolbar"), Fc = W()({
  name: "VToolbar",
  props: Fs(),
  setup(e, n) {
    var m;
    let {
      slots: t
    } = n;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: l
    } = We(K(e, "color")), {
      borderClasses: i
    } = dt(e), {
      elevationClasses: o
    } = vt(e), {
      roundedClasses: s
    } = Fe(e), {
      themeClasses: r
    } = be(e), {
      rtlClasses: f
    } = Ge(), v = z(!!(e.extended || (m = t.extension) != null && m.call(t))), d = h(() => parseInt(Number(e.height) + (e.density === "prominent" ? Number(e.height) : 0) - (e.density === "comfortable" ? 8 : 0) - (e.density === "compact" ? 16 : 0), 10)), c = h(() => v.value ? parseInt(Number(e.extensionHeight) + (e.density === "prominent" ? Number(e.extensionHeight) : 0) - (e.density === "comfortable" ? 4 : 0) - (e.density === "compact" ? 8 : 0), 10) : 0);
    return ut({
      VBtn: {
        variant: "text"
      }
    }), Z(() => {
      var w;
      const g = !!(e.title || t.title), y = !!(t.image || e.image), b = (w = t.extension) == null ? void 0 : w.call(t);
      return v.value = !!(e.extended || b), u(e.tag, {
        class: ["v-toolbar", {
          "v-toolbar--absolute": e.absolute,
          "v-toolbar--collapse": e.collapse,
          "v-toolbar--flat": e.flat,
          "v-toolbar--floating": e.floating,
          [`v-toolbar--density-${e.density}`]: !0
        }, a.value, i.value, o.value, s.value, r.value, f.value, e.class],
        style: [l.value, e.style]
      }, {
        default: () => [y && u("div", {
          key: "image",
          class: "v-toolbar__image"
        }, [t.image ? u(he, {
          key: "image-defaults",
          disabled: !e.image,
          defaults: {
            VImg: {
              cover: !0,
              src: e.image
            }
          }
        }, t.image) : u(Xl, {
          key: "image-img",
          cover: !0,
          src: e.image
        }, null)]), u(he, {
          defaults: {
            VTabs: {
              height: j(d.value)
            }
          }
        }, {
          default: () => {
            var C, V, A;
            return [u("div", {
              class: "v-toolbar__content",
              style: {
                height: j(d.value)
              }
            }, [t.prepend && u("div", {
              class: "v-toolbar__prepend"
            }, [(C = t.prepend) == null ? void 0 : C.call(t)]), g && u(Vs, {
              key: "title",
              text: e.title
            }, {
              text: t.title
            }), (V = t.default) == null ? void 0 : V.call(t), t.append && u("div", {
              class: "v-toolbar__append"
            }, [(A = t.append) == null ? void 0 : A.call(t)])])];
          }
        }), u(he, {
          defaults: {
            VTabs: {
              height: j(c.value)
            }
          }
        }, {
          default: () => [u(Ul, null, {
            default: () => [v.value && u("div", {
              class: "v-toolbar__extension",
              style: {
                height: j(c.value)
              }
            }, [b])]
          })]
        })]
      });
    }), {
      contentHeight: d,
      extensionHeight: c
    };
  }
});
function sa() {
  const e = z(!1);
  return He(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: h(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: Yn(e)
  };
}
const Ls = [null, "default", "comfortable", "compact"], Ze = F({
  density: {
    type: String,
    default: "default",
    validator: (e) => Ls.includes(e)
  }
}, "density");
function Je(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  return {
    densityClasses: h(() => `${n}--density-${e.density}`)
  };
}
const Os = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function Mt(e, n) {
  return u(ie, null, [e && u("span", {
    key: "overlay",
    class: `${n}__overlay`
  }, null), u("span", {
    key: "underlay",
    class: `${n}__underlay`
  }, null)]);
}
const Qe = F({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => Os.includes(e)
  }
}, "variant");
function Rt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  const t = h(() => {
    const {
      variant: i
    } = ke(e);
    return `${n}--variant-${i}`;
  }), {
    colorClasses: a,
    colorStyles: l
  } = oa(h(() => {
    const {
      variant: i,
      color: o
    } = ke(e);
    return {
      [["elevated", "flat"].includes(i) ? "background" : "text"]: o
    };
  }));
  return {
    colorClasses: a,
    colorStyles: l,
    variantClasses: t
  };
}
const Zl = F({
  divided: Boolean,
  ...ct(),
  ...ne(),
  ...Ze(),
  ...ft(),
  ...$e(),
  ...ge(),
  ...ve(),
  ...Qe()
}, "VBtnGroup"), Za = W()({
  name: "VBtnGroup",
  props: Zl(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      themeClasses: a
    } = be(e), {
      densityClasses: l
    } = Je(e), {
      borderClasses: i
    } = dt(e), {
      elevationClasses: o
    } = vt(e), {
      roundedClasses: s
    } = Fe(e);
    ut({
      VBtn: {
        height: "auto",
        color: K(e, "color"),
        density: K(e, "density"),
        flat: !0,
        variant: K(e, "variant")
      }
    }), Z(() => u(e.tag, {
      class: ["v-btn-group", {
        "v-btn-group--divided": e.divided
      }, a.value, i.value, l.value, o.value, s.value, e.class],
      style: e.style
    }, t));
  }
}), Jl = F({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), Ql = F({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function ei(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const a = fe("useGroupItem");
  if (!a)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const l = Be();
  we(Symbol.for(`${n.description}:id`), l);
  const i = ue(n, null);
  if (!i) {
    if (!t)
      return i;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${n.description}`);
  }
  const o = K(e, "value"), s = h(() => !!(i.disabled.value || e.disabled));
  i.register({
    id: l,
    value: o,
    disabled: s
  }, a), Ie(() => {
    i.unregister(l);
  });
  const r = h(() => i.isSelected(l)), f = h(() => r.value && [i.selectedClass.value, e.selectedClass]);
  return H(r, (v) => {
    a.emit("group:selected", {
      value: v
    });
  }), {
    id: l,
    isSelected: r,
    toggle: () => i.select(l, !r.value),
    select: (v) => i.select(l, v),
    selectedClass: f,
    value: o,
    disabled: s,
    group: i
  };
}
function ti(e, n) {
  let t = !1;
  const a = Le([]), l = oe(e, "modelValue", [], (c) => c == null ? [] : ni(a, Ae(c)), (c) => {
    const m = Rs(a, c);
    return e.multiple ? m : m[0];
  }), i = fe("useGroup");
  function o(c, m) {
    const g = c, y = Symbol.for(`${n.description}:id`), w = Tt(y, i == null ? void 0 : i.vnode).indexOf(m);
    w > -1 ? a.splice(w, 0, g) : a.push(g);
  }
  function s(c) {
    if (t)
      return;
    r();
    const m = a.findIndex((g) => g.id === c);
    a.splice(m, 1);
  }
  function r() {
    const c = a.find((m) => !m.disabled);
    c && e.mandatory === "force" && !l.value.length && (l.value = [c.id]);
  }
  He(() => {
    r();
  }), Ie(() => {
    t = !0;
  });
  function f(c, m) {
    const g = a.find((y) => y.id === c);
    if (!(m && (g != null && g.disabled)))
      if (e.multiple) {
        const y = l.value.slice(), b = y.findIndex((C) => C === c), w = ~b;
        if (m = m ?? !w, w && e.mandatory && y.length <= 1 || !w && e.max != null && y.length + 1 > e.max)
          return;
        b < 0 && m ? y.push(c) : b >= 0 && !m && y.splice(b, 1), l.value = y;
      } else {
        const y = l.value.includes(c);
        if (e.mandatory && y)
          return;
        l.value = m ?? !y ? [c] : [];
      }
  }
  function v(c) {
    if (e.multiple && st('This method is not supported when using "multiple" prop'), l.value.length) {
      const m = l.value[0], g = a.findIndex((w) => w.id === m);
      let y = (g + c) % a.length, b = a[y];
      for (; b.disabled && y !== g; )
        y = (y + c) % a.length, b = a[y];
      if (b.disabled)
        return;
      l.value = [a[y].id];
    } else {
      const m = a.find((g) => !g.disabled);
      m && (l.value = [m.id]);
    }
  }
  const d = {
    register: o,
    unregister: s,
    selected: l,
    select: f,
    disabled: K(e, "disabled"),
    prev: () => v(a.length - 1),
    next: () => v(1),
    isSelected: (c) => l.value.includes(c),
    selectedClass: h(() => e.selectedClass),
    items: h(() => a),
    getItemIndex: (c) => Ms(a, c)
  };
  return we(n, d), d;
}
function Ms(e, n) {
  const t = ni(e, [n]);
  return t.length ? e.findIndex((a) => a.id === t[0]) : -1;
}
function ni(e, n) {
  const t = [];
  return n.forEach((a) => {
    const l = e.find((o) => kt(a, o.value)), i = e[a];
    (l == null ? void 0 : l.value) != null ? t.push(l.id) : i != null && t.push(i.id);
  }), t;
}
function Rs(e, n) {
  const t = [];
  return n.forEach((a) => {
    const l = e.findIndex((i) => i.id === a);
    if (~l) {
      const i = e[l];
      t.push(i.value != null ? i.value : l);
    }
  }), t;
}
const ai = Symbol.for("vuetify:v-btn-toggle"), Ds = F({
  ...Zl(),
  ...Jl()
}, "VBtnToggle"), Lc = W()({
  name: "VBtnToggle",
  props: Ds(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      isSelected: a,
      next: l,
      prev: i,
      select: o,
      selected: s
    } = ti(e, ai);
    return Z(() => {
      const r = Za.filterProps(e);
      return u(Za, q({
        class: ["v-btn-toggle", e.class]
      }, r, {
        style: e.style
      }), {
        default: () => {
          var f;
          return [(f = t.default) == null ? void 0 : f.call(t, {
            isSelected: a,
            next: l,
            prev: i,
            select: o,
            selected: s
          })];
        }
      });
    }), {
      next: l,
      prev: i,
      select: o
    };
  }
});
const Ns = {
  collapse: "mdi-chevron-up",
  complete: "mdi-check",
  cancel: "mdi-close-circle",
  close: "mdi-close",
  delete: "mdi-close-circle",
  // delete (e.g. v-chip close)
  clear: "mdi-close-circle",
  success: "mdi-check-circle",
  info: "mdi-information",
  warning: "mdi-alert-circle",
  error: "mdi-close-circle",
  prev: "mdi-chevron-left",
  next: "mdi-chevron-right",
  checkboxOn: "mdi-checkbox-marked",
  checkboxOff: "mdi-checkbox-blank-outline",
  checkboxIndeterminate: "mdi-minus-box",
  delimiter: "mdi-circle",
  // for carousel
  sortAsc: "mdi-arrow-up",
  sortDesc: "mdi-arrow-down",
  expand: "mdi-chevron-down",
  menu: "mdi-menu",
  subgroup: "mdi-menu-down",
  dropdown: "mdi-menu-down",
  radioOn: "mdi-radiobox-marked",
  radioOff: "mdi-radiobox-blank",
  edit: "mdi-pencil",
  ratingEmpty: "mdi-star-outline",
  ratingFull: "mdi-star",
  ratingHalf: "mdi-star-half-full",
  loading: "mdi-cached",
  first: "mdi-page-first",
  last: "mdi-page-last",
  unfold: "mdi-unfold-more-horizontal",
  file: "mdi-paperclip",
  plus: "mdi-plus",
  minus: "mdi-minus",
  calendar: "mdi-calendar",
  eyeDropper: "mdi-eyedropper"
}, zs = {
  // Not using mergeProps here, functional components merge props by default (?)
  component: (e) => xt(ii, {
    ...e,
    class: "mdi"
  })
}, re = [String, Function, Object, Array], Hs = Symbol.for("vuetify:icons"), gn = F({
  icon: {
    type: re
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), Ja = W()({
  name: "VComponentIcon",
  props: gn(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return () => {
      const a = e.icon;
      return u(e.tag, null, {
        default: () => {
          var l;
          return [e.icon ? u(a, null, null) : (l = t.default) == null ? void 0 : l.call(t)];
        }
      });
    };
  }
}), li = Ot({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: gn(),
  setup(e, n) {
    let {
      attrs: t
    } = n;
    return () => u(e.tag, q(t, {
      style: null
    }), {
      default: () => [u("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((a) => Array.isArray(a) ? u("path", {
        d: a[0],
        "fill-opacity": a[1]
      }, null) : u("path", {
        d: a
      }, null)) : u("path", {
        d: e.icon
      }, null)])]
    });
  }
}), Oc = Ot({
  name: "VLigatureIcon",
  props: gn(),
  setup(e) {
    return () => u(e.tag, null, {
      default: () => [e.icon]
    });
  }
}), ii = Ot({
  name: "VClassIcon",
  props: gn(),
  setup(e) {
    return () => u(e.tag, {
      class: e.icon
    }, null);
  }
}), js = {
  svg: {
    component: li
  },
  class: {
    component: ii
  }
};
function Mc(e) {
  return Me({
    defaultSet: "mdi",
    sets: {
      ...js,
      mdi: zs
    },
    aliases: {
      ...Ns,
      /* eslint-disable max-len */
      vuetify: ["M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z", ["M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z", 0.6]],
      "vuetify-outline": "svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z"
      /* eslint-enable max-len */
    }
  }, e);
}
const Ws = (e) => {
  const n = ue(Hs);
  if (!n)
    throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: h(() => {
      var r;
      const a = ke(e);
      if (!a)
        return {
          component: Ja
        };
      let l = a;
      if (typeof l == "string" && (l = l.trim(), l.startsWith("$") && (l = (r = n.aliases) == null ? void 0 : r[l.slice(1)])), !l)
        throw new Error(`Could not find aliased icon "${a}"`);
      if (Array.isArray(l))
        return {
          component: li,
          icon: l
        };
      if (typeof l != "string")
        return {
          component: Ja,
          icon: l
        };
      const i = Object.keys(n.sets).find((f) => typeof l == "string" && l.startsWith(`${f}:`)), o = i ? l.slice(i.length + 1) : l;
      return {
        component: n.sets[i ?? n.defaultSet].component,
        icon: o
      };
    })
  };
}, Gs = ["x-small", "small", "default", "large", "x-large"], Dt = F({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function Nt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  return Qn(() => {
    let t, a;
    return Zt(Gs, e.size) ? t = `${n}--size-${e.size}` : e.size && (a = {
      width: j(e.size),
      height: j(e.size)
    }), {
      sizeClasses: t,
      sizeStyles: a
    };
  });
}
const Us = F({
  color: String,
  start: Boolean,
  end: Boolean,
  icon: re,
  ...ne(),
  ...Dt(),
  ...ge({
    tag: "i"
  }),
  ...ve()
}, "VIcon"), ye = W()({
  name: "VIcon",
  props: Us(),
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const l = D(), {
      themeClasses: i
    } = be(e), {
      iconData: o
    } = Ws(h(() => l.value || e.icon)), {
      sizeClasses: s
    } = Nt(e), {
      textColorClasses: r,
      textColorStyles: f
    } = ze(K(e, "color"));
    return Z(() => {
      var d, c;
      const v = (d = a.default) == null ? void 0 : d.call(a);
      return v && (l.value = (c = Cl(v).filter((m) => m.type === go && m.children && typeof m.children == "string")[0]) == null ? void 0 : c.children), u(o.value.component, {
        tag: e.tag,
        icon: o.value.icon,
        class: ["v-icon", "notranslate", i.value, s.value, r.value, {
          "v-icon--clickable": !!t.onClick,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [s.value ? void 0 : {
          fontSize: j(e.size),
          height: j(e.size),
          width: j(e.size)
        }, f.value, e.style],
        role: t.onClick ? "button" : void 0,
        "aria-hidden": !t.onClick
      }, {
        default: () => [v]
      });
    }), {};
  }
});
function oi(e, n) {
  const t = D(), a = z(!1);
  if (Zn) {
    const l = new IntersectionObserver((i) => {
      e == null || e(i, l), a.value = !!i.find((o) => o.isIntersecting);
    }, n);
    Ie(() => {
      l.disconnect();
    }), H(t, (i, o) => {
      o && (l.unobserve(o), a.value = !1), i && l.observe(i);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: t,
    isIntersecting: a
  };
}
const Ks = F({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...ne(),
  ...Dt(),
  ...ge({
    tag: "div"
  }),
  ...ve()
}, "VProgressCircular"), si = W()({
  name: "VProgressCircular",
  props: Ks(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = 20, l = 2 * Math.PI * a, i = D(), {
      themeClasses: o
    } = be(e), {
      sizeClasses: s,
      sizeStyles: r
    } = Nt(e), {
      textColorClasses: f,
      textColorStyles: v
    } = ze(K(e, "color")), {
      textColorClasses: d,
      textColorStyles: c
    } = ze(K(e, "bgColor")), {
      intersectionRef: m,
      isIntersecting: g
    } = oi(), {
      resizeRef: y,
      contentRect: b
    } = vn(), w = h(() => Math.max(0, Math.min(100, parseFloat(e.modelValue)))), C = h(() => Number(e.width)), V = h(() => r.value ? Number(e.size) : b.value ? b.value.width : Math.max(C.value, 32)), A = h(() => a / (1 - C.value / V.value) * 2), p = h(() => C.value / V.value * A.value), x = h(() => j((100 - w.value) / 100 * l));
    return Te(() => {
      m.value = i.value, y.value = i.value;
    }), Z(() => u(e.tag, {
      ref: i,
      class: ["v-progress-circular", {
        "v-progress-circular--indeterminate": !!e.indeterminate,
        "v-progress-circular--visible": g.value,
        "v-progress-circular--disable-shrink": e.indeterminate === "disable-shrink"
      }, o.value, s.value, f.value, e.class],
      style: [r.value, v.value, e.style],
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": e.indeterminate ? void 0 : w.value
    }, {
      default: () => [u("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${Number(e.rotate)}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${A.value} ${A.value}`
      }, [u("circle", {
        class: ["v-progress-circular__underlay", d.value],
        style: c.value,
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: a,
        "stroke-width": p.value,
        "stroke-dasharray": l,
        "stroke-dashoffset": 0
      }, null), u("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: a,
        "stroke-width": p.value,
        "stroke-dasharray": l,
        "stroke-dashoffset": x.value
      }, null)]), t.default && u("div", {
        class: "v-progress-circular__content"
      }, [t.default({
        value: w.value
      })])]
    })), {};
  }
});
const Qa = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, ra = F({
  location: String
}, "location");
function ua(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: a
  } = Ge();
  return {
    locationStyles: h(() => {
      if (!e.location)
        return {};
      const {
        side: i,
        align: o
      } = $n(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, a.value);
      function s(f) {
        return t ? t(f) : 0;
      }
      const r = {};
      return i !== "center" && (n ? r[Qa[i]] = `calc(100% - ${s(i)}px)` : r[i] = 0), o !== "center" ? n ? r[Qa[o]] = `calc(100% - ${s(o)}px)` : r[o] = 0 : (i === "center" ? r.top = r.left = "50%" : r[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[i]] = "50%", r.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[i]), r;
    })
  };
}
const Ys = F({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...ne(),
  ...ra({
    location: "top"
  }),
  ...$e(),
  ...ge(),
  ...ve()
}, "VProgressLinear"), ri = W()({
  name: "VProgressLinear",
  props: Ys(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = oe(e, "modelValue"), {
      isRtl: l,
      rtlClasses: i
    } = Ge(), {
      themeClasses: o
    } = be(e), {
      locationStyles: s
    } = ua(e), {
      textColorClasses: r,
      textColorStyles: f
    } = ze(e, "color"), {
      backgroundColorClasses: v,
      backgroundColorStyles: d
    } = We(h(() => e.bgColor || e.color)), {
      backgroundColorClasses: c,
      backgroundColorStyles: m
    } = We(e, "color"), {
      roundedClasses: g
    } = Fe(e), {
      intersectionRef: y,
      isIntersecting: b
    } = oi(), w = h(() => parseInt(e.max, 10)), C = h(() => parseInt(e.height, 10)), V = h(() => parseFloat(e.bufferValue) / w.value * 100), A = h(() => parseFloat(a.value) / w.value * 100), p = h(() => l.value !== e.reverse), x = h(() => e.indeterminate ? "fade-transition" : "slide-x-transition"), S = h(() => e.bgOpacity == null ? e.bgOpacity : parseFloat(e.bgOpacity));
    function P(k) {
      if (!y.value)
        return;
      const {
        left: I,
        right: T,
        width: $
      } = y.value.getBoundingClientRect(), E = p.value ? $ - k.clientX + (T - $) : k.clientX - I;
      a.value = Math.round(E / $ * w.value);
    }
    return Z(() => u(e.tag, {
      ref: y,
      class: ["v-progress-linear", {
        "v-progress-linear--absolute": e.absolute,
        "v-progress-linear--active": e.active && b.value,
        "v-progress-linear--reverse": p.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped
      }, g.value, o.value, i.value, e.class],
      style: [{
        bottom: e.location === "bottom" ? 0 : void 0,
        top: e.location === "top" ? 0 : void 0,
        height: e.active ? j(C.value) : 0,
        "--v-progress-linear-height": j(C.value),
        ...s.value
      }, e.style],
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : A.value,
      onClick: e.clickable && P
    }, {
      default: () => [e.stream && u("div", {
        key: "stream",
        class: ["v-progress-linear__stream", r.value],
        style: {
          ...f.value,
          [p.value ? "left" : "right"]: j(-C.value),
          borderTop: `${j(C.value / 2)} dotted`,
          opacity: S.value,
          top: `calc(50% - ${j(C.value / 4)})`,
          width: j(100 - V.value, "%"),
          "--v-progress-linear-stream-to": j(C.value * (p.value ? 1 : -1))
        }
      }, null), u("div", {
        class: ["v-progress-linear__background", v.value],
        style: [d.value, {
          opacity: S.value,
          width: j(e.stream ? V.value : 100, "%")
        }]
      }, null), u(Ke, {
        name: x.value
      }, {
        default: () => [e.indeterminate ? u("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((k) => u("div", {
          key: k,
          class: ["v-progress-linear__indeterminate", k, c.value],
          style: m.value
        }, null))]) : u("div", {
          class: ["v-progress-linear__determinate", c.value],
          style: [m.value, {
            width: j(A.value, "%")
          }]
        }, null)]
      }), t.default && u("div", {
        class: "v-progress-linear__content"
      }, [t.default({
        value: A.value,
        buffer: V.value
      })])]
    })), {};
  }
}), ui = F({
  loading: [Boolean, String]
}, "loader");
function ca(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  return {
    loaderClasses: h(() => ({
      [`${n}--loading`]: e.loading
    }))
  };
}
function ci(e, n) {
  var a;
  let {
    slots: t
  } = n;
  return u("div", {
    class: `${e.name}__loader`
  }, [((a = t.default) == null ? void 0 : a.call(t, {
    color: e.color,
    isActive: e.active
  })) || u(ri, {
    absolute: e.absolute,
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const qs = ["static", "relative", "fixed", "absolute", "sticky"], di = F({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => qs.includes(e)
    )
  }
}, "position");
function fi(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  return {
    positionClasses: h(() => e.position ? `${n}--${e.position}` : void 0)
  };
}
function Xs() {
  const e = fe("useRoute");
  return h(() => {
    var n;
    return (n = e == null ? void 0 : e.proxy) == null ? void 0 : n.$route;
  });
}
function vi() {
  var e, n;
  return (n = (e = fe("useRouter")) == null ? void 0 : e.proxy) == null ? void 0 : n.$router;
}
function da(e, n) {
  const t = ho("RouterLink"), a = h(() => !!(e.href || e.to)), l = h(() => (a == null ? void 0 : a.value) || Aa(n, "click") || Aa(e, "click"));
  if (typeof t == "string")
    return {
      isLink: a,
      isClickable: l,
      href: K(e, "href")
    };
  const i = e.to ? t.useLink(e) : void 0, o = Xs();
  return {
    isLink: a,
    isClickable: l,
    route: i == null ? void 0 : i.route,
    navigate: i == null ? void 0 : i.navigate,
    isActive: i && h(() => {
      var s, r, f;
      return e.exact ? o.value ? ((f = i.isExactActive) == null ? void 0 : f.value) && kt(i.route.value.query, o.value.query) : (r = i.isExactActive) == null ? void 0 : r.value : (s = i.isActive) == null ? void 0 : s.value;
    }),
    href: h(() => e.to ? i == null ? void 0 : i.route.value.href : e.href)
  };
}
const fa = F({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let kn = !1;
function Zs(e, n) {
  let t = !1, a, l;
  se && (de(() => {
    window.addEventListener("popstate", i), a = e == null ? void 0 : e.beforeEach((o, s, r) => {
      kn ? t ? n(r) : r() : setTimeout(() => t ? n(r) : r()), kn = !0;
    }), l = e == null ? void 0 : e.afterEach(() => {
      kn = !1;
    });
  }), Ce(() => {
    window.removeEventListener("popstate", i), a == null || a(), l == null || l();
  }));
  function i(o) {
    var s;
    (s = o.state) != null && s.replaced || (t = !0, setTimeout(() => t = !1));
  }
}
function Js(e, n) {
  H(() => {
    var t;
    return (t = e.isActive) == null ? void 0 : t.value;
  }, (t) => {
    e.isLink.value && t && n && de(() => {
      n(!0);
    });
  }, {
    immediate: !0
  });
}
const Dn = Symbol("rippleStop"), Qs = 80;
function el(e, n) {
  e.style.transform = n, e.style.webkitTransform = n;
}
function Nn(e) {
  return e.constructor.name === "TouchEvent";
}
function mi(e) {
  return e.constructor.name === "KeyboardEvent";
}
const er = function(e, n) {
  var d;
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = 0, l = 0;
  if (!mi(e)) {
    const c = n.getBoundingClientRect(), m = Nn(e) ? e.touches[e.touches.length - 1] : e;
    a = m.clientX - c.left, l = m.clientY - c.top;
  }
  let i = 0, o = 0.3;
  (d = n._ripple) != null && d.circle ? (o = 0.15, i = n.clientWidth / 2, i = t.center ? i : i + Math.sqrt((a - i) ** 2 + (l - i) ** 2) / 4) : i = Math.sqrt(n.clientWidth ** 2 + n.clientHeight ** 2) / 2;
  const s = `${(n.clientWidth - i * 2) / 2}px`, r = `${(n.clientHeight - i * 2) / 2}px`, f = t.center ? s : `${a - i}px`, v = t.center ? r : `${l - i}px`;
  return {
    radius: i,
    scale: o,
    x: f,
    y: v,
    centerX: s,
    centerY: r
  };
}, on = {
  /* eslint-disable max-statements */
  show(e, n) {
    var m;
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!((m = n == null ? void 0 : n._ripple) != null && m.enabled))
      return;
    const a = document.createElement("span"), l = document.createElement("span");
    a.appendChild(l), a.className = "v-ripple__container", t.class && (a.className += ` ${t.class}`);
    const {
      radius: i,
      scale: o,
      x: s,
      y: r,
      centerX: f,
      centerY: v
    } = er(e, n, t), d = `${i * 2}px`;
    l.className = "v-ripple__animation", l.style.width = d, l.style.height = d, n.appendChild(a);
    const c = window.getComputedStyle(n);
    c && c.position === "static" && (n.style.position = "relative", n.dataset.previousPosition = "static"), l.classList.add("v-ripple__animation--enter"), l.classList.add("v-ripple__animation--visible"), el(l, `translate(${s}, ${r}) scale3d(${o},${o},${o})`), l.dataset.activated = String(performance.now()), setTimeout(() => {
      l.classList.remove("v-ripple__animation--enter"), l.classList.add("v-ripple__animation--in"), el(l, `translate(${f}, ${v}) scale3d(1,1,1)`);
    }, 0);
  },
  hide(e) {
    var i;
    if (!((i = e == null ? void 0 : e._ripple) != null && i.enabled))
      return;
    const n = e.getElementsByClassName("v-ripple__animation");
    if (n.length === 0)
      return;
    const t = n[n.length - 1];
    if (t.dataset.isHiding)
      return;
    t.dataset.isHiding = "true";
    const a = performance.now() - Number(t.dataset.activated), l = Math.max(250 - a, 0);
    setTimeout(() => {
      t.classList.remove("v-ripple__animation--in"), t.classList.add("v-ripple__animation--out"), setTimeout(() => {
        var s;
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), ((s = t.parentNode) == null ? void 0 : s.parentNode) === e && e.removeChild(t.parentNode);
      }, 300);
    }, l);
  }
};
function gi(e) {
  return typeof e > "u" || !!e;
}
function Bt(e) {
  const n = {}, t = e.currentTarget;
  if (!(!(t != null && t._ripple) || t._ripple.touched || e[Dn])) {
    if (e[Dn] = !0, Nn(e))
      t._ripple.touched = !0, t._ripple.isTouch = !0;
    else if (t._ripple.isTouch)
      return;
    if (n.center = t._ripple.centered || mi(e), t._ripple.class && (n.class = t._ripple.class), Nn(e)) {
      if (t._ripple.showTimerCommit)
        return;
      t._ripple.showTimerCommit = () => {
        on.show(e, t, n);
      }, t._ripple.showTimer = window.setTimeout(() => {
        var a;
        (a = t == null ? void 0 : t._ripple) != null && a.showTimerCommit && (t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null);
      }, Qs);
    } else
      on.show(e, t, n);
  }
}
function tl(e) {
  e[Dn] = !0;
}
function Pe(e) {
  const n = e.currentTarget;
  if (n != null && n._ripple) {
    if (window.clearTimeout(n._ripple.showTimer), e.type === "touchend" && n._ripple.showTimerCommit) {
      n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null, n._ripple.showTimer = window.setTimeout(() => {
        Pe(e);
      });
      return;
    }
    window.setTimeout(() => {
      n._ripple && (n._ripple.touched = !1);
    }), on.hide(n);
  }
}
function hi(e) {
  const n = e.currentTarget;
  n != null && n._ripple && (n._ripple.showTimerCommit && (n._ripple.showTimerCommit = null), window.clearTimeout(n._ripple.showTimer));
}
let $t = !1;
function yi(e) {
  !$t && (e.keyCode === Pa.enter || e.keyCode === Pa.space) && ($t = !0, Bt(e));
}
function bi(e) {
  $t = !1, Pe(e);
}
function Si(e) {
  $t && ($t = !1, Pe(e));
}
function wi(e, n, t) {
  const {
    value: a,
    modifiers: l
  } = n, i = gi(a);
  if (i || on.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = i, e._ripple.centered = l.center, e._ripple.circle = l.circle, En(a) && a.class && (e._ripple.class = a.class), i && !t) {
    if (l.stop) {
      e.addEventListener("touchstart", tl, {
        passive: !0
      }), e.addEventListener("mousedown", tl);
      return;
    }
    e.addEventListener("touchstart", Bt, {
      passive: !0
    }), e.addEventListener("touchend", Pe, {
      passive: !0
    }), e.addEventListener("touchmove", hi, {
      passive: !0
    }), e.addEventListener("touchcancel", Pe), e.addEventListener("mousedown", Bt), e.addEventListener("mouseup", Pe), e.addEventListener("mouseleave", Pe), e.addEventListener("keydown", yi), e.addEventListener("keyup", bi), e.addEventListener("blur", Si), e.addEventListener("dragstart", Pe, {
      passive: !0
    });
  } else
    !i && t && Ci(e);
}
function Ci(e) {
  e.removeEventListener("mousedown", Bt), e.removeEventListener("touchstart", Bt), e.removeEventListener("touchend", Pe), e.removeEventListener("touchmove", hi), e.removeEventListener("touchcancel", Pe), e.removeEventListener("mouseup", Pe), e.removeEventListener("mouseleave", Pe), e.removeEventListener("keydown", yi), e.removeEventListener("keyup", bi), e.removeEventListener("dragstart", Pe), e.removeEventListener("blur", Si);
}
function tr(e, n) {
  wi(e, n, !1);
}
function nr(e) {
  delete e._ripple, Ci(e);
}
function ar(e, n) {
  if (n.value === n.oldValue)
    return;
  const t = gi(n.oldValue);
  wi(e, n, t);
}
const hn = {
  mounted: tr,
  unmounted: nr,
  updated: ar
}, lr = F({
  active: {
    type: Boolean,
    default: void 0
  },
  symbol: {
    type: null,
    default: ai
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: re,
  appendIcon: re,
  block: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  ...ct(),
  ...ne(),
  ...Ze(),
  ...Vt(),
  ...ft(),
  ...Ql(),
  ...ui(),
  ...ra(),
  ...di(),
  ...$e(),
  ...fa(),
  ...Dt(),
  ...ge({
    tag: "button"
  }),
  ...ve(),
  ...Qe({
    variant: "elevated"
  })
}, "VBtn"), Rc = W()({
  name: "VBtn",
  directives: {
    Ripple: hn
  },
  props: lr(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const {
      themeClasses: l
    } = be(e), {
      borderClasses: i
    } = dt(e), {
      colorClasses: o,
      colorStyles: s,
      variantClasses: r
    } = Rt(e), {
      densityClasses: f
    } = Je(e), {
      dimensionStyles: v
    } = Pt(e), {
      elevationClasses: d
    } = vt(e), {
      loaderClasses: c
    } = ca(e), {
      locationStyles: m
    } = ua(e), {
      positionClasses: g
    } = fi(e), {
      roundedClasses: y
    } = Fe(e), {
      sizeClasses: b,
      sizeStyles: w
    } = Nt(e), C = ei(e, e.symbol, !1), V = da(e, t), A = h(() => {
      var k;
      return e.active !== void 0 ? e.active : V.isLink.value ? (k = V.isActive) == null ? void 0 : k.value : C == null ? void 0 : C.isSelected.value;
    }), p = h(() => (C == null ? void 0 : C.disabled.value) || e.disabled), x = h(() => e.variant === "elevated" && !(e.disabled || e.flat || e.border)), S = h(() => {
      if (!(e.value === void 0 || typeof e.value == "symbol"))
        return Object(e.value) === e.value ? JSON.stringify(e.value, null, 0) : e.value;
    });
    function P(k) {
      var I;
      p.value || V.isLink.value && (k.metaKey || k.ctrlKey || k.shiftKey || k.button !== 0 || t.target === "_blank") || ((I = V.navigate) == null || I.call(V, k), C == null || C.toggle());
    }
    return Js(V, C == null ? void 0 : C.select), Z(() => {
      var L, N;
      const k = V.isLink.value ? "a" : e.tag, I = !!(e.prependIcon || a.prepend), T = !!(e.appendIcon || a.append), $ = !!(e.icon && e.icon !== !0), E = (C == null ? void 0 : C.isSelected.value) && (!V.isLink.value || ((L = V.isActive) == null ? void 0 : L.value)) || !C || ((N = V.isActive) == null ? void 0 : N.value);
      return Ve(u(k, {
        type: k === "a" ? void 0 : "button",
        class: ["v-btn", C == null ? void 0 : C.selectedClass.value, {
          "v-btn--active": A.value,
          "v-btn--block": e.block,
          "v-btn--disabled": p.value,
          "v-btn--elevated": x.value,
          "v-btn--flat": e.flat,
          "v-btn--icon": !!e.icon,
          "v-btn--loading": e.loading,
          "v-btn--slim": e.slim,
          "v-btn--stacked": e.stacked
        }, l.value, i.value, E ? o.value : void 0, f.value, d.value, c.value, g.value, y.value, b.value, r.value, e.class],
        style: [E ? s.value : void 0, v.value, m.value, w.value, e.style],
        disabled: p.value || void 0,
        href: V.href.value,
        onClick: P,
        value: S.value
      }, {
        default: () => {
          var X;
          return [Mt(!0, "v-btn"), !e.icon && I && u("span", {
            key: "prepend",
            class: "v-btn__prepend"
          }, [a.prepend ? u(he, {
            key: "prepend-defaults",
            disabled: !e.prependIcon,
            defaults: {
              VIcon: {
                icon: e.prependIcon
              }
            }
          }, a.prepend) : u(ye, {
            key: "prepend-icon",
            icon: e.prependIcon
          }, null)]), u("span", {
            class: "v-btn__content",
            "data-no-activator": ""
          }, [!a.default && $ ? u(ye, {
            key: "content-icon",
            icon: e.icon
          }, null) : u(he, {
            key: "content-defaults",
            disabled: !$,
            defaults: {
              VIcon: {
                icon: e.icon
              }
            }
          }, {
            default: () => {
              var J;
              return [((J = a.default) == null ? void 0 : J.call(a)) ?? e.text];
            }
          })]), !e.icon && T && u("span", {
            key: "append",
            class: "v-btn__append"
          }, [a.append ? u(he, {
            key: "append-defaults",
            disabled: !e.appendIcon,
            defaults: {
              VIcon: {
                icon: e.appendIcon
              }
            }
          }, a.append) : u(ye, {
            key: "append-icon",
            icon: e.appendIcon
          }, null)]), !!e.loading && u("span", {
            key: "loader",
            class: "v-btn__loader"
          }, [((X = a.loader) == null ? void 0 : X.call(a)) ?? u(si, {
            color: typeof e.loading == "boolean" ? void 0 : e.loading,
            indeterminate: !0,
            size: "23",
            width: "2"
          }, null)])];
        }
      }), [[qe("ripple"), !p.value && e.ripple, null]]);
    }), {};
  }
});
const ir = F({
  start: Boolean,
  end: Boolean,
  icon: re,
  image: String,
  text: String,
  ...ne(),
  ...Ze(),
  ...$e(),
  ...Dt(),
  ...ge(),
  ...ve(),
  ...Qe({
    variant: "flat"
  })
}, "VAvatar"), St = W()({
  name: "VAvatar",
  props: ir(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      themeClasses: a
    } = be(e), {
      colorClasses: l,
      colorStyles: i,
      variantClasses: o
    } = Rt(e), {
      densityClasses: s
    } = Je(e), {
      roundedClasses: r
    } = Fe(e), {
      sizeClasses: f,
      sizeStyles: v
    } = Nt(e);
    return Z(() => u(e.tag, {
      class: ["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, a.value, l.value, s.value, r.value, f.value, o.value, e.class],
      style: [i.value, v.value, e.style]
    }, {
      default: () => {
        var d;
        return [e.image ? u(Xl, {
          key: "image",
          src: e.image,
          alt: "",
          cover: !0
        }, null) : e.icon ? u(ye, {
          key: "icon",
          icon: e.icon
        }, null) : ((d = t.default) == null ? void 0 : d.call(t)) ?? e.text, Mt(!1, "v-avatar")];
      }
    })), {};
  }
});
const or = F({
  text: String,
  clickable: Boolean,
  ...ne(),
  ...ve()
}, "VLabel"), xi = W()({
  name: "VLabel",
  props: or(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return Z(() => {
      var a;
      return u("label", {
        class: ["v-label", {
          "v-label--clickable": e.clickable
        }, e.class],
        style: e.style
      }, [e.text, (a = t.default) == null ? void 0 : a.call(t)]);
    }), {};
  }
});
const pi = Symbol.for("vuetify:selection-control-group"), ki = F({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: re,
  trueIcon: re,
  ripple: {
    type: Boolean,
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: kt
  },
  ...ne(),
  ...Ze(),
  ...ve()
}, "SelectionControlGroup"), sr = F({
  ...ki({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup"), Dc = W()({
  name: "VSelectionControlGroup",
  props: sr(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = oe(e, "modelValue"), l = Be(), i = h(() => e.id || `v-selection-control-group-${l}`), o = h(() => e.name || i.value), s = /* @__PURE__ */ new Set();
    return we(pi, {
      modelValue: a,
      forceUpdate: () => {
        s.forEach((r) => r());
      },
      onForceUpdate: (r) => {
        s.add(r), Ce(() => {
          s.delete(r);
        });
      }
    }), ut({
      [e.defaultsTarget]: {
        color: K(e, "color"),
        disabled: K(e, "disabled"),
        density: K(e, "density"),
        error: K(e, "error"),
        inline: K(e, "inline"),
        modelValue: a,
        multiple: h(() => !!e.multiple || e.multiple == null && Array.isArray(a.value)),
        name: o,
        falseIcon: K(e, "falseIcon"),
        trueIcon: K(e, "trueIcon"),
        readonly: K(e, "readonly"),
        ripple: K(e, "ripple"),
        type: K(e, "type"),
        valueComparator: K(e, "valueComparator")
      }
    }), Z(() => {
      var r;
      return u("div", {
        class: ["v-selection-control-group", {
          "v-selection-control-group--inline": e.inline
        }, e.class],
        style: e.style,
        role: e.type === "radio" ? "radiogroup" : void 0
      }, [(r = t.default) == null ? void 0 : r.call(t)]);
    }), {};
  }
}), va = F({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...ne(),
  ...ki()
}, "VSelectionControl");
function rr(e) {
  const n = ue(pi, void 0), {
    densityClasses: t
  } = Je(e), a = oe(e, "modelValue"), l = h(() => e.trueValue !== void 0 ? e.trueValue : e.value !== void 0 ? e.value : !0), i = h(() => e.falseValue !== void 0 ? e.falseValue : !1), o = h(() => !!e.multiple || e.multiple == null && Array.isArray(a.value)), s = h({
    get() {
      const m = n ? n.modelValue.value : a.value;
      return o.value ? Ae(m).some((g) => e.valueComparator(g, l.value)) : e.valueComparator(m, l.value);
    },
    set(m) {
      if (e.readonly)
        return;
      const g = m ? l.value : i.value;
      let y = g;
      o.value && (y = m ? [...Ae(a.value), g] : Ae(a.value).filter((b) => !e.valueComparator(b, l.value))), n ? n.modelValue.value = y : a.value = y;
    }
  }), {
    textColorClasses: r,
    textColorStyles: f
  } = ze(h(() => {
    if (!(e.error || e.disabled))
      return s.value ? e.color : e.baseColor;
  })), {
    backgroundColorClasses: v,
    backgroundColorStyles: d
  } = We(h(() => s.value && !e.error && !e.disabled ? e.color : void 0)), c = h(() => s.value ? e.trueIcon : e.falseIcon);
  return {
    group: n,
    densityClasses: t,
    trueValue: l,
    falseValue: i,
    model: s,
    textColorClasses: r,
    textColorStyles: f,
    backgroundColorClasses: v,
    backgroundColorStyles: d,
    icon: c
  };
}
const sn = W()({
  name: "VSelectionControl",
  directives: {
    Ripple: hn
  },
  inheritAttrs: !1,
  props: va(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const {
      group: l,
      densityClasses: i,
      icon: o,
      model: s,
      textColorClasses: r,
      textColorStyles: f,
      backgroundColorClasses: v,
      backgroundColorStyles: d,
      trueValue: c
    } = rr(e), m = Be(), g = h(() => e.id || `input-${m}`), y = z(!1), b = z(!1), w = D();
    l == null || l.onForceUpdate(() => {
      w.value && (w.value.checked = s.value);
    });
    function C(p) {
      y.value = !0, bt(p.target, ":focus-visible") !== !1 && (b.value = !0);
    }
    function V() {
      y.value = !1, b.value = !1;
    }
    function A(p) {
      e.readonly && l && de(() => l.forceUpdate()), s.value = p.target.checked;
    }
    return Z(() => {
      var k, I;
      const p = a.label ? a.label({
        label: e.label,
        props: {
          for: g.value
        }
      }) : e.label, [x, S] = fn(t), P = u("input", q({
        ref: w,
        checked: s.value,
        disabled: !!(e.readonly || e.disabled),
        id: g.value,
        onBlur: V,
        onFocus: C,
        onInput: A,
        "aria-disabled": !!(e.readonly || e.disabled),
        type: e.type,
        value: c.value,
        name: e.name,
        "aria-checked": e.type === "checkbox" ? s.value : void 0
      }, S), null);
      return u("div", q({
        class: ["v-selection-control", {
          "v-selection-control--dirty": s.value,
          "v-selection-control--disabled": e.disabled,
          "v-selection-control--error": e.error,
          "v-selection-control--focused": y.value,
          "v-selection-control--focus-visible": b.value,
          "v-selection-control--inline": e.inline
        }, i.value, e.class]
      }, x, {
        style: e.style
      }), [u("div", {
        class: ["v-selection-control__wrapper", r.value],
        style: f.value
      }, [(k = a.default) == null ? void 0 : k.call(a, {
        backgroundColorClasses: v,
        backgroundColorStyles: d
      }), Ve(u("div", {
        class: ["v-selection-control__input"]
      }, [((I = a.input) == null ? void 0 : I.call(a, {
        model: s,
        textColorClasses: r,
        textColorStyles: f,
        backgroundColorClasses: v,
        backgroundColorStyles: d,
        inputNode: P,
        icon: o.value,
        props: {
          onFocus: C,
          onBlur: V,
          id: g.value
        }
      })) ?? u(ie, null, [o.value && u(ye, {
        key: "icon",
        icon: o.value
      }, null), P])]), [[qe("ripple"), e.ripple && [!e.disabled && !e.readonly, null, ["center", "circle"]]]])]), p && u(xi, {
        for: g.value,
        clickable: !0,
        onClick: (T) => T.stopPropagation()
      }, {
        default: () => [p]
      })]);
    }), {
      isFocused: y,
      input: w
    };
  }
}), ur = F({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: re,
    default: "$checkboxIndeterminate"
  },
  ...va({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn"), Vi = W()({
  name: "VCheckboxBtn",
  props: ur(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = oe(e, "indeterminate"), l = oe(e, "modelValue");
    function i(r) {
      a.value && (a.value = !1);
    }
    const o = h(() => a.value ? e.indeterminateIcon : e.falseIcon), s = h(() => a.value ? e.indeterminateIcon : e.trueIcon);
    return Z(() => {
      const r = Xe(sn.filterProps(e), ["modelValue"]);
      return u(sn, q(r, {
        modelValue: l.value,
        "onUpdate:modelValue": [(f) => l.value = f, i],
        class: ["v-checkbox-btn", e.class],
        style: e.style,
        type: "checkbox",
        falseIcon: o.value,
        trueIcon: s.value,
        "aria-checked": a.value ? "mixed" : void 0
      }), t);
    }), {};
  }
});
function Pi(e) {
  const {
    t: n
  } = mn();
  function t(a) {
    let {
      name: l
    } = a;
    const i = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[l], o = e[`onClick:${l}`], s = o && i ? n(`$vuetify.input.${i}`, e.label ?? "") : void 0;
    return u(ye, {
      icon: e[`${l}Icon`],
      "aria-label": s,
      onClick: o
    }, null);
  }
  return {
    InputIcon: t
  };
}
const cr = F({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...ne(),
  ...It({
    transition: {
      component: Gl,
      leaveAbsolute: !0,
      group: !0
    }
  })
}, "VMessages"), dr = W()({
  name: "VMessages",
  props: cr(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = h(() => Ae(e.messages)), {
      textColorClasses: l,
      textColorStyles: i
    } = ze(h(() => e.color));
    return Z(() => u(Ue, {
      transition: e.transition,
      tag: "div",
      class: ["v-messages", l.value, e.class],
      style: [i.value, e.style],
      role: "alert",
      "aria-live": "polite"
    }, {
      default: () => [e.active && a.value.map((o, s) => u("div", {
        class: "v-messages__message",
        key: `${s}-${a.value}`
      }, [t.message ? t.message({
        message: o
      }) : o]))]
    })), {};
  }
}), Ii = F({
  focused: Boolean,
  "onUpdate:focused": De()
}, "focus");
function yn(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  const t = oe(e, "focused"), a = h(() => ({
    [`${n}--focused`]: t.value
  }));
  function l() {
    t.value = !0;
  }
  function i() {
    t.value = !1;
  }
  return {
    focusClasses: a,
    isFocused: t,
    focus: l,
    blur: i
  };
}
const _i = Symbol.for("vuetify:form"), Nc = F({
  disabled: Boolean,
  fastFail: Boolean,
  readonly: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  validateOn: {
    type: String,
    default: "input"
  }
}, "form");
function zc(e) {
  const n = oe(e, "modelValue"), t = h(() => e.disabled), a = h(() => e.readonly), l = z(!1), i = D([]), o = D([]);
  async function s() {
    const v = [];
    let d = !0;
    o.value = [], l.value = !0;
    for (const c of i.value) {
      const m = await c.validate();
      if (m.length > 0 && (d = !1, v.push({
        id: c.id,
        errorMessages: m
      })), !d && e.fastFail)
        break;
    }
    return o.value = v, l.value = !1, {
      valid: d,
      errors: o.value
    };
  }
  function r() {
    i.value.forEach((v) => v.reset());
  }
  function f() {
    i.value.forEach((v) => v.resetValidation());
  }
  return H(i, () => {
    let v = 0, d = 0;
    const c = [];
    for (const m of i.value)
      m.isValid === !1 ? (d++, c.push({
        id: m.id,
        errorMessages: m.errorMessages
      })) : m.isValid === !0 && v++;
    o.value = c, n.value = d > 0 ? !1 : v === i.value.length ? !0 : null;
  }, {
    deep: !0
  }), we(_i, {
    register: (v) => {
      let {
        id: d,
        validate: c,
        reset: m,
        resetValidation: g
      } = v;
      i.value.some((y) => y.id === d) && st(`Duplicate input name "${d}"`), i.value.push({
        id: d,
        validate: c,
        reset: m,
        resetValidation: g,
        isValid: null,
        errorMessages: []
      });
    },
    unregister: (v) => {
      i.value = i.value.filter((d) => d.id !== v);
    },
    update: (v, d, c) => {
      const m = i.value.find((g) => g.id === v);
      m && (m.isValid = d, m.errorMessages = c);
    },
    isDisabled: t,
    isReadonly: a,
    isValidating: l,
    isValid: n,
    items: i,
    validateOn: K(e, "validateOn")
  }), {
    errors: o,
    isDisabled: t,
    isReadonly: a,
    isValidating: l,
    isValid: n,
    items: i,
    validate: s,
    reset: r,
    resetValidation: f
  };
}
function ma() {
  return ue(_i, null);
}
const fr = F({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...Ii()
}, "validation");
function vr(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je(), t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Be();
  const a = oe(e, "modelValue"), l = h(() => e.validationValue === void 0 ? a.value : e.validationValue), i = ma(), o = D([]), s = z(!0), r = h(() => !!(Ae(a.value === "" ? null : a.value).length || Ae(l.value === "" ? null : l.value).length)), f = h(() => !!(e.disabled ?? (i == null ? void 0 : i.isDisabled.value))), v = h(() => !!(e.readonly ?? (i == null ? void 0 : i.isReadonly.value))), d = h(() => {
    var A;
    return (A = e.errorMessages) != null && A.length ? Ae(e.errorMessages).concat(o.value).slice(0, Math.max(0, +e.maxErrors)) : o.value;
  }), c = h(() => {
    let A = (e.validateOn ?? (i == null ? void 0 : i.validateOn.value)) || "input";
    A === "lazy" && (A = "input lazy");
    const p = new Set((A == null ? void 0 : A.split(" ")) ?? []);
    return {
      blur: p.has("blur") || p.has("input"),
      input: p.has("input"),
      submit: p.has("submit"),
      lazy: p.has("lazy")
    };
  }), m = h(() => {
    var A;
    return e.error || (A = e.errorMessages) != null && A.length ? !1 : e.rules.length ? s.value ? o.value.length || c.value.lazy ? null : !0 : !o.value.length : !0;
  }), g = z(!1), y = h(() => ({
    [`${n}--error`]: m.value === !1,
    [`${n}--dirty`]: r.value,
    [`${n}--disabled`]: f.value,
    [`${n}--readonly`]: v.value
  })), b = h(() => e.name ?? ke(t));
  Xn(() => {
    i == null || i.register({
      id: b.value,
      validate: V,
      reset: w,
      resetValidation: C
    });
  }), Ie(() => {
    i == null || i.unregister(b.value);
  }), He(async () => {
    c.value.lazy || await V(!0), i == null || i.update(b.value, m.value, d.value);
  }), Ne(() => c.value.input, () => {
    H(l, () => {
      if (l.value != null)
        V();
      else if (e.focused) {
        const A = H(() => e.focused, (p) => {
          p || V(), A();
        });
      }
    });
  }), Ne(() => c.value.blur, () => {
    H(() => e.focused, (A) => {
      A || V();
    });
  }), H(m, () => {
    i == null || i.update(b.value, m.value, d.value);
  });
  function w() {
    a.value = null, de(C);
  }
  function C() {
    s.value = !0, c.value.lazy ? o.value = [] : V(!0);
  }
  async function V() {
    let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const p = [];
    g.value = !0;
    for (const x of e.rules) {
      if (p.length >= +(e.maxErrors ?? 1))
        break;
      const P = await (typeof x == "function" ? x : () => x)(l.value);
      if (P !== !0) {
        if (P !== !1 && typeof P != "string") {
          console.warn(`${P} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        p.push(P || "");
      }
    }
    return o.value = p, g.value = !1, s.value = A, o.value;
  }
  return {
    errorMessages: d,
    isDirty: r,
    isDisabled: f,
    isReadonly: v,
    isPristine: s,
    isValid: m,
    isValidating: g,
    reset: w,
    resetValidation: C,
    validate: V,
    validationClasses: y
  };
}
const bn = F({
  id: String,
  appendIcon: re,
  centerAffix: {
    type: Boolean,
    default: !0
  },
  prependIcon: re,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["horizontal", "vertical"].includes(e)
  },
  "onClick:prepend": De(),
  "onClick:append": De(),
  ...ne(),
  ...Ze(),
  ...fr()
}, "VInput"), wt = W()({
  name: "VInput",
  props: {
    ...bn()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      slots: a,
      emit: l
    } = n;
    const {
      densityClasses: i
    } = Je(e), {
      rtlClasses: o
    } = Ge(), {
      InputIcon: s
    } = Pi(e), r = Be(), f = h(() => e.id || `input-${r}`), v = h(() => `${f.value}-messages`), {
      errorMessages: d,
      isDirty: c,
      isDisabled: m,
      isReadonly: g,
      isPristine: y,
      isValid: b,
      isValidating: w,
      reset: C,
      resetValidation: V,
      validate: A,
      validationClasses: p
    } = vr(e, "v-input", f), x = h(() => ({
      id: f,
      messagesId: v,
      isDirty: c,
      isDisabled: m,
      isReadonly: g,
      isPristine: y,
      isValid: b,
      isValidating: w,
      reset: C,
      resetValidation: V,
      validate: A
    })), S = h(() => {
      var P;
      return (P = e.errorMessages) != null && P.length || !y.value && d.value.length ? d.value : e.hint && (e.persistentHint || e.focused) ? e.hint : e.messages;
    });
    return Z(() => {
      var $, E, L, N;
      const P = !!(a.prepend || e.prependIcon), k = !!(a.append || e.appendIcon), I = S.value.length > 0, T = !e.hideDetails || e.hideDetails === "auto" && (I || !!a.details);
      return u("div", {
        class: ["v-input", `v-input--${e.direction}`, {
          "v-input--center-affix": e.centerAffix,
          "v-input--hide-spin-buttons": e.hideSpinButtons
        }, i.value, o.value, p.value, e.class],
        style: e.style
      }, [P && u("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [($ = a.prepend) == null ? void 0 : $.call(a, x.value), e.prependIcon && u(s, {
        key: "prepend-icon",
        name: "prepend"
      }, null)]), a.default && u("div", {
        class: "v-input__control"
      }, [(E = a.default) == null ? void 0 : E.call(a, x.value)]), k && u("div", {
        key: "append",
        class: "v-input__append"
      }, [e.appendIcon && u(s, {
        key: "append-icon",
        name: "append"
      }, null), (L = a.append) == null ? void 0 : L.call(a, x.value)]), T && u("div", {
        class: "v-input__details"
      }, [u(dr, {
        id: v.value,
        active: I,
        messages: S.value
      }, {
        message: a.message
      }), (N = a.details) == null ? void 0 : N.call(a, x.value)])]);
    }), {
      reset: C,
      resetValidation: V,
      validate: A,
      isValid: b,
      errorMessages: d
    };
  }
});
const Ai = Symbol.for("vuetify:v-chip-group"), mr = F({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: kt
  },
  ...ne(),
  ...Jl({
    selectedClass: "v-chip--selected"
  }),
  ...ge(),
  ...ve(),
  ...Qe({
    variant: "tonal"
  })
}, "VChipGroup"), Hc = W()({
  name: "VChipGroup",
  props: mr(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      themeClasses: a
    } = be(e), {
      isSelected: l,
      select: i,
      next: o,
      prev: s,
      selected: r
    } = ti(e, Ai);
    return ut({
      VChip: {
        color: K(e, "color"),
        disabled: K(e, "disabled"),
        filter: K(e, "filter"),
        variant: K(e, "variant")
      }
    }), Z(() => u(e.tag, {
      class: ["v-chip-group", {
        "v-chip-group--column": e.column
      }, a.value, e.class],
      style: e.style
    }, {
      default: () => {
        var f;
        return [(f = t.default) == null ? void 0 : f.call(t, {
          isSelected: l,
          select: i,
          next: o,
          prev: s,
          selected: r.value
        })];
      }
    })), {};
  }
}), gr = F({
  activeClass: String,
  appendAvatar: String,
  appendIcon: re,
  closable: Boolean,
  closeIcon: {
    type: re,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: String,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: re,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  onClick: De(),
  onClickOnce: De(),
  ...ct(),
  ...ne(),
  ...Ze(),
  ...ft(),
  ...Ql(),
  ...$e(),
  ...fa(),
  ...Dt(),
  ...ge({
    tag: "span"
  }),
  ...ve(),
  ...Qe({
    variant: "tonal"
  })
}, "VChip"), Ti = W()({
  name: "VChip",
  directives: {
    Ripple: hn
  },
  props: gr(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0,
    "group:selected": (e) => !0,
    click: (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      emit: a,
      slots: l
    } = n;
    const {
      t: i
    } = mn(), {
      borderClasses: o
    } = dt(e), {
      colorClasses: s,
      colorStyles: r,
      variantClasses: f
    } = Rt(e), {
      densityClasses: v
    } = Je(e), {
      elevationClasses: d
    } = vt(e), {
      roundedClasses: c
    } = Fe(e), {
      sizeClasses: m
    } = Nt(e), {
      themeClasses: g
    } = be(e), y = oe(e, "modelValue"), b = ei(e, Ai, !1), w = da(e, t), C = h(() => e.link !== !1 && w.isLink.value), V = h(() => !e.disabled && e.link !== !1 && (!!b || e.link || w.isClickable.value)), A = h(() => ({
      "aria-label": i(e.closeLabel),
      onClick(S) {
        S.stopPropagation(), y.value = !1, a("click:close", S);
      }
    }));
    function p(S) {
      var P;
      a("click", S), V.value && ((P = w.navigate) == null || P.call(w, S), b == null || b.toggle());
    }
    function x(S) {
      (S.key === "Enter" || S.key === " ") && (S.preventDefault(), p(S));
    }
    return () => {
      const S = w.isLink.value ? "a" : e.tag, P = !!(e.appendIcon || e.appendAvatar), k = !!(P || l.append), I = !!(l.close || e.closable), T = !!(l.filter || e.filter) && b, $ = !!(e.prependIcon || e.prependAvatar), E = !!($ || l.prepend), L = !b || b.isSelected.value;
      return y.value && Ve(u(S, {
        class: ["v-chip", {
          "v-chip--disabled": e.disabled,
          "v-chip--label": e.label,
          "v-chip--link": V.value,
          "v-chip--filter": T,
          "v-chip--pill": e.pill
        }, g.value, o.value, L ? s.value : void 0, v.value, d.value, c.value, m.value, f.value, b == null ? void 0 : b.selectedClass.value, e.class],
        style: [L ? r.value : void 0, e.style],
        disabled: e.disabled || void 0,
        draggable: e.draggable,
        href: w.href.value,
        tabindex: V.value ? 0 : void 0,
        onClick: p,
        onKeydown: V.value && !C.value && x
      }, {
        default: () => {
          var N;
          return [Mt(V.value, "v-chip"), T && u(Kl, {
            key: "filter"
          }, {
            default: () => [Ve(u("div", {
              class: "v-chip__filter"
            }, [l.filter ? u(he, {
              key: "filter-defaults",
              disabled: !e.filterIcon,
              defaults: {
                VIcon: {
                  icon: e.filterIcon
                }
              }
            }, l.filter) : u(ye, {
              key: "filter-icon",
              icon: e.filterIcon
            }, null)]), [[pt, b.isSelected.value]])]
          }), E && u("div", {
            key: "prepend",
            class: "v-chip__prepend"
          }, [l.prepend ? u(he, {
            key: "prepend-defaults",
            disabled: !$,
            defaults: {
              VAvatar: {
                image: e.prependAvatar,
                start: !0
              },
              VIcon: {
                icon: e.prependIcon,
                start: !0
              }
            }
          }, l.prepend) : u(ie, null, [e.prependIcon && u(ye, {
            key: "prepend-icon",
            icon: e.prependIcon,
            start: !0
          }, null), e.prependAvatar && u(St, {
            key: "prepend-avatar",
            image: e.prependAvatar,
            start: !0
          }, null)])]), u("div", {
            class: "v-chip__content"
          }, [((N = l.default) == null ? void 0 : N.call(l, {
            isSelected: b == null ? void 0 : b.isSelected.value,
            selectedClass: b == null ? void 0 : b.selectedClass.value,
            select: b == null ? void 0 : b.select,
            toggle: b == null ? void 0 : b.toggle,
            value: b == null ? void 0 : b.value.value,
            disabled: e.disabled
          })) ?? e.text]), k && u("div", {
            key: "append",
            class: "v-chip__append"
          }, [l.append ? u(he, {
            key: "append-defaults",
            disabled: !P,
            defaults: {
              VAvatar: {
                end: !0,
                image: e.appendAvatar
              },
              VIcon: {
                end: !0,
                icon: e.appendIcon
              }
            }
          }, l.append) : u(ie, null, [e.appendIcon && u(ye, {
            key: "append-icon",
            end: !0,
            icon: e.appendIcon
          }, null), e.appendAvatar && u(St, {
            key: "append-avatar",
            end: !0,
            image: e.appendAvatar
          }, null)])]), I && u("button", q({
            key: "close",
            class: "v-chip__close",
            type: "button"
          }, A.value), [l.close ? u(he, {
            key: "close-defaults",
            defaults: {
              VIcon: {
                icon: e.closeIcon,
                size: "x-small"
              }
            }
          }, l.close) : u(ye, {
            key: "close-icon",
            icon: e.closeIcon,
            size: "x-small"
          }, null)])];
        }
      }), [[qe("ripple"), V.value && e.ripple, null]]);
    };
  }
});
const zn = Symbol.for("vuetify:list");
function Ei() {
  const e = ue(zn, {
    hasPrepend: z(!1),
    updateHasPrepend: () => null
  }), n = {
    hasPrepend: z(!1),
    updateHasPrepend: (t) => {
      t && (n.hasPrepend.value = t);
    }
  };
  return we(zn, n), e;
}
function Bi() {
  return ue(zn, null);
}
const hr = {
  open: (e) => {
    let {
      id: n,
      value: t,
      opened: a,
      parents: l
    } = e;
    if (t) {
      const i = /* @__PURE__ */ new Set();
      i.add(n);
      let o = l.get(n);
      for (; o != null; )
        i.add(o), o = l.get(o);
      return i;
    } else
      return a.delete(n), a;
  },
  select: () => null
}, $i = {
  open: (e) => {
    let {
      id: n,
      value: t,
      opened: a,
      parents: l
    } = e;
    if (t) {
      let i = l.get(n);
      for (a.add(n); i != null && i !== n; )
        a.add(i), i = l.get(i);
      return a;
    } else
      a.delete(n);
    return a;
  },
  select: () => null
}, yr = {
  open: $i.open,
  select: (e) => {
    let {
      id: n,
      value: t,
      opened: a,
      parents: l
    } = e;
    if (!t)
      return a;
    const i = [];
    let o = l.get(n);
    for (; o != null; )
      i.push(o), o = l.get(o);
    return new Set(i);
  }
}, ga = (e) => {
  const n = {
    select: (t) => {
      let {
        id: a,
        value: l,
        selected: i
      } = t;
      if (a = Ye(a), e && !l) {
        const o = Array.from(i.entries()).reduce((s, r) => {
          let [f, v] = r;
          return v === "on" ? [...s, f] : s;
        }, []);
        if (o.length === 1 && o[0] === a)
          return i;
      }
      return i.set(a, l ? "on" : "off"), i;
    },
    in: (t, a, l) => {
      let i = /* @__PURE__ */ new Map();
      for (const o of t || [])
        i = n.select({
          id: o,
          value: !0,
          selected: new Map(i),
          children: a,
          parents: l
        });
      return i;
    },
    out: (t) => {
      const a = [];
      for (const [l, i] of t.entries())
        i === "on" && a.push(l);
      return a;
    }
  };
  return n;
}, Fi = (e) => {
  const n = ga(e);
  return {
    select: (a) => {
      let {
        selected: l,
        id: i,
        ...o
      } = a;
      i = Ye(i);
      const s = l.has(i) ? /* @__PURE__ */ new Map([[i, l.get(i)]]) : /* @__PURE__ */ new Map();
      return n.select({
        ...o,
        id: i,
        selected: s
      });
    },
    in: (a, l, i) => {
      let o = /* @__PURE__ */ new Map();
      return a != null && a.length && (o = n.in(a.slice(0, 1), l, i)), o;
    },
    out: (a, l, i) => n.out(a, l, i)
  };
}, br = (e) => {
  const n = ga(e);
  return {
    select: (a) => {
      let {
        id: l,
        selected: i,
        children: o,
        ...s
      } = a;
      return l = Ye(l), o.has(l) ? i : n.select({
        id: l,
        selected: i,
        children: o,
        ...s
      });
    },
    in: n.in,
    out: n.out
  };
}, Sr = (e) => {
  const n = Fi(e);
  return {
    select: (a) => {
      let {
        id: l,
        selected: i,
        children: o,
        ...s
      } = a;
      return l = Ye(l), o.has(l) ? i : n.select({
        id: l,
        selected: i,
        children: o,
        ...s
      });
    },
    in: n.in,
    out: n.out
  };
}, wr = (e) => {
  const n = {
    select: (t) => {
      let {
        id: a,
        value: l,
        selected: i,
        children: o,
        parents: s
      } = t;
      a = Ye(a);
      const r = new Map(i), f = [a];
      for (; f.length; ) {
        const d = f.shift();
        i.set(d, l ? "on" : "off"), o.has(d) && f.push(...o.get(d));
      }
      let v = s.get(a);
      for (; v; ) {
        const d = o.get(v), c = d.every((g) => i.get(g) === "on"), m = d.every((g) => !i.has(g) || i.get(g) === "off");
        i.set(v, c ? "on" : m ? "off" : "indeterminate"), v = s.get(v);
      }
      return e && !l && Array.from(i.entries()).reduce((c, m) => {
        let [g, y] = m;
        return y === "on" ? [...c, g] : c;
      }, []).length === 0 ? r : i;
    },
    in: (t, a, l) => {
      let i = /* @__PURE__ */ new Map();
      for (const o of t || [])
        i = n.select({
          id: o,
          value: !0,
          selected: new Map(i),
          children: a,
          parents: l
        });
      return i;
    },
    out: (t, a) => {
      const l = [];
      for (const [i, o] of t.entries())
        o === "on" && !a.has(i) && l.push(i);
      return l;
    }
  };
  return n;
}, Ft = Symbol.for("vuetify:nested"), Li = {
  id: z(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: D(/* @__PURE__ */ new Map()),
    children: D(/* @__PURE__ */ new Map()),
    open: () => null,
    openOnSelect: () => null,
    select: () => null,
    opened: D(/* @__PURE__ */ new Set()),
    selected: D(/* @__PURE__ */ new Map()),
    selectedValues: D([])
  }
}, Cr = F({
  selectStrategy: [String, Function],
  openStrategy: [String, Object],
  opened: Array,
  selected: Array,
  mandatory: Boolean
}, "nested"), xr = (e) => {
  let n = !1;
  const t = D(/* @__PURE__ */ new Map()), a = D(/* @__PURE__ */ new Map()), l = oe(e, "opened", e.opened, (d) => new Set(d), (d) => [...d.values()]), i = h(() => {
    if (typeof e.selectStrategy == "object")
      return e.selectStrategy;
    switch (e.selectStrategy) {
      case "single-leaf":
        return Sr(e.mandatory);
      case "leaf":
        return br(e.mandatory);
      case "independent":
        return ga(e.mandatory);
      case "single-independent":
        return Fi(e.mandatory);
      case "classic":
      default:
        return wr(e.mandatory);
    }
  }), o = h(() => {
    if (typeof e.openStrategy == "object")
      return e.openStrategy;
    switch (e.openStrategy) {
      case "list":
        return yr;
      case "single":
        return hr;
      case "multiple":
      default:
        return $i;
    }
  }), s = oe(e, "selected", e.selected, (d) => i.value.in(d, t.value, a.value), (d) => i.value.out(d, t.value, a.value));
  Ie(() => {
    n = !0;
  });
  function r(d) {
    const c = [];
    let m = d;
    for (; m != null; )
      c.unshift(m), m = a.value.get(m);
    return c;
  }
  const f = fe("nested"), v = {
    id: z(),
    root: {
      opened: l,
      selected: s,
      selectedValues: h(() => {
        const d = [];
        for (const [c, m] of s.value.entries())
          m === "on" && d.push(c);
        return d;
      }),
      register: (d, c, m) => {
        c && d !== c && a.value.set(d, c), m && t.value.set(d, []), c != null && t.value.set(c, [...t.value.get(c) || [], d]);
      },
      unregister: (d) => {
        if (n)
          return;
        t.value.delete(d);
        const c = a.value.get(d);
        if (c) {
          const m = t.value.get(c) ?? [];
          t.value.set(c, m.filter((g) => g !== d));
        }
        a.value.delete(d), l.value.delete(d);
      },
      open: (d, c, m) => {
        f.emit("click:open", {
          id: d,
          value: c,
          path: r(d),
          event: m
        });
        const g = o.value.open({
          id: d,
          value: c,
          opened: new Set(l.value),
          children: t.value,
          parents: a.value,
          event: m
        });
        g && (l.value = g);
      },
      openOnSelect: (d, c, m) => {
        const g = o.value.select({
          id: d,
          value: c,
          selected: new Map(s.value),
          opened: new Set(l.value),
          children: t.value,
          parents: a.value,
          event: m
        });
        g && (l.value = g);
      },
      select: (d, c, m) => {
        f.emit("click:select", {
          id: d,
          value: c,
          path: r(d),
          event: m
        });
        const g = i.value.select({
          id: d,
          value: c,
          selected: new Map(s.value),
          children: t.value,
          parents: a.value,
          event: m
        });
        g && (s.value = g), v.root.openOnSelect(d, c, m);
      },
      children: t,
      parents: a
    }
  };
  return we(Ft, v), v.root;
}, Oi = (e, n) => {
  const t = ue(Ft, Li), a = Symbol(Be()), l = h(() => e.value !== void 0 ? e.value : a), i = {
    ...t,
    id: l,
    open: (o, s) => t.root.open(l.value, o, s),
    openOnSelect: (o, s) => t.root.openOnSelect(l.value, o, s),
    isOpen: h(() => t.root.opened.value.has(l.value)),
    parent: h(() => t.root.parents.value.get(l.value)),
    select: (o, s) => t.root.select(l.value, o, s),
    isSelected: h(() => t.root.selected.value.get(Ye(l.value)) === "on"),
    isIndeterminate: h(() => t.root.selected.value.get(l.value) === "indeterminate"),
    isLeaf: h(() => !t.root.children.value.get(l.value)),
    isGroupActivator: t.isGroupActivator
  };
  return !t.isGroupActivator && t.root.register(l.value, t.id.value, n), Ie(() => {
    !t.isGroupActivator && t.root.unregister(l.value);
  }), n && we(Ft, i), i;
}, pr = () => {
  const e = ue(Ft, Li);
  we(Ft, {
    ...e,
    isGroupActivator: !0
  });
}, kr = Ot({
  name: "VListGroupActivator",
  setup(e, n) {
    let {
      slots: t
    } = n;
    return pr(), () => {
      var a;
      return (a = t.default) == null ? void 0 : a.call(t);
    };
  }
}), Vr = F({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: re,
    default: "$collapse"
  },
  expandIcon: {
    type: re,
    default: "$expand"
  },
  prependIcon: re,
  appendIcon: re,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...ne(),
  ...ge()
}, "VListGroup"), nl = W()({
  name: "VListGroup",
  props: Vr(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      isOpen: a,
      open: l,
      id: i
    } = Oi(K(e, "value"), !0), o = h(() => `v-list-group--id-${String(i.value)}`), s = Bi(), {
      isBooted: r
    } = sa();
    function f(m) {
      l(!a.value, m);
    }
    const v = h(() => ({
      onClick: f,
      class: "v-list-group__header",
      id: o.value
    })), d = h(() => a.value ? e.collapseIcon : e.expandIcon), c = h(() => ({
      VListItem: {
        active: a.value,
        activeColor: e.activeColor,
        baseColor: e.baseColor,
        color: e.color,
        prependIcon: e.prependIcon || e.subgroup && d.value,
        appendIcon: e.appendIcon || !e.subgroup && d.value,
        title: e.title,
        value: e.value
      }
    }));
    return Z(() => u(e.tag, {
      class: ["v-list-group", {
        "v-list-group--prepend": s == null ? void 0 : s.hasPrepend.value,
        "v-list-group--fluid": e.fluid,
        "v-list-group--subgroup": e.subgroup,
        "v-list-group--open": a.value
      }, e.class],
      style: e.style
    }, {
      default: () => [t.activator && u(he, {
        defaults: c.value
      }, {
        default: () => [u(kr, null, {
          default: () => [t.activator({
            props: v.value,
            isOpen: a.value
          })]
        })]
      }), u(Ue, {
        transition: {
          component: Ul
        },
        disabled: !r.value
      }, {
        default: () => {
          var m;
          return [Ve(u("div", {
            class: "v-list-group__items",
            role: "group",
            "aria-labelledby": o.value
          }, [(m = t.default) == null ? void 0 : m.call(t)]), [[pt, a.value]])];
        }
      })]
    })), {};
  }
});
const Pr = Fl("v-list-item-subtitle"), Ir = Fl("v-list-item-title"), _r = F({
  active: {
    type: Boolean,
    default: void 0
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: re,
  baseColor: String,
  disabled: Boolean,
  lines: String,
  link: {
    type: Boolean,
    default: void 0
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: re,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  slim: Boolean,
  subtitle: [String, Number],
  title: [String, Number],
  value: null,
  onClick: De(),
  onClickOnce: De(),
  ...ct(),
  ...ne(),
  ...Ze(),
  ...Vt(),
  ...ft(),
  ...$e(),
  ...fa(),
  ...ge(),
  ...ve(),
  ...Qe({
    variant: "text"
  })
}, "VListItem"), Ct = W()({
  name: "VListItem",
  directives: {
    Ripple: hn
  },
  props: _r(),
  emits: {
    click: (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      slots: a,
      emit: l
    } = n;
    const i = da(e, t), o = h(() => e.value === void 0 ? i.href.value : e.value), {
      select: s,
      isSelected: r,
      isIndeterminate: f,
      isGroupActivator: v,
      root: d,
      parent: c,
      openOnSelect: m
    } = Oi(o, !1), g = Bi(), y = h(() => {
      var _;
      return e.active !== !1 && (e.active || ((_ = i.isActive) == null ? void 0 : _.value) || r.value);
    }), b = h(() => e.link !== !1 && i.isLink.value), w = h(() => !e.disabled && e.link !== !1 && (e.link || i.isClickable.value || e.value != null && !!g)), C = h(() => e.rounded || e.nav), V = h(() => e.color ?? e.activeColor), A = h(() => ({
      color: y.value ? V.value ?? e.baseColor : e.baseColor,
      variant: e.variant
    }));
    H(() => {
      var _;
      return (_ = i.isActive) == null ? void 0 : _.value;
    }, (_) => {
      _ && c.value != null && d.open(c.value, !0), _ && m(_);
    }, {
      immediate: !0
    });
    const {
      themeClasses: p
    } = be(e), {
      borderClasses: x
    } = dt(e), {
      colorClasses: S,
      colorStyles: P,
      variantClasses: k
    } = Rt(A), {
      densityClasses: I
    } = Je(e), {
      dimensionStyles: T
    } = Pt(e), {
      elevationClasses: $
    } = vt(e), {
      roundedClasses: E
    } = Fe(C), L = h(() => e.lines ? `v-list-item--${e.lines}-line` : void 0), N = h(() => ({
      isActive: y.value,
      select: s,
      isSelected: r.value,
      isIndeterminate: f.value
    }));
    function X(_) {
      var B;
      l("click", _), !(v || !w.value) && ((B = i.navigate) == null || B.call(i, _), e.value != null && s(!r.value, _));
    }
    function J(_) {
      (_.key === "Enter" || _.key === " ") && (_.preventDefault(), X(_));
    }
    return Z(() => {
      const _ = b.value ? "a" : e.tag, B = a.title || e.title != null, O = a.subtitle || e.subtitle != null, G = !!(e.appendAvatar || e.appendIcon), ee = !!(G || a.append), R = !!(e.prependAvatar || e.prependIcon), Y = !!(R || a.prepend);
      return g == null || g.updateHasPrepend(Y), e.activeColor && jo("active-color", ["color", "base-color"]), Ve(u(_, {
        class: ["v-list-item", {
          "v-list-item--active": y.value,
          "v-list-item--disabled": e.disabled,
          "v-list-item--link": w.value,
          "v-list-item--nav": e.nav,
          "v-list-item--prepend": !Y && (g == null ? void 0 : g.hasPrepend.value),
          "v-list-item--slim": e.slim,
          [`${e.activeClass}`]: e.activeClass && y.value
        }, p.value, x.value, S.value, I.value, $.value, L.value, E.value, k.value, e.class],
        style: [P.value, T.value, e.style],
        href: i.href.value,
        tabindex: w.value ? g ? -2 : 0 : void 0,
        onClick: X,
        onKeydown: w.value && !b.value && J
      }, {
        default: () => {
          var te;
          return [Mt(w.value || y.value, "v-list-item"), Y && u("div", {
            key: "prepend",
            class: "v-list-item__prepend"
          }, [a.prepend ? u(he, {
            key: "prepend-defaults",
            disabled: !R,
            defaults: {
              VAvatar: {
                density: e.density,
                image: e.prependAvatar
              },
              VIcon: {
                density: e.density,
                icon: e.prependIcon
              },
              VListItemAction: {
                start: !0
              }
            }
          }, {
            default: () => {
              var U;
              return [(U = a.prepend) == null ? void 0 : U.call(a, N.value)];
            }
          }) : u(ie, null, [e.prependAvatar && u(St, {
            key: "prepend-avatar",
            density: e.density,
            image: e.prependAvatar
          }, null), e.prependIcon && u(ye, {
            key: "prepend-icon",
            density: e.density,
            icon: e.prependIcon
          }, null)]), u("div", {
            class: "v-list-item__spacer"
          }, null)]), u("div", {
            class: "v-list-item__content",
            "data-no-activator": ""
          }, [B && u(Ir, {
            key: "title"
          }, {
            default: () => {
              var U;
              return [((U = a.title) == null ? void 0 : U.call(a, {
                title: e.title
              })) ?? e.title];
            }
          }), O && u(Pr, {
            key: "subtitle"
          }, {
            default: () => {
              var U;
              return [((U = a.subtitle) == null ? void 0 : U.call(a, {
                subtitle: e.subtitle
              })) ?? e.subtitle];
            }
          }), (te = a.default) == null ? void 0 : te.call(a, N.value)]), ee && u("div", {
            key: "append",
            class: "v-list-item__append"
          }, [a.append ? u(he, {
            key: "append-defaults",
            disabled: !G,
            defaults: {
              VAvatar: {
                density: e.density,
                image: e.appendAvatar
              },
              VIcon: {
                density: e.density,
                icon: e.appendIcon
              },
              VListItemAction: {
                end: !0
              }
            }
          }, {
            default: () => {
              var U;
              return [(U = a.append) == null ? void 0 : U.call(a, N.value)];
            }
          }) : u(ie, null, [e.appendIcon && u(ye, {
            key: "append-icon",
            density: e.density,
            icon: e.appendIcon
          }, null), e.appendAvatar && u(St, {
            key: "append-avatar",
            density: e.density,
            image: e.appendAvatar
          }, null)]), u("div", {
            class: "v-list-item__spacer"
          }, null)])];
        }
      }), [[qe("ripple"), w.value && e.ripple]]);
    }), {};
  }
}), Ar = F({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...ne(),
  ...ge()
}, "VListSubheader"), Tr = W()({
  name: "VListSubheader",
  props: Ar(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      textColorClasses: a,
      textColorStyles: l
    } = ze(K(e, "color"));
    return Z(() => {
      const i = !!(t.default || e.title);
      return u(e.tag, {
        class: ["v-list-subheader", {
          "v-list-subheader--inset": e.inset,
          "v-list-subheader--sticky": e.sticky
        }, a.value, e.class],
        style: [{
          textColorStyles: l
        }, e.style]
      }, {
        default: () => {
          var o;
          return [i && u("div", {
            class: "v-list-subheader__text"
          }, [((o = t.default) == null ? void 0 : o.call(t)) ?? e.title])];
        }
      });
    }), {};
  }
});
const Er = F({
  color: String,
  inset: Boolean,
  length: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...ne(),
  ...ve()
}, "VDivider"), Br = W()({
  name: "VDivider",
  props: Er(),
  setup(e, n) {
    let {
      attrs: t
    } = n;
    const {
      themeClasses: a
    } = be(e), {
      textColorClasses: l,
      textColorStyles: i
    } = ze(K(e, "color")), o = h(() => {
      const s = {};
      return e.length && (s[e.vertical ? "maxHeight" : "maxWidth"] = j(e.length)), e.thickness && (s[e.vertical ? "borderRightWidth" : "borderTopWidth"] = j(e.thickness)), s;
    });
    return Z(() => u("hr", {
      class: [{
        "v-divider": !0,
        "v-divider--inset": e.inset,
        "v-divider--vertical": e.vertical
      }, a.value, l.value, e.class],
      style: [o.value, i.value, e.style],
      "aria-orientation": !t.role || t.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
      role: `${t.role || "separator"}`
    }, null)), {};
  }
}), $r = F({
  items: Array,
  returnObject: Boolean
}, "VListChildren"), Mi = W()({
  name: "VListChildren",
  props: $r(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return Ei(), () => {
      var a, l;
      return ((a = t.default) == null ? void 0 : a.call(t)) ?? ((l = e.items) == null ? void 0 : l.map((i) => {
        var c, m;
        let {
          children: o,
          props: s,
          type: r,
          raw: f
        } = i;
        if (r === "divider")
          return ((c = t.divider) == null ? void 0 : c.call(t, {
            props: s
          })) ?? u(Br, s, null);
        if (r === "subheader")
          return ((m = t.subheader) == null ? void 0 : m.call(t, {
            props: s
          })) ?? u(Tr, s, null);
        const v = {
          subtitle: t.subtitle ? (g) => {
            var y;
            return (y = t.subtitle) == null ? void 0 : y.call(t, {
              ...g,
              item: f
            });
          } : void 0,
          prepend: t.prepend ? (g) => {
            var y;
            return (y = t.prepend) == null ? void 0 : y.call(t, {
              ...g,
              item: f
            });
          } : void 0,
          append: t.append ? (g) => {
            var y;
            return (y = t.append) == null ? void 0 : y.call(t, {
              ...g,
              item: f
            });
          } : void 0,
          title: t.title ? (g) => {
            var y;
            return (y = t.title) == null ? void 0 : y.call(t, {
              ...g,
              item: f
            });
          } : void 0
        }, d = nl.filterProps(s);
        return o ? u(nl, q({
          value: s == null ? void 0 : s.value
        }, d), {
          activator: (g) => {
            let {
              props: y
            } = g;
            const b = {
              ...s,
              ...y,
              value: e.returnObject ? f : s.value
            };
            return t.header ? t.header({
              props: b
            }) : u(Ct, b, v);
          },
          default: () => u(Mi, {
            items: o
          }, t)
        }) : t.item ? t.item({
          props: s
        }) : u(Ct, q(s, {
          value: e.returnObject ? f : s.value
        }), v);
      }));
    };
  }
}), Ri = F({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean,
  valueComparator: {
    type: Function,
    default: kt
  }
}, "list-items");
function Hn(e, n) {
  const t = Oe(n, e.itemTitle, n), a = Oe(n, e.itemValue, t), l = Oe(n, e.itemChildren), i = e.itemProps === !0 ? typeof n == "object" && n != null && !Array.isArray(n) ? "children" in n ? Xe(n, ["children"]) : n : void 0 : Oe(n, e.itemProps), o = {
    title: t,
    value: a,
    ...i
  };
  return {
    title: String(o.title ?? ""),
    value: o.value,
    props: o,
    children: Array.isArray(l) ? Di(e, l) : void 0,
    raw: n
  };
}
function Di(e, n) {
  const t = [];
  for (const a of n)
    t.push(Hn(e, a));
  return t;
}
function Ni(e) {
  const n = h(() => Di(e, e.items)), t = h(() => n.value.some((i) => i.value === null));
  function a(i) {
    return t.value || (i = i.filter((o) => o !== null)), i.map((o) => e.returnObject && typeof o == "string" ? Hn(e, o) : n.value.find((s) => e.valueComparator(o, s.value)) || Hn(e, o));
  }
  function l(i) {
    return e.returnObject ? i.map((o) => {
      let {
        raw: s
      } = o;
      return s;
    }) : i.map((o) => {
      let {
        value: s
      } = o;
      return s;
    });
  }
  return {
    items: n,
    transformIn: a,
    transformOut: l
  };
}
function Fr(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean";
}
function Lr(e, n) {
  const t = Oe(n, e.itemType, "item"), a = Fr(n) ? n : Oe(n, e.itemTitle), l = Oe(n, e.itemValue, void 0), i = Oe(n, e.itemChildren), o = e.itemProps === !0 ? Xe(n, ["children"]) : Oe(n, e.itemProps), s = {
    title: a,
    value: l,
    ...o
  };
  return {
    type: t,
    title: s.title,
    value: s.value,
    props: s,
    children: t === "item" && i ? zi(e, i) : void 0,
    raw: n
  };
}
function zi(e, n) {
  const t = [];
  for (const a of n)
    t.push(Lr(e, a));
  return t;
}
function Or(e) {
  return {
    items: h(() => zi(e, e.items))
  };
}
const Mr = F({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  nav: Boolean,
  ...Cr({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...ct(),
  ...ne(),
  ...Ze(),
  ...Vt(),
  ...ft(),
  itemType: {
    type: String,
    default: "type"
  },
  ...Ri(),
  ...$e(),
  ...ge(),
  ...ve(),
  ...Qe({
    variant: "text"
  })
}, "VList"), Hi = W()({
  name: "VList",
  props: Mr(),
  emits: {
    "update:selected": (e) => !0,
    "update:opened": (e) => !0,
    "click:open": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      items: a
    } = Or(e), {
      themeClasses: l
    } = be(e), {
      backgroundColorClasses: i,
      backgroundColorStyles: o
    } = We(K(e, "bgColor")), {
      borderClasses: s
    } = dt(e), {
      densityClasses: r
    } = Je(e), {
      dimensionStyles: f
    } = Pt(e), {
      elevationClasses: v
    } = vt(e), {
      roundedClasses: d
    } = Fe(e), {
      open: c,
      select: m
    } = xr(e), g = h(() => e.lines ? `v-list--${e.lines}-line` : void 0), y = K(e, "activeColor"), b = K(e, "baseColor"), w = K(e, "color");
    Ei(), ut({
      VListGroup: {
        activeColor: y,
        baseColor: b,
        color: w
      },
      VListItem: {
        activeClass: K(e, "activeClass"),
        activeColor: y,
        baseColor: b,
        color: w,
        density: K(e, "density"),
        disabled: K(e, "disabled"),
        lines: K(e, "lines"),
        nav: K(e, "nav"),
        slim: K(e, "slim"),
        variant: K(e, "variant")
      }
    });
    const C = z(!1), V = D();
    function A(I) {
      C.value = !0;
    }
    function p(I) {
      C.value = !1;
    }
    function x(I) {
      var T;
      !C.value && !(I.relatedTarget && ((T = V.value) != null && T.contains(I.relatedTarget))) && k();
    }
    function S(I) {
      if (V.value) {
        if (I.key === "ArrowDown")
          k("next");
        else if (I.key === "ArrowUp")
          k("prev");
        else if (I.key === "Home")
          k("first");
        else if (I.key === "End")
          k("last");
        else
          return;
        I.preventDefault();
      }
    }
    function P(I) {
      C.value = !0;
    }
    function k(I) {
      if (V.value)
        return Jt(V.value, I);
    }
    return Z(() => u(e.tag, {
      ref: V,
      class: ["v-list", {
        "v-list--disabled": e.disabled,
        "v-list--nav": e.nav,
        "v-list--slim": e.slim
      }, l.value, i.value, s.value, r.value, v.value, g.value, d.value, e.class],
      style: [o.value, f.value, e.style],
      tabindex: e.disabled || C.value ? -1 : 0,
      role: "listbox",
      "aria-activedescendant": void 0,
      onFocusin: A,
      onFocusout: p,
      onFocus: x,
      onKeydown: S,
      onMousedown: P
    }, {
      default: () => [u(Mi, {
        items: a.value,
        returnObject: e.returnObject
      }, t)]
    })), {
      open: c,
      select: m,
      focus: k
    };
  }
});
function Vn(e, n) {
  return {
    x: e.x + n.x,
    y: e.y + n.y
  };
}
function Rr(e, n) {
  return {
    x: e.x - n.x,
    y: e.y - n.y
  };
}
function al(e, n) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: t,
      align: a
    } = e, l = a === "left" ? 0 : a === "center" ? n.width / 2 : a === "right" ? n.width : a, i = t === "top" ? 0 : t === "bottom" ? n.height : t;
    return Vn({
      x: l,
      y: i
    }, n);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: t,
      align: a
    } = e, l = t === "left" ? 0 : t === "right" ? n.width : t, i = a === "top" ? 0 : a === "center" ? n.height / 2 : a === "bottom" ? n.height : a;
    return Vn({
      x: l,
      y: i
    }, n);
  }
  return Vn({
    x: n.width / 2,
    y: n.height / 2
  }, n);
}
const ji = {
  static: zr,
  // specific viewport position, usually centered
  connected: jr
  // connected to a certain element
}, Dr = F({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in ji
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function Nr(e, n) {
  const t = D({}), a = D();
  se && Ne(() => !!(n.isActive.value && e.locationStrategy), (i) => {
    var o, s;
    H(() => e.locationStrategy, i), Ce(() => {
      window.removeEventListener("resize", l), a.value = void 0;
    }), window.addEventListener("resize", l, {
      passive: !0
    }), typeof e.locationStrategy == "function" ? a.value = (o = e.locationStrategy(n, e, t)) == null ? void 0 : o.updateLocation : a.value = (s = ji[e.locationStrategy](n, e, t)) == null ? void 0 : s.updateLocation;
  });
  function l(i) {
    var o;
    (o = a.value) == null || o.call(a, i);
  }
  return {
    contentStyles: t,
    updateLocation: a
  };
}
function zr() {
}
function Hr(e, n) {
  n ? e.style.removeProperty("left") : e.style.removeProperty("right");
  const t = ta(e);
  return n ? t.x += parseFloat(e.style.right || 0) : t.x -= parseFloat(e.style.left || 0), t.y -= parseFloat(e.style.top || 0), t;
}
function jr(e, n, t) {
  (Array.isArray(e.target.value) || us(e.target.value)) && Object.assign(t.value, {
    position: "fixed",
    top: 0,
    [e.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: l,
    preferredOrigin: i
  } = Qn(() => {
    const g = $n(n.location, e.isRtl.value), y = n.origin === "overlap" ? g : n.origin === "auto" ? Cn(g) : $n(n.origin, e.isRtl.value);
    return g.side === y.side && g.align === xn(y).align ? {
      preferredAnchor: Ta(g),
      preferredOrigin: Ta(y)
    } : {
      preferredAnchor: g,
      preferredOrigin: y
    };
  }), [o, s, r, f] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((g) => h(() => {
    const y = parseFloat(n[g]);
    return isNaN(y) ? 1 / 0 : y;
  })), v = h(() => {
    if (Array.isArray(n.offset))
      return n.offset;
    if (typeof n.offset == "string") {
      const g = n.offset.split(" ").map(parseFloat);
      return g.length < 2 && g.push(0), g;
    }
    return typeof n.offset == "number" ? [n.offset, 0] : [0, 0];
  });
  let d = !1;
  const c = new ResizeObserver(() => {
    d && m();
  });
  H([e.target, e.contentEl], (g, y) => {
    let [b, w] = g, [C, V] = y;
    C && !Array.isArray(C) && c.unobserve(C), b && !Array.isArray(b) && c.observe(b), V && c.unobserve(V), w && c.observe(w);
  }, {
    immediate: !0
  }), Ce(() => {
    c.disconnect();
  });
  function m() {
    if (d = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => d = !0);
    }), !e.target.value || !e.contentEl.value)
      return;
    const g = Pl(e.target.value), y = Hr(e.contentEl.value, e.isRtl.value), b = nn(e.contentEl.value), w = 12;
    b.length || (b.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (y.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), y.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const C = b.reduce((T, $) => {
      const E = $.getBoundingClientRect(), L = new ot({
        x: $ === document.documentElement ? 0 : E.x,
        y: $ === document.documentElement ? 0 : E.y,
        width: $.clientWidth,
        height: $.clientHeight
      });
      return T ? new ot({
        x: Math.max(T.left, L.left),
        y: Math.max(T.top, L.top),
        width: Math.min(T.right, L.right) - Math.max(T.left, L.left),
        height: Math.min(T.bottom, L.bottom) - Math.max(T.top, L.top)
      }) : L;
    }, void 0);
    C.x += w, C.y += w, C.width -= w * 2, C.height -= w * 2;
    let V = {
      anchor: l.value,
      origin: i.value
    };
    function A(T) {
      const $ = new ot(y), E = al(T.anchor, g), L = al(T.origin, $);
      let {
        x: N,
        y: X
      } = Rr(E, L);
      switch (T.anchor.side) {
        case "top":
          X -= v.value[0];
          break;
        case "bottom":
          X += v.value[0];
          break;
        case "left":
          N -= v.value[0];
          break;
        case "right":
          N += v.value[0];
          break;
      }
      switch (T.anchor.align) {
        case "top":
          X -= v.value[1];
          break;
        case "bottom":
          X += v.value[1];
          break;
        case "left":
          N -= v.value[1];
          break;
        case "right":
          N += v.value[1];
          break;
      }
      return $.x += N, $.y += X, $.width = Math.min($.width, r.value), $.height = Math.min($.height, f.value), {
        overflows: Ba($, C),
        x: N,
        y: X
      };
    }
    let p = 0, x = 0;
    const S = {
      x: 0,
      y: 0
    }, P = {
      x: !1,
      y: !1
    };
    let k = -1;
    for (; ; ) {
      if (k++ > 10) {
        Ln("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: T,
        y: $,
        overflows: E
      } = A(V);
      p += T, x += $, y.x += T, y.y += $;
      {
        const L = Ea(V.anchor), N = E.x.before || E.x.after, X = E.y.before || E.y.after;
        let J = !1;
        if (["x", "y"].forEach((_) => {
          if (_ === "x" && N && !P.x || _ === "y" && X && !P.y) {
            const B = {
              anchor: {
                ...V.anchor
              },
              origin: {
                ...V.origin
              }
            }, O = _ === "x" ? L === "y" ? xn : Cn : L === "y" ? Cn : xn;
            B.anchor = O(B.anchor), B.origin = O(B.origin);
            const {
              overflows: G
            } = A(B);
            (G[_].before <= E[_].before && G[_].after <= E[_].after || G[_].before + G[_].after < (E[_].before + E[_].after) / 2) && (V = B, J = P[_] = !0);
          }
        }), J)
          continue;
      }
      E.x.before && (p += E.x.before, y.x += E.x.before), E.x.after && (p -= E.x.after, y.x -= E.x.after), E.y.before && (x += E.y.before, y.y += E.y.before), E.y.after && (x -= E.y.after, y.y -= E.y.after);
      {
        const L = Ba(y, C);
        S.x = C.width - L.x.before - L.x.after, S.y = C.height - L.y.before - L.y.after, p += L.x.before, y.x += L.x.before, x += L.y.before, y.y += L.y.before;
      }
      break;
    }
    const I = Ea(V.anchor);
    return Object.assign(t.value, {
      "--v-overlay-anchor-origin": `${V.anchor.side} ${V.anchor.align}`,
      transformOrigin: `${V.origin.side} ${V.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: j(Pn(x)),
      left: e.isRtl.value ? void 0 : j(Pn(p)),
      right: e.isRtl.value ? j(Pn(-p)) : void 0,
      minWidth: j(I === "y" ? Math.min(o.value, g.width) : o.value),
      maxWidth: j(ll(lt(S.x, o.value === 1 / 0 ? 0 : o.value, r.value))),
      maxHeight: j(ll(lt(S.y, s.value === 1 / 0 ? 0 : s.value, f.value)))
    }), {
      available: S,
      contentBox: y
    };
  }
  return H(() => [l.value, i.value, n.offset, n.minWidth, n.minHeight, n.maxWidth, n.maxHeight], () => m()), de(() => {
    const g = m();
    if (!g)
      return;
    const {
      available: y,
      contentBox: b
    } = g;
    b.height > y.y && requestAnimationFrame(() => {
      m(), requestAnimationFrame(() => {
        m();
      });
    });
  }), {
    updateLocation: m
  };
}
function Pn(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function ll(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let jn = !0;
const rn = [];
function Wr(e) {
  !jn || rn.length ? (rn.push(e), Wn()) : (jn = !1, e(), Wn());
}
let il = -1;
function Wn() {
  cancelAnimationFrame(il), il = requestAnimationFrame(() => {
    const e = rn.shift();
    e && e(), rn.length ? Wn() : jn = !0;
  });
}
const Xt = {
  none: null,
  close: Kr,
  block: Yr,
  reposition: qr
}, Gr = F({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in Xt
  }
}, "VOverlay-scroll-strategies");
function Ur(e, n) {
  if (!se)
    return;
  let t;
  Te(async () => {
    t == null || t.stop(), n.isActive.value && e.scrollStrategy && (t = qn(), await de(), t.active && t.run(() => {
      var a;
      typeof e.scrollStrategy == "function" ? e.scrollStrategy(n, e, t) : (a = Xt[e.scrollStrategy]) == null || a.call(Xt, n, e, t);
    }));
  }), Ce(() => {
    t == null || t.stop();
  });
}
function Kr(e) {
  function n(t) {
    e.isActive.value = !1;
  }
  Wi(e.targetEl.value ?? e.contentEl.value, n);
}
function Yr(e, n) {
  var o;
  const t = (o = e.root.value) == null ? void 0 : o.offsetParent, a = [.../* @__PURE__ */ new Set([...nn(e.targetEl.value, n.contained ? t : void 0), ...nn(e.contentEl.value, n.contained ? t : void 0)])].filter((s) => !s.classList.contains("v-overlay-scroll-blocked")), l = window.innerWidth - document.documentElement.offsetWidth, i = ((s) => la(s) && s)(t || document.documentElement);
  i && e.root.value.classList.add("v-overlay--scroll-blocked"), a.forEach((s, r) => {
    s.style.setProperty("--v-body-scroll-x", j(-s.scrollLeft)), s.style.setProperty("--v-body-scroll-y", j(-s.scrollTop)), s !== document.documentElement && s.style.setProperty("--v-scrollbar-offset", j(l)), s.classList.add("v-overlay-scroll-blocked");
  }), Ce(() => {
    a.forEach((s, r) => {
      const f = parseFloat(s.style.getPropertyValue("--v-body-scroll-x")), v = parseFloat(s.style.getPropertyValue("--v-body-scroll-y"));
      s.style.removeProperty("--v-body-scroll-x"), s.style.removeProperty("--v-body-scroll-y"), s.style.removeProperty("--v-scrollbar-offset"), s.classList.remove("v-overlay-scroll-blocked"), s.scrollLeft = -f, s.scrollTop = -v;
    }), i && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function qr(e, n, t) {
  let a = !1, l = -1, i = -1;
  function o(s) {
    Wr(() => {
      var v, d;
      const r = performance.now();
      (d = (v = e.updateLocation).value) == null || d.call(v, s), a = (performance.now() - r) / (1e3 / 60) > 2;
    });
  }
  i = (typeof requestIdleCallback > "u" ? (s) => s() : requestIdleCallback)(() => {
    t.run(() => {
      Wi(e.targetEl.value ?? e.contentEl.value, (s) => {
        a ? (cancelAnimationFrame(l), l = requestAnimationFrame(() => {
          l = requestAnimationFrame(() => {
            o(s);
          });
        })) : o(s);
      });
    });
  }), Ce(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(i), cancelAnimationFrame(l);
  });
}
function Wi(e, n) {
  const t = [document, ...nn(e)];
  t.forEach((a) => {
    a.addEventListener("scroll", n, {
      passive: !0
    });
  }), Ce(() => {
    t.forEach((a) => {
      a.removeEventListener("scroll", n);
    });
  });
}
const Gn = Symbol.for("vuetify:v-menu"), Xr = F({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function Zr(e, n) {
  let t = () => {
  };
  function a(o) {
    t == null || t();
    const s = Number(o ? e.openDelay : e.closeDelay);
    return new Promise((r) => {
      t = Bo(s, () => {
        n == null || n(o), r(o);
      });
    });
  }
  function l() {
    return a(!0);
  }
  function i() {
    return a(!1);
  }
  return {
    clearDelay: t,
    runOpenDelay: l,
    runCloseDelay: i
  };
}
const Jr = F({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...Xr()
}, "VOverlay-activator");
function Qr(e, n) {
  let {
    isActive: t,
    isTop: a
  } = n;
  const l = fe("useActivator"), i = D();
  let o = !1, s = !1, r = !0;
  const f = h(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), v = h(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !f.value), {
    runOpenDelay: d,
    runCloseDelay: c
  } = Zr(e, (S) => {
    S === (e.openOnHover && o || f.value && s) && !(e.openOnHover && t.value && !a.value) && (t.value !== S && (r = !0), t.value = S);
  }), m = D(), g = {
    onClick: (S) => {
      S.stopPropagation(), i.value = S.currentTarget || S.target, t.value || (m.value = [S.clientX, S.clientY]), t.value = !t.value;
    },
    onMouseenter: (S) => {
      var P;
      (P = S.sourceCapabilities) != null && P.firesTouchEvents || (o = !0, i.value = S.currentTarget || S.target, d());
    },
    onMouseleave: (S) => {
      o = !1, c();
    },
    onFocus: (S) => {
      bt(S.target, ":focus-visible") !== !1 && (s = !0, S.stopPropagation(), i.value = S.currentTarget || S.target, d());
    },
    onBlur: (S) => {
      s = !1, S.stopPropagation(), c();
    }
  }, y = h(() => {
    const S = {};
    return v.value && (S.onClick = g.onClick), e.openOnHover && (S.onMouseenter = g.onMouseenter, S.onMouseleave = g.onMouseleave), f.value && (S.onFocus = g.onFocus, S.onBlur = g.onBlur), S;
  }), b = h(() => {
    const S = {};
    if (e.openOnHover && (S.onMouseenter = () => {
      o = !0, d();
    }, S.onMouseleave = () => {
      o = !1, c();
    }), f.value && (S.onFocusin = () => {
      s = !0, d();
    }, S.onFocusout = () => {
      s = !1, c();
    }), e.closeOnContentClick) {
      const P = ue(Gn, null);
      S.onClick = () => {
        t.value = !1, P == null || P.closeParents();
      };
    }
    return S;
  }), w = h(() => {
    const S = {};
    return e.openOnHover && (S.onMouseenter = () => {
      r && (o = !0, r = !1, d());
    }, S.onMouseleave = () => {
      o = !1, c();
    }), S;
  });
  H(a, (S) => {
    S && (e.openOnHover && !o && (!f.value || !s) || f.value && !s && (!e.openOnHover || !o)) && (t.value = !1);
  }), H(t, (S) => {
    S || setTimeout(() => {
      m.value = void 0;
    });
  }, {
    flush: "post"
  });
  const C = D();
  Te(() => {
    C.value && de(() => {
      i.value = Et(C.value);
    });
  });
  const V = D(), A = h(() => e.target === "cursor" && m.value ? m.value : V.value ? Et(V.value) : Gi(e.target, l) || i.value), p = h(() => Array.isArray(A.value) ? void 0 : A.value);
  let x;
  return H(() => !!e.activator, (S) => {
    S && se ? (x = qn(), x.run(() => {
      eu(e, l, {
        activatorEl: i,
        activatorEvents: y
      });
    })) : x && x.stop();
  }, {
    flush: "post",
    immediate: !0
  }), Ce(() => {
    x == null || x.stop();
  }), {
    activatorEl: i,
    activatorRef: C,
    target: A,
    targetEl: p,
    targetRef: V,
    activatorEvents: y,
    contentEvents: b,
    scrimEvents: w
  };
}
function eu(e, n, t) {
  let {
    activatorEl: a,
    activatorEvents: l
  } = t;
  H(() => e.activator, (r, f) => {
    if (f && r !== f) {
      const v = s(f);
      v && o(v);
    }
    r && de(() => i());
  }, {
    immediate: !0
  }), H(() => e.activatorProps, () => {
    i();
  }), Ce(() => {
    o();
  });
  function i() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s(), f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    r && Fo(r, q(l.value, f));
  }
  function o() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s(), f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    r && Lo(r, q(l.value, f));
  }
  function s() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator;
    const f = Gi(r, n);
    return a.value = (f == null ? void 0 : f.nodeType) === Node.ELEMENT_NODE ? f : void 0, a.value;
  }
}
function Gi(e, n) {
  var a, l;
  if (!e)
    return;
  let t;
  if (e === "parent") {
    let i = (l = (a = n == null ? void 0 : n.proxy) == null ? void 0 : a.$el) == null ? void 0 : l.parentNode;
    for (; i != null && i.hasAttribute("data-no-activator"); )
      i = i.parentNode;
    t = i;
  } else
    typeof e == "string" ? t = document.querySelector(e) : "$el" in e ? t = e.$el : t = e;
  return t;
}
const tu = ["sm", "md", "lg", "xl", "xxl"], nu = Symbol.for("vuetify:display"), ol = {
  mobileBreakpoint: "lg",
  thresholds: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
  }
}, au = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ol;
  return Me(ol, e);
};
function sl(e) {
  return se && !e ? window.innerWidth : typeof e == "object" && e.clientWidth || 0;
}
function rl(e) {
  return se && !e ? window.innerHeight : typeof e == "object" && e.clientHeight || 0;
}
function ul(e) {
  const n = se && !e ? window.navigator.userAgent : "ssr";
  function t(g) {
    return Boolean(n.match(g));
  }
  const a = t(/android/i), l = t(/iphone|ipad|ipod/i), i = t(/cordova/i), o = t(/electron/i), s = t(/chrome/i), r = t(/edge/i), f = t(/firefox/i), v = t(/opera/i), d = t(/win/i), c = t(/mac/i), m = t(/linux/i);
  return {
    android: a,
    ios: l,
    cordova: i,
    electron: o,
    chrome: s,
    edge: r,
    firefox: f,
    opera: v,
    win: d,
    mac: c,
    linux: m,
    touch: wo,
    ssr: n === "ssr"
  };
}
function jc(e, n) {
  const {
    thresholds: t,
    mobileBreakpoint: a
  } = au(e), l = z(rl(n)), i = z(ul(n)), o = Le({}), s = z(sl(n));
  function r() {
    l.value = rl(), s.value = sl();
  }
  function f() {
    r(), i.value = ul();
  }
  return Te(() => {
    const v = s.value < t.sm, d = s.value < t.md && !v, c = s.value < t.lg && !(d || v), m = s.value < t.xl && !(c || d || v), g = s.value < t.xxl && !(m || c || d || v), y = s.value >= t.xxl, b = v ? "xs" : d ? "sm" : c ? "md" : m ? "lg" : g ? "xl" : "xxl", w = typeof a == "number" ? a : t[a], C = s.value < w;
    o.xs = v, o.sm = d, o.md = c, o.lg = m, o.xl = g, o.xxl = y, o.smAndUp = !v, o.mdAndUp = !(v || d), o.lgAndUp = !(v || d || c), o.xlAndUp = !(v || d || c || m), o.smAndDown = !(c || m || g || y), o.mdAndDown = !(m || g || y), o.lgAndDown = !(g || y), o.xlAndDown = !y, o.name = b, o.height = l.value, o.width = s.value, o.mobile = C, o.mobileBreakpoint = a, o.platform = i.value, o.thresholds = t;
  }), se && window.addEventListener("resize", r, {
    passive: !0
  }), {
    ...Un(o),
    update: f,
    ssr: !!n
  };
}
const lu = F({
  mobileBreakpoint: [Number, String]
}, "display");
function ha() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : je();
  const t = ue(nu);
  if (!t)
    throw new Error("Could not find Vuetify display injection");
  const a = h(() => {
    if (!e.mobileBreakpoint)
      return t.mobile.value;
    const i = typeof e.mobileBreakpoint == "number" ? e.mobileBreakpoint : t.thresholds.value[e.mobileBreakpoint];
    return t.width.value < i;
  }), l = h(() => n ? {
    [`${n}--mobile`]: a.value
  } : {});
  return {
    ...t,
    displayClasses: l,
    mobile: a
  };
}
function iu() {
  if (!se)
    return z(!1);
  const {
    ssr: e
  } = ha();
  if (e) {
    const n = z(!1);
    return He(() => {
      n.value = !0;
    }), n;
  } else
    return z(!0);
}
const ou = F({
  eager: Boolean
}, "lazy");
function su(e, n) {
  const t = z(!1), a = h(() => t.value || e.eager || n.value);
  H(n, () => t.value = !0);
  function l() {
    e.eager || (t.value = !1);
  }
  return {
    isBooted: t,
    hasContent: a,
    onAfterLeave: l
  };
}
function Sn() {
  const n = fe("useScopeId").vnode.scopeId;
  return {
    scopeId: n ? {
      [n]: ""
    } : void 0
  };
}
const cl = Symbol.for("vuetify:stack"), At = Le([]);
function ru(e, n, t) {
  const a = fe("useStack"), l = !t, i = ue(cl, void 0), o = Le({
    activeChildren: /* @__PURE__ */ new Set()
  });
  we(cl, o);
  const s = z(+n.value);
  Ne(e, () => {
    var d;
    const v = (d = At.at(-1)) == null ? void 0 : d[1];
    s.value = v ? v + 10 : +n.value, l && At.push([a.uid, s.value]), i == null || i.activeChildren.add(a.uid), Ce(() => {
      if (l) {
        const c = Ye(At).findIndex((m) => m[0] === a.uid);
        At.splice(c, 1);
      }
      i == null || i.activeChildren.delete(a.uid);
    });
  });
  const r = z(!0);
  l && Te(() => {
    var d;
    const v = ((d = At.at(-1)) == null ? void 0 : d[0]) === a.uid;
    setTimeout(() => r.value = v);
  });
  const f = h(() => !o.activeChildren.size);
  return {
    globalTop: Yn(r),
    localTop: f,
    stackStyles: h(() => ({
      zIndex: s.value
    }))
  };
}
function uu(e) {
  return {
    teleportTarget: h(() => {
      const t = e.value;
      if (t === !0 || !se)
        return;
      const a = t === !1 ? document.body : typeof t == "string" ? document.querySelector(t) : t;
      if (a == null) {
        dn(`Unable to locate target ${t}`);
        return;
      }
      let l = a.querySelector(":scope > .v-overlay-container");
      return l || (l = document.createElement("div"), l.className = "v-overlay-container", a.appendChild(l)), l;
    })
  };
}
function cu() {
  return !0;
}
function Ui(e, n, t) {
  if (!e || Ki(e, t) === !1)
    return !1;
  const a = Ll(n);
  if (typeof ShadowRoot < "u" && a instanceof ShadowRoot && a.host === e.target)
    return !1;
  const l = (typeof t.value == "object" && t.value.include || (() => []))();
  return l.push(n), !l.some((i) => i == null ? void 0 : i.contains(e.target));
}
function Ki(e, n) {
  return (typeof n.value == "object" && n.value.closeConditional || cu)(e);
}
function du(e, n, t) {
  const a = typeof t.value == "function" ? t.value : t.value.handler;
  n._clickOutside.lastMousedownWasOutside && Ui(e, n, t) && setTimeout(() => {
    Ki(e, t) && a && a(e);
  }, 0);
}
function dl(e, n) {
  const t = Ll(e);
  n(document), typeof ShadowRoot < "u" && t instanceof ShadowRoot && n(t);
}
const fu = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, n) {
    const t = (l) => du(l, e, n), a = (l) => {
      e._clickOutside.lastMousedownWasOutside = Ui(l, e, n);
    };
    dl(e, (l) => {
      l.addEventListener("click", t, !0), l.addEventListener("mousedown", a, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !1
    }), e._clickOutside[n.instance.$.uid] = {
      onClick: t,
      onMousedown: a
    };
  },
  unmounted(e, n) {
    e._clickOutside && (dl(e, (t) => {
      var i;
      if (!t || !((i = e._clickOutside) != null && i[n.instance.$.uid]))
        return;
      const {
        onClick: a,
        onMousedown: l
      } = e._clickOutside[n.instance.$.uid];
      t.removeEventListener("click", a, !0), t.removeEventListener("mousedown", l, !0);
    }), delete e._clickOutside[n.instance.$.uid]);
  }
};
function vu(e) {
  const {
    modelValue: n,
    color: t,
    ...a
  } = e;
  return u(Ke, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && u("div", q({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, a), null)]
  });
}
const ya = F({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...Jr(),
  ...ne(),
  ...Vt(),
  ...ou(),
  ...Dr(),
  ...Gr(),
  ...ve(),
  ...It()
}, "VOverlay"), un = W()({
  name: "VOverlay",
  directives: {
    ClickOutside: fu
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...ya()
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    afterLeave: () => !0
  },
  setup(e, n) {
    let {
      slots: t,
      attrs: a,
      emit: l
    } = n;
    const i = oe(e, "modelValue"), o = h({
      get: () => i.value,
      set: (R) => {
        R && e.disabled || (i.value = R);
      }
    }), {
      teleportTarget: s
    } = uu(h(() => e.attach || e.contained)), {
      themeClasses: r
    } = be(e), {
      rtlClasses: f,
      isRtl: v
    } = Ge(), {
      hasContent: d,
      onAfterLeave: c
    } = su(e, o), m = We(h(() => typeof e.scrim == "string" ? e.scrim : null)), {
      globalTop: g,
      localTop: y,
      stackStyles: b
    } = ru(o, K(e, "zIndex"), e._disableGlobalStack), {
      activatorEl: w,
      activatorRef: C,
      target: V,
      targetEl: A,
      targetRef: p,
      activatorEvents: x,
      contentEvents: S,
      scrimEvents: P
    } = Qr(e, {
      isActive: o,
      isTop: y
    }), {
      dimensionStyles: k
    } = Pt(e), I = iu(), {
      scopeId: T
    } = Sn();
    H(() => e.disabled, (R) => {
      R && (o.value = !1);
    });
    const $ = D(), E = D(), {
      contentStyles: L,
      updateLocation: N
    } = Nr(e, {
      isRtl: v,
      contentEl: E,
      target: V,
      isActive: o
    });
    Ur(e, {
      root: $,
      contentEl: E,
      targetEl: A,
      isActive: o,
      updateLocation: N
    });
    function X(R) {
      l("click:outside", R), e.persistent ? G() : o.value = !1;
    }
    function J() {
      return o.value && g.value;
    }
    se && H(o, (R) => {
      R ? window.addEventListener("keydown", _) : window.removeEventListener("keydown", _);
    }, {
      immediate: !0
    }), Ie(() => {
      se && window.removeEventListener("keydown", _);
    });
    function _(R) {
      var Y, te;
      R.key === "Escape" && g.value && (e.persistent ? G() : (o.value = !1, (Y = E.value) != null && Y.contains(document.activeElement) && ((te = w.value) == null || te.focus())));
    }
    const B = vi();
    Ne(() => e.closeOnBack, () => {
      Zs(B, (R) => {
        g.value && o.value ? (R(!1), e.persistent ? G() : o.value = !1) : R();
      });
    });
    const O = D();
    H(() => o.value && (e.absolute || e.contained) && s.value == null, (R) => {
      if (R) {
        const Y = Ml($.value);
        Y && Y !== document.scrollingElement && (O.value = Y.scrollTop);
      }
    });
    function G() {
      e.noClickAnimation || E.value && yt(E.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: tn
      });
    }
    function ee() {
      c(), l("afterLeave");
    }
    return Z(() => {
      var R;
      return u(ie, null, [(R = t.activator) == null ? void 0 : R.call(t, {
        isActive: o.value,
        props: q({
          ref: C,
          targetRef: p
        }, x.value, e.activatorProps)
      }), !e.disabled && I.value && d.value && u(yo, {
        disabled: !s.value,
        to: s.value
      }, {
        default: () => [u("div", q({
          class: ["v-overlay", {
            "v-overlay--absolute": e.absolute || e.contained,
            "v-overlay--active": o.value,
            "v-overlay--contained": e.contained
          }, r.value, f.value, e.class],
          style: [b.value, {
            top: j(O.value)
          }, e.style],
          ref: $
        }, T, a), [u(vu, q({
          color: m,
          modelValue: !!e.scrim && o.value
        }, P.value), null), u(Ue, {
          appear: !0,
          persisted: !0,
          transition: e.transition,
          target: V.value,
          onAfterLeave: ee
        }, {
          default: () => {
            var Y;
            return [Ve(u("div", q({
              ref: E,
              class: ["v-overlay__content", e.contentClass],
              style: [k.value, L.value]
            }, S.value, e.contentProps), [(Y = t.default) == null ? void 0 : Y.call(t, {
              isActive: o
            })]), [[pt, o.value], [qe("click-outside"), {
              handler: X,
              closeConditional: J,
              include: () => [w.value]
            }]])];
          }
        })])]
      })]);
    }), {
      activatorEl: w,
      target: V,
      animateClick: G,
      contentEl: E,
      globalTop: g,
      localTop: y,
      updateLocation: N
    };
  }
}), In = Symbol("Forwarded refs");
function _n(e, n) {
  let t = e;
  for (; t; ) {
    const a = Reflect.getOwnPropertyDescriptor(t, n);
    if (a)
      return a;
    t = Object.getPrototypeOf(t);
  }
}
function _t(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    t[a - 1] = arguments[a];
  return e[In] = t, new Proxy(e, {
    get(l, i) {
      if (Reflect.has(l, i))
        return Reflect.get(l, i);
      if (!(typeof i == "symbol" || i.startsWith("$") || i.startsWith("__"))) {
        for (const o of t)
          if (o.value && Reflect.has(o.value, i)) {
            const s = Reflect.get(o.value, i);
            return typeof s == "function" ? s.bind(o.value) : s;
          }
      }
    },
    has(l, i) {
      if (Reflect.has(l, i))
        return !0;
      if (typeof i == "symbol" || i.startsWith("$") || i.startsWith("__"))
        return !1;
      for (const o of t)
        if (o.value && Reflect.has(o.value, i))
          return !0;
      return !1;
    },
    set(l, i, o) {
      if (Reflect.has(l, i))
        return Reflect.set(l, i, o);
      if (typeof i == "symbol" || i.startsWith("$") || i.startsWith("__"))
        return !1;
      for (const s of t)
        if (s.value && Reflect.has(s.value, i))
          return Reflect.set(s.value, i, o);
      return !1;
    },
    getOwnPropertyDescriptor(l, i) {
      var s;
      const o = Reflect.getOwnPropertyDescriptor(l, i);
      if (o)
        return o;
      if (!(typeof i == "symbol" || i.startsWith("$") || i.startsWith("__"))) {
        for (const r of t) {
          if (!r.value)
            continue;
          const f = _n(r.value, i) ?? ("_" in r.value ? _n((s = r.value._) == null ? void 0 : s.setupState, i) : void 0);
          if (f)
            return f;
        }
        for (const r of t) {
          const f = r.value && r.value[In];
          if (!f)
            continue;
          const v = f.slice();
          for (; v.length; ) {
            const d = v.shift(), c = _n(d.value, i);
            if (c)
              return c;
            const m = d.value && d.value[In];
            m && v.push(...m);
          }
        }
      }
    }
  });
}
const mu = F({
  // TODO
  // disableKeys: Boolean,
  id: String,
  ...Xe(ya({
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: Wl
    }
  }), ["absolute"])
}, "VMenu"), Yi = W()({
  name: "VMenu",
  props: mu(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = oe(e, "modelValue"), {
      scopeId: l
    } = Sn(), i = Be(), o = h(() => e.id || `v-menu-${i}`), s = D(), r = ue(Gn, null), f = z(0);
    we(Gn, {
      register() {
        ++f.value;
      },
      unregister() {
        --f.value;
      },
      closeParents() {
        setTimeout(() => {
          f.value || (a.value = !1, r == null || r.closeParents());
        }, 40);
      }
    });
    async function v(y) {
      var C, V, A;
      const b = y.relatedTarget, w = y.target;
      await de(), a.value && b !== w && ((C = s.value) != null && C.contentEl) && // We're the topmost menu
      ((V = s.value) != null && V.globalTop) && // It isn't the document or the menu body
      ![document, s.value.contentEl].includes(w) && // It isn't inside the menu body
      !s.value.contentEl.contains(w) && ((A = Bn(s.value.contentEl)[0]) == null || A.focus());
    }
    H(a, (y) => {
      y ? (r == null || r.register(), document.addEventListener("focusin", v, {
        once: !0
      })) : (r == null || r.unregister(), document.removeEventListener("focusin", v));
    });
    function d() {
      r == null || r.closeParents();
    }
    function c(y) {
      var b, w, C;
      e.disabled || y.key === "Tab" && (kl(Bn((b = s.value) == null ? void 0 : b.contentEl, !1), y.shiftKey ? "prev" : "next", (A) => A.tabIndex >= 0) || (a.value = !1, (C = (w = s.value) == null ? void 0 : w.activatorEl) == null || C.focus()));
    }
    function m(y) {
      var w;
      if (e.disabled)
        return;
      const b = (w = s.value) == null ? void 0 : w.contentEl;
      b && a.value ? y.key === "ArrowDown" ? (y.preventDefault(), Jt(b, "next")) : y.key === "ArrowUp" && (y.preventDefault(), Jt(b, "prev")) : ["ArrowDown", "ArrowUp"].includes(y.key) && (a.value = !0, y.preventDefault(), setTimeout(() => setTimeout(() => m(y))));
    }
    const g = h(() => q({
      "aria-haspopup": "menu",
      "aria-expanded": String(a.value),
      "aria-owns": o.value,
      onKeydown: m
    }, e.activatorProps));
    return Z(() => {
      const y = un.filterProps(e);
      return u(un, q({
        ref: s,
        class: ["v-menu", e.class],
        style: e.style
      }, y, {
        modelValue: a.value,
        "onUpdate:modelValue": (b) => a.value = b,
        absolute: !0,
        activatorProps: g.value,
        "onClick:outside": d,
        onKeydown: c
      }, l), {
        activator: t.activator,
        default: function() {
          for (var b = arguments.length, w = new Array(b), C = 0; C < b; C++)
            w[C] = arguments[C];
          return u(he, {
            root: "VMenu"
          }, {
            default: () => {
              var V;
              return [(V = t.default) == null ? void 0 : V.call(t, ...w)];
            }
          });
        }
      });
    }), _t({
      id: o,
      ΨopenChildren: f
    }, s);
  }
});
const gu = F({
  active: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...ne(),
  ...It({
    transition: {
      component: Gl
    }
  })
}, "VCounter"), qi = W()({
  name: "VCounter",
  functional: !0,
  props: gu(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = h(() => e.max ? `${e.value} / ${e.max}` : String(e.value));
    return Z(() => u(Ue, {
      transition: e.transition
    }, {
      default: () => [Ve(u("div", {
        class: ["v-counter", e.class],
        style: e.style
      }, [t.default ? t.default({
        counter: a.value,
        max: e.max,
        value: e.value
      }) : a.value]), [[pt, e.active]])]
    })), {};
  }
});
const hu = F({
  floating: Boolean,
  ...ne()
}, "VFieldLabel"), Kt = W()({
  name: "VFieldLabel",
  props: hu(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return Z(() => u(xi, {
      class: ["v-field-label", {
        "v-field-label--floating": e.floating
      }, e.class],
      style: e.style,
      "aria-hidden": e.floating || void 0
    }, t)), {};
  }
}), yu = ["underlined", "outlined", "filled", "solo", "solo-inverted", "solo-filled", "plain"], ba = F({
  appendInnerIcon: re,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: re,
    default: "$clear"
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: void 0
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  flat: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: re,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (e) => yu.includes(e)
  },
  "onClick:clear": De(),
  "onClick:appendInner": De(),
  "onClick:prependInner": De(),
  ...ne(),
  ...ui(),
  ...$e(),
  ...ve()
}, "VField"), Sa = W()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    ...Ii(),
    ...ba()
  },
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      emit: a,
      slots: l
    } = n;
    const {
      themeClasses: i
    } = be(e), {
      loaderClasses: o
    } = ca(e), {
      focusClasses: s,
      isFocused: r,
      focus: f,
      blur: v
    } = yn(e), {
      InputIcon: d
    } = Pi(e), {
      roundedClasses: c
    } = Fe(e), {
      rtlClasses: m
    } = Ge(), g = h(() => e.dirty || e.active), y = h(() => !e.singleLine && !!(e.label || l.label)), b = Be(), w = h(() => e.id || `input-${b}`), C = h(() => `${w.value}-messages`), V = D(), A = D(), p = D(), x = h(() => ["plain", "underlined"].includes(e.variant)), {
      backgroundColorClasses: S,
      backgroundColorStyles: P
    } = We(K(e, "bgColor")), {
      textColorClasses: k,
      textColorStyles: I
    } = ze(h(() => e.error || e.disabled ? void 0 : g.value && r.value ? e.color : e.baseColor));
    H(g, (E) => {
      if (y.value) {
        const L = V.value.$el, N = A.value.$el;
        requestAnimationFrame(() => {
          const X = ta(L), J = N.getBoundingClientRect(), _ = J.x - X.x, B = J.y - X.y - (X.height / 2 - J.height / 2), O = J.width / 0.75, G = Math.abs(O - X.width) > 1 ? {
            maxWidth: j(O)
          } : void 0, ee = getComputedStyle(L), R = getComputedStyle(N), Y = parseFloat(ee.transitionDuration) * 1e3 || 150, te = parseFloat(R.getPropertyValue("--v-field-label-scale")), U = R.getPropertyValue("color");
          L.style.visibility = "visible", N.style.visibility = "hidden", yt(L, {
            transform: `translate(${_}px, ${B}px) scale(${te})`,
            color: U,
            ...G
          }, {
            duration: Y,
            easing: tn,
            direction: E ? "normal" : "reverse"
          }).finished.then(() => {
            L.style.removeProperty("visibility"), N.style.removeProperty("visibility");
          });
        });
      }
    }, {
      flush: "post"
    });
    const T = h(() => ({
      isActive: g,
      isFocused: r,
      controlRef: p,
      blur: v,
      focus: f
    }));
    function $(E) {
      E.target !== document.activeElement && E.preventDefault();
    }
    return Z(() => {
      var _, B, O;
      const E = e.variant === "outlined", L = l["prepend-inner"] || e.prependInnerIcon, N = !!(e.clearable || l.clear), X = !!(l["append-inner"] || e.appendInnerIcon || N), J = () => l.label ? l.label({
        ...T.value,
        label: e.label,
        props: {
          for: w.value
        }
      }) : e.label;
      return u("div", q({
        class: ["v-field", {
          "v-field--active": g.value,
          "v-field--appended": X,
          "v-field--center-affix": e.centerAffix ?? !x.value,
          "v-field--disabled": e.disabled,
          "v-field--dirty": e.dirty,
          "v-field--error": e.error,
          "v-field--flat": e.flat,
          "v-field--has-background": !!e.bgColor,
          "v-field--persistent-clear": e.persistentClear,
          "v-field--prepended": L,
          "v-field--reverse": e.reverse,
          "v-field--single-line": e.singleLine,
          "v-field--no-label": !J(),
          [`v-field--variant-${e.variant}`]: !0
        }, i.value, S.value, s.value, o.value, c.value, m.value, e.class],
        style: [P.value, e.style],
        onClick: $
      }, t), [u("div", {
        class: "v-field__overlay"
      }, null), u(ci, {
        name: "v-field",
        active: !!e.loading,
        color: e.error ? "error" : typeof e.loading == "string" ? e.loading : e.color
      }, {
        default: l.loader
      }), L && u("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [e.prependInnerIcon && u(d, {
        key: "prepend-icon",
        name: "prependInner"
      }, null), (_ = l["prepend-inner"]) == null ? void 0 : _.call(l, T.value)]), u("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["filled", "solo", "solo-inverted", "solo-filled"].includes(e.variant) && y.value && u(Kt, {
        key: "floating-label",
        ref: A,
        class: [k.value],
        floating: !0,
        for: w.value,
        style: I.value
      }, {
        default: () => [J()]
      }), u(Kt, {
        ref: V,
        for: w.value
      }, {
        default: () => [J()]
      }), (B = l.default) == null ? void 0 : B.call(l, {
        ...T.value,
        props: {
          id: w.value,
          class: "v-field__input",
          "aria-describedby": C.value
        },
        focus: f,
        blur: v
      })]), N && u(Kl, {
        key: "clear"
      }, {
        default: () => [Ve(u("div", {
          class: "v-field__clearable",
          onMousedown: (G) => {
            G.preventDefault(), G.stopPropagation();
          }
        }, [l.clear ? l.clear() : u(d, {
          name: "clear"
        }, null)]), [[pt, e.dirty]])]
      }), X && u("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [(O = l["append-inner"]) == null ? void 0 : O.call(l, T.value), e.appendInnerIcon && u(d, {
        key: "append-icon",
        name: "appendInner"
      }, null)]), u("div", {
        class: ["v-field__outline", k.value],
        style: I.value
      }, [E && u(ie, null, [u("div", {
        class: "v-field__outline__start"
      }, null), y.value && u("div", {
        class: "v-field__outline__notch"
      }, [u(Kt, {
        ref: A,
        floating: !0,
        for: w.value
      }, {
        default: () => [J()]
      })]), u("div", {
        class: "v-field__outline__end"
      }, null)]), x.value && y.value && u(Kt, {
        ref: A,
        floating: !0,
        for: w.value
      }, {
        default: () => [J()]
      })])]);
    }), {
      controlRef: p
    };
  }
});
function Xi(e) {
  const n = Object.keys(Sa.props).filter((t) => !Jn(t) && t !== "class" && t !== "style");
  return Sl(e, n);
}
const bu = ["color", "file", "time", "date", "datetime-local", "week", "month"], wa = F({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: "text"
  },
  modelModifiers: Object,
  ...bn(),
  ...ba()
}, "VTextField"), cn = W()({
  name: "VTextField",
  directives: {
    Intersect: ia
  },
  inheritAttrs: !1,
  props: wa(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      emit: a,
      slots: l
    } = n;
    const i = oe(e, "modelValue"), {
      isFocused: o,
      focus: s,
      blur: r
    } = yn(e), f = h(() => typeof e.counterValue == "function" ? e.counterValue(i.value) : typeof e.counterValue == "number" ? e.counterValue : (i.value ?? "").toString().length), v = h(() => {
      if (t.maxlength)
        return t.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    }), d = h(() => ["plain", "underlined"].includes(e.variant));
    function c(x, S) {
      var P, k;
      !e.autofocus || !x || (k = (P = S[0].target) == null ? void 0 : P.focus) == null || k.call(P);
    }
    const m = D(), g = D(), y = D(), b = h(() => bu.includes(e.type) || e.persistentPlaceholder || o.value || e.active);
    function w() {
      var x;
      y.value !== document.activeElement && ((x = y.value) == null || x.focus()), o.value || s();
    }
    function C(x) {
      a("mousedown:control", x), x.target !== y.value && (w(), x.preventDefault());
    }
    function V(x) {
      w(), a("click:control", x);
    }
    function A(x) {
      x.stopPropagation(), w(), de(() => {
        i.value = null, pl(e["onClick:clear"], x);
      });
    }
    function p(x) {
      var P;
      const S = x.target;
      if (i.value = S.value, (P = e.modelModifiers) != null && P.trim && ["text", "search", "password", "tel", "url"].includes(e.type)) {
        const k = [S.selectionStart, S.selectionEnd];
        de(() => {
          S.selectionStart = k[0], S.selectionEnd = k[1];
        });
      }
    }
    return Z(() => {
      const x = !!(l.counter || e.counter !== !1 && e.counter != null), S = !!(x || l.details), [P, k] = fn(t), {
        modelValue: I,
        ...T
      } = wt.filterProps(e), $ = Xi(e);
      return u(wt, q({
        ref: m,
        modelValue: i.value,
        "onUpdate:modelValue": (E) => i.value = E,
        class: ["v-text-field", {
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-input--plain-underlined": d.value
        }, e.class],
        style: e.style
      }, P, T, {
        centerAffix: !d.value,
        focused: o.value
      }), {
        ...l,
        default: (E) => {
          let {
            id: L,
            isDisabled: N,
            isDirty: X,
            isReadonly: J,
            isValid: _
          } = E;
          return u(Sa, q({
            ref: g,
            onMousedown: C,
            onClick: V,
            "onClick:clear": A,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"],
            role: e.role
          }, $, {
            id: L.value,
            active: b.value || X.value,
            dirty: X.value || e.dirty,
            disabled: N.value,
            focused: o.value,
            error: _.value === !1
          }), {
            ...l,
            default: (B) => {
              let {
                props: {
                  class: O,
                  ...G
                }
              } = B;
              const ee = Ve(u("input", q({
                ref: y,
                value: i.value,
                onInput: p,
                autofocus: e.autofocus,
                readonly: J.value,
                disabled: N.value,
                name: e.name,
                placeholder: e.placeholder,
                size: 1,
                type: e.type,
                onFocus: w,
                onBlur: r
              }, G, k), null), [[qe("intersect"), {
                handler: c
              }, null, {
                once: !0
              }]]);
              return u(ie, null, [e.prefix && u("span", {
                class: "v-text-field__prefix"
              }, [u("span", {
                class: "v-text-field__prefix__text"
              }, [e.prefix])]), l.default ? u("div", {
                class: O,
                "data-no-activator": ""
              }, [l.default(), ee]) : bo(ee, {
                class: O
              }), e.suffix && u("span", {
                class: "v-text-field__suffix"
              }, [u("span", {
                class: "v-text-field__suffix__text"
              }, [e.suffix])])]);
            }
          });
        },
        details: S ? (E) => {
          var L;
          return u(ie, null, [(L = l.details) == null ? void 0 : L.call(l, E), x && u(ie, null, [u("span", null, null), u(qi, {
            active: e.persistentCounter || o.value,
            value: f.value,
            max: v.value
          }, l.counter)])]);
        } : void 0
      });
    }), _t({}, m, g, y);
  }
});
const Su = F({
  renderless: Boolean,
  ...ne()
}, "VVirtualScrollItem"), wu = W()({
  name: "VVirtualScrollItem",
  inheritAttrs: !1,
  props: Su(),
  emits: {
    "update:height": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      emit: a,
      slots: l
    } = n;
    const {
      resizeRef: i,
      contentRect: o
    } = vn(void 0, "border");
    H(() => {
      var s;
      return (s = o.value) == null ? void 0 : s.height;
    }, (s) => {
      s != null && a("update:height", s);
    }), Z(() => {
      var s, r;
      return e.renderless ? u(ie, null, [(s = l.default) == null ? void 0 : s.call(l, {
        itemRef: i
      })]) : u("div", q({
        ref: i,
        class: ["v-virtual-scroll__item", e.class],
        style: e.style
      }, t), [(r = l.default) == null ? void 0 : r.call(l)]);
    });
  }
}), Cu = -1, xu = 1, An = 100, pu = F({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, "virtual");
function ku(e, n) {
  const t = ha(), a = z(0);
  Te(() => {
    a.value = parseFloat(e.itemHeight || 0);
  });
  const l = z(0), i = z(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(e.height) || t.height.value) / (a.value || 16)
  ) || 1), o = z(0), s = z(0), r = D(), f = D();
  let v = 0;
  const {
    resizeRef: d,
    contentRect: c
  } = vn();
  Te(() => {
    d.value = r.value;
  });
  const m = h(() => {
    var B;
    return r.value === document.documentElement ? t.height.value : ((B = c.value) == null ? void 0 : B.height) || parseInt(e.height) || 0;
  }), g = h(() => !!(r.value && f.value && m.value && a.value));
  let y = Array.from({
    length: n.value.length
  }), b = Array.from({
    length: n.value.length
  });
  const w = z(0);
  let C = -1;
  function V(B) {
    return y[B] || a.value;
  }
  const A = _o(() => {
    const B = performance.now();
    b[0] = 0;
    const O = n.value.length;
    for (let G = 1; G <= O - 1; G++)
      b[G] = (b[G - 1] || 0) + V(G - 1);
    w.value = Math.max(w.value, performance.now() - B);
  }, w), p = H(g, (B) => {
    B && (p(), v = f.value.offsetTop, A.immediate(), N(), ~C && de(() => {
      se && window.requestAnimationFrame(() => {
        J(C), C = -1;
      });
    }));
  });
  H(m, (B, O) => {
    O && N();
  }), Ce(() => {
    A.clear();
  });
  function x(B, O) {
    const G = y[B], ee = a.value;
    a.value = ee ? Math.min(a.value, O) : O, (G !== O || ee !== a.value) && (y[B] = O, A());
  }
  function S(B) {
    return B = lt(B, 0, n.value.length - 1), b[B] || 0;
  }
  function P(B) {
    return Vu(b, B);
  }
  let k = 0, I = 0, T = 0;
  function $() {
    if (!r.value || !f.value)
      return;
    const B = r.value.scrollTop, O = performance.now();
    O - T > 500 ? (I = Math.sign(B - k), v = f.value.offsetTop) : I = B - k, k = B, T = O, N();
  }
  function E() {
    !r.value || !f.value || (I = 0, T = 0, N());
  }
  let L = -1;
  function N() {
    cancelAnimationFrame(L), L = requestAnimationFrame(X);
  }
  function X() {
    if (!r.value || !m.value)
      return;
    const B = k - v, O = Math.sign(I), G = Math.max(0, B - An), ee = lt(P(G), 0, n.value.length), R = B + m.value + An, Y = lt(P(R) + 1, ee + 1, n.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (O !== Cu || ee < l.value) && (O !== xu || Y > i.value)
    ) {
      const te = S(l.value) - S(ee), U = S(Y) - S(i.value);
      Math.max(te, U) > An ? (l.value = ee, i.value = Y) : (ee <= 0 && (l.value = ee), Y >= n.value.length && (i.value = Y));
    }
    o.value = S(l.value), s.value = S(n.value.length) - S(i.value);
  }
  function J(B) {
    const O = S(B);
    !r.value || B && !O ? C = B : r.value.scrollTop = O;
  }
  const _ = h(() => n.value.slice(l.value, i.value).map((B, O) => ({
    raw: B,
    index: O + l.value
  })));
  return H(n, () => {
    y = Array.from({
      length: n.value.length
    }), b = Array.from({
      length: n.value.length
    }), A.immediate(), N();
  }, {
    deep: !0
  }), {
    containerRef: r,
    markerRef: f,
    computedItems: _,
    paddingTop: o,
    paddingBottom: s,
    scrollToIndex: J,
    handleScroll: $,
    handleScrollend: E,
    handleItemResize: x
  };
}
function Vu(e, n) {
  let t = e.length - 1, a = 0, l = 0, i = null, o = -1;
  if (e[t] < n)
    return t;
  for (; a <= t; )
    if (l = a + t >> 1, i = e[l], i > n)
      t = l - 1;
    else if (i < n)
      o = l, a = l + 1;
    else
      return i === n ? l : a;
  return o;
}
const Pu = F({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...pu(),
  ...ne(),
  ...Vt()
}, "VVirtualScroll"), Zi = W()({
  name: "VVirtualScroll",
  props: Pu(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = fe("VVirtualScroll"), {
      dimensionStyles: l
    } = Pt(e), {
      containerRef: i,
      markerRef: o,
      handleScroll: s,
      handleScrollend: r,
      handleItemResize: f,
      scrollToIndex: v,
      paddingTop: d,
      paddingBottom: c,
      computedItems: m
    } = ku(e, K(e, "items"));
    return Ne(() => e.renderless, () => {
      function g() {
        var w, C;
        const b = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? "addEventListener" : "removeEventListener";
        i.value === document.documentElement ? (document[b]("scroll", s, {
          passive: !0
        }), document[b]("scrollend", r)) : ((w = i.value) == null || w[b]("scroll", s, {
          passive: !0
        }), (C = i.value) == null || C[b]("scrollend", r));
      }
      He(() => {
        i.value = Ml(a.vnode.el, !0), g(!0);
      }), Ce(g);
    }), Z(() => {
      const g = m.value.map((y) => u(wu, {
        key: y.index,
        renderless: e.renderless,
        "onUpdate:height": (b) => f(y.index, b)
      }, {
        default: (b) => {
          var w;
          return (w = t.default) == null ? void 0 : w.call(t, {
            item: y.raw,
            index: y.index,
            ...b
          });
        }
      }));
      return e.renderless ? u(ie, null, [u("div", {
        ref: o,
        class: "v-virtual-scroll__spacer",
        style: {
          paddingTop: j(d.value)
        }
      }, null), g, u("div", {
        class: "v-virtual-scroll__spacer",
        style: {
          paddingBottom: j(c.value)
        }
      }, null)]) : u("div", {
        ref: i,
        class: ["v-virtual-scroll", e.class],
        onScrollPassive: s,
        onScrollend: r,
        style: [l.value, e.style]
      }, [u("div", {
        ref: o,
        class: "v-virtual-scroll__container",
        style: {
          paddingTop: j(d.value),
          paddingBottom: j(c.value)
        }
      }, [g])]);
    }), {
      scrollToIndex: v
    };
  }
});
function Ji(e, n) {
  const t = z(!1);
  let a;
  function l(s) {
    cancelAnimationFrame(a), t.value = !0, a = requestAnimationFrame(() => {
      a = requestAnimationFrame(() => {
        t.value = !1;
      });
    });
  }
  async function i() {
    await new Promise((s) => requestAnimationFrame(s)), await new Promise((s) => requestAnimationFrame(s)), await new Promise((s) => requestAnimationFrame(s)), await new Promise((s) => {
      if (t.value) {
        const r = H(t, () => {
          r(), s();
        });
      } else
        s();
    });
  }
  async function o(s) {
    var v, d;
    if (s.key === "Tab" && ((v = n.value) == null || v.focus()), !["PageDown", "PageUp", "Home", "End"].includes(s.key))
      return;
    const r = (d = e.value) == null ? void 0 : d.$el;
    if (!r)
      return;
    (s.key === "Home" || s.key === "End") && r.scrollTo({
      top: s.key === "Home" ? 0 : r.scrollHeight,
      behavior: "smooth"
    }), await i();
    const f = r.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (s.key === "PageDown" || s.key === "Home") {
      const c = r.getBoundingClientRect().top;
      for (const m of f)
        if (m.getBoundingClientRect().top >= c) {
          m.focus();
          break;
        }
    } else {
      const c = r.getBoundingClientRect().bottom;
      for (const m of [...f].reverse())
        if (m.getBoundingClientRect().bottom <= c) {
          m.focus();
          break;
        }
    }
  }
  return {
    onListScroll: l,
    onListKeydown: o
  };
}
const Qi = F({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  menu: Boolean,
  menuIcon: {
    type: re,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  ...Ri({
    itemChildren: !1
  })
}, "Select"), Iu = F({
  ...Qi(),
  ...Xe(wa({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...It({
    transition: {
      component: Wl
    }
  })
}, "VSelect"), Wc = W()({
  name: "VSelect",
  props: Iu(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      t: a
    } = mn(), l = D(), i = D(), o = D(), s = oe(e, "menu"), r = h({
      get: () => s.value,
      set: (_) => {
        var B;
        s.value && !_ && ((B = i.value) != null && B.ΨopenChildren) || (s.value = _);
      }
    }), {
      items: f,
      transformIn: v,
      transformOut: d
    } = Ni(e), c = oe(e, "modelValue", [], (_) => v(_ === null ? [null] : Ae(_)), (_) => {
      const B = d(_);
      return e.multiple ? B : B[0] ?? null;
    }), m = h(() => typeof e.counterValue == "function" ? e.counterValue(c.value) : typeof e.counterValue == "number" ? e.counterValue : c.value.length), g = ma(), y = h(() => c.value.map((_) => _.value)), b = z(!1), w = h(() => r.value ? e.closeText : e.openText);
    let C = "", V;
    const A = h(() => e.hideSelected ? f.value.filter((_) => !c.value.some((B) => B === _)) : f.value), p = h(() => e.hideNoData && !A.value.length || e.readonly || (g == null ? void 0 : g.isReadonly.value)), x = h(() => {
      var _;
      return {
        ...e.menuProps,
        activatorProps: {
          ...((_ = e.menuProps) == null ? void 0 : _.activatorProps) || {},
          "aria-haspopup": "listbox"
          // Set aria-haspopup to 'listbox'
        }
      };
    }), S = D(), {
      onListScroll: P,
      onListKeydown: k
    } = Ji(S, l);
    function I(_) {
      e.openOnClear && (r.value = !0);
    }
    function T() {
      p.value || (r.value = !r.value);
    }
    function $(_) {
      var R, Y;
      if (!_.key || e.readonly || g != null && g.isReadonly.value)
        return;
      ["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(_.key) && _.preventDefault(), ["Enter", "ArrowDown", " "].includes(_.key) && (r.value = !0), ["Escape", "Tab"].includes(_.key) && (r.value = !1), _.key === "Home" ? (R = S.value) == null || R.focus("first") : _.key === "End" && ((Y = S.value) == null || Y.focus("last"));
      const B = 1e3;
      function O(te) {
        const U = te.key.length === 1, le = !te.ctrlKey && !te.metaKey && !te.altKey;
        return U && le;
      }
      if (e.multiple || !O(_))
        return;
      const G = performance.now();
      G - V > B && (C = ""), C += _.key.toLowerCase(), V = G;
      const ee = f.value.find((te) => te.title.toLowerCase().startsWith(C));
      ee !== void 0 && (c.value = [ee]);
    }
    function E(_) {
      if (e.multiple) {
        const B = c.value.findIndex((O) => e.valueComparator(O.value, _.value));
        if (B === -1)
          c.value = [...c.value, _];
        else {
          const O = [...c.value];
          O.splice(B, 1), c.value = O;
        }
      } else
        c.value = [_], r.value = !1;
    }
    function L(_) {
      var B;
      (B = S.value) != null && B.$el.contains(_.relatedTarget) || (r.value = !1);
    }
    function N() {
      var _;
      b.value && ((_ = l.value) == null || _.focus());
    }
    function X(_) {
      b.value = !0;
    }
    function J(_) {
      if (_ == null)
        c.value = [];
      else if (bt(l.value, ":autofill") || bt(l.value, ":-webkit-autofill")) {
        const B = f.value.find((O) => O.title === _);
        B && E(B);
      } else
        l.value && (l.value.value = "");
    }
    return H(r, () => {
      if (!e.hideSelected && r.value && c.value.length) {
        const _ = A.value.findIndex((B) => c.value.some((O) => e.valueComparator(O.value, B.value)));
        se && window.requestAnimationFrame(() => {
          var B;
          _ >= 0 && ((B = o.value) == null || B.scrollToIndex(_));
        });
      }
    }), H(A, (_, B) => {
      b.value && (!_.length && e.hideNoData && (r.value = !1), !B.length && _.length && (r.value = !0));
    }), Z(() => {
      const _ = !!(e.chips || t.chip), B = !!(!e.hideNoData || A.value.length || t["prepend-item"] || t["append-item"] || t["no-data"]), O = c.value.length > 0, G = cn.filterProps(e), ee = O || !b.value && e.label && !e.persistentPlaceholder ? void 0 : e.placeholder;
      return u(cn, q({
        ref: l
      }, G, {
        modelValue: c.value.map((R) => R.props.value).join(", "),
        "onUpdate:modelValue": J,
        focused: b.value,
        "onUpdate:focused": (R) => b.value = R,
        validationValue: c.externalValue,
        counterValue: m.value,
        dirty: O,
        class: ["v-select", {
          "v-select--active-menu": r.value,
          "v-select--chips": !!e.chips,
          [`v-select--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": c.value.length,
          "v-select--selection-slot": !!t.selection
        }, e.class],
        style: e.style,
        inputmode: "none",
        placeholder: ee,
        "onClick:clear": I,
        "onMousedown:control": T,
        onBlur: L,
        onKeydown: $,
        "aria-label": a(w.value),
        title: a(w.value)
      }), {
        ...t,
        default: () => u(ie, null, [u(Yi, q({
          ref: i,
          modelValue: r.value,
          "onUpdate:modelValue": (R) => r.value = R,
          activator: "parent",
          contentClass: "v-select__content",
          disabled: p.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterLeave: N
        }, x.value), {
          default: () => [B && u(Hi, {
            ref: S,
            selected: y.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (R) => R.preventDefault(),
            onKeydown: k,
            onFocusin: X,
            onScrollPassive: P,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, {
            default: () => {
              var R, Y, te;
              return [(R = t["prepend-item"]) == null ? void 0 : R.call(t), !A.value.length && !e.hideNoData && (((Y = t["no-data"]) == null ? void 0 : Y.call(t)) ?? u(Ct, {
                title: a(e.noDataText)
              }, null)), u(Zi, {
                ref: o,
                renderless: !0,
                items: A.value
              }, {
                default: (U) => {
                  var xe;
                  let {
                    item: le,
                    index: M,
                    itemRef: Q
                  } = U;
                  const ce = q(le.props, {
                    ref: Q,
                    key: M,
                    onClick: () => E(le)
                  });
                  return ((xe = t.item) == null ? void 0 : xe.call(t, {
                    item: le,
                    index: M,
                    props: ce
                  })) ?? u(Ct, q(ce, {
                    role: "option"
                  }), {
                    prepend: (ae) => {
                      let {
                        isSelected: Se
                      } = ae;
                      return u(ie, null, [e.multiple && !e.hideSelected ? u(Vi, {
                        key: le.value,
                        modelValue: Se,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, le.props.prependAvatar && u(St, {
                        image: le.props.prependAvatar
                      }, null), le.props.prependIcon && u(ye, {
                        icon: le.props.prependIcon
                      }, null)]);
                    }
                  });
                }
              }), (te = t["append-item"]) == null ? void 0 : te.call(t)];
            }
          })]
        }), c.value.map((R, Y) => {
          function te(Q) {
            Q.stopPropagation(), Q.preventDefault(), E(R);
          }
          const U = {
            "onClick:close": te,
            onMousedown(Q) {
              Q.preventDefault(), Q.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, le = _ ? !!t.chip : !!t.selection, M = le ? ea(_ ? t.chip({
            item: R,
            index: Y,
            props: U
          }) : t.selection({
            item: R,
            index: Y
          })) : void 0;
          if (!(le && !M))
            return u("div", {
              key: R.value,
              class: "v-select__selection"
            }, [_ ? t.chip ? u(he, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: R.title
                }
              }
            }, {
              default: () => [M]
            }) : u(Ti, q({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: R.title,
              disabled: R.props.disabled
            }, U), null) : M ?? u("span", {
              class: "v-select__selection-text"
            }, [R.title, e.multiple && Y < c.value.length - 1 && u("span", {
              class: "v-select__selection-comma"
            }, [hl(",")])])]);
        })]),
        "append-inner": function() {
          var U;
          for (var R = arguments.length, Y = new Array(R), te = 0; te < R; te++)
            Y[te] = arguments[te];
          return u(ie, null, [(U = t["append-inner"]) == null ? void 0 : U.call(t, ...Y), e.menuIcon ? u(ye, {
            class: "v-select__menu-icon",
            icon: e.menuIcon
          }, null) : void 0]);
        }
      });
    }), _t({
      isFocused: b,
      menu: r,
      select: E
    }, l);
  }
}), _u = (e, n, t) => e == null || n == null ? -1 : e.toString().toLocaleLowerCase().indexOf(n.toString().toLocaleLowerCase()), Au = F({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function Tu(e, n, t) {
  var s;
  const a = [], l = (t == null ? void 0 : t.default) ?? _u, i = t != null && t.filterKeys ? Ae(t.filterKeys) : !1, o = Object.keys((t == null ? void 0 : t.customKeyFilter) ?? {}).length;
  if (!(e != null && e.length))
    return a;
  e:
    for (let r = 0; r < e.length; r++) {
      const [f, v = f] = Ae(e[r]), d = {}, c = {};
      let m = -1;
      if (n && !(t != null && t.noFilter)) {
        if (typeof f == "object") {
          const b = i || Object.keys(v);
          for (const w of b) {
            const C = Oe(v, w, v), V = (s = t == null ? void 0 : t.customKeyFilter) == null ? void 0 : s[w];
            if (m = V ? V(C, n, f) : l(C, n, f), m !== -1 && m !== !1)
              V ? d[w] = m : c[w] = m;
            else if ((t == null ? void 0 : t.filterMode) === "every")
              continue e;
          }
        } else
          m = l(f, n, f), m !== -1 && m !== !1 && (c.title = m);
        const g = Object.keys(c).length, y = Object.keys(d).length;
        if (!g && !y || (t == null ? void 0 : t.filterMode) === "union" && y !== o && !g || (t == null ? void 0 : t.filterMode) === "intersection" && (y !== o || !g))
          continue;
      }
      a.push({
        index: r,
        matches: {
          ...c,
          ...d
        }
      });
    }
  return a;
}
function Eu(e, n, t, a) {
  const l = D([]), i = D(/* @__PURE__ */ new Map()), o = h(() => a != null && a.transform ? ke(n).map((r) => [r, a.transform(r)]) : ke(n));
  Te(() => {
    const r = typeof t == "function" ? t() : ke(t), f = typeof r != "string" && typeof r != "number" ? "" : String(r), v = Tu(o.value, f, {
      customKeyFilter: {
        ...e.customKeyFilter,
        ...ke(a == null ? void 0 : a.customKeyFilter)
      },
      default: e.customFilter,
      filterKeys: e.filterKeys,
      filterMode: e.filterMode,
      noFilter: e.noFilter
    }), d = ke(n), c = [], m = /* @__PURE__ */ new Map();
    v.forEach((g) => {
      let {
        index: y,
        matches: b
      } = g;
      const w = d[y];
      c.push(w), m.set(w.value, b);
    }), l.value = c, i.value = m;
  });
  function s(r) {
    return i.value.get(r.value);
  }
  return {
    filteredItems: l,
    filteredMatches: i,
    getMatches: s
  };
}
function Bu(e, n, t) {
  if (n == null)
    return e;
  if (Array.isArray(n))
    throw new Error("Multiple matches is not implemented");
  return typeof n == "number" && ~n ? u(ie, null, [u("span", {
    class: "v-autocomplete__unmask"
  }, [e.substr(0, n)]), u("span", {
    class: "v-autocomplete__mask"
  }, [e.substr(n, t)]), u("span", {
    class: "v-autocomplete__unmask"
  }, [e.substr(n + t)])]) : e;
}
const $u = F({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  search: String,
  ...Au({
    filterKeys: ["title"]
  }),
  ...Qi(),
  ...Xe(wa({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...It({
    transition: !1
  })
}, "VAutocomplete"), Gc = W()({
  name: "VAutocomplete",
  props: $u(),
  emits: {
    "update:focused": (e) => !0,
    "update:search": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      t: a
    } = mn(), l = D(), i = z(!1), o = z(!0), s = z(!1), r = D(), f = D(), v = oe(e, "menu"), d = h({
      get: () => v.value,
      set: (M) => {
        var Q;
        v.value && !M && ((Q = r.value) != null && Q.ΨopenChildren) || (v.value = M);
      }
    }), c = z(-1), m = h(() => {
      var M;
      return (M = l.value) == null ? void 0 : M.color;
    }), g = h(() => d.value ? e.closeText : e.openText), {
      items: y,
      transformIn: b,
      transformOut: w
    } = Ni(e), {
      textColorClasses: C,
      textColorStyles: V
    } = ze(m), A = oe(e, "search", ""), p = oe(e, "modelValue", [], (M) => b(M === null ? [null] : Ae(M)), (M) => {
      const Q = w(M);
      return e.multiple ? Q : Q[0] ?? null;
    }), x = h(() => typeof e.counterValue == "function" ? e.counterValue(p.value) : typeof e.counterValue == "number" ? e.counterValue : p.value.length), S = ma(), {
      filteredItems: P,
      getMatches: k
    } = Eu(e, y, () => o.value ? "" : A.value), I = h(() => e.hideSelected ? P.value.filter((M) => !p.value.some((Q) => Q.value === M.value)) : P.value), T = h(() => p.value.map((M) => M.props.value)), $ = h(() => {
      var Q;
      return (e.autoSelectFirst === !0 || e.autoSelectFirst === "exact" && A.value === ((Q = I.value[0]) == null ? void 0 : Q.title)) && I.value.length > 0 && !o.value && !s.value;
    }), E = h(() => e.hideNoData && !I.value.length || e.readonly || (S == null ? void 0 : S.isReadonly.value)), L = D(), {
      onListScroll: N,
      onListKeydown: X
    } = Ji(L, l);
    function J(M) {
      e.openOnClear && (d.value = !0), A.value = "";
    }
    function _() {
      E.value || (d.value = !0);
    }
    function B(M) {
      E.value || (i.value && (M.preventDefault(), M.stopPropagation()), d.value = !d.value);
    }
    function O(M) {
      var xe, ae, Se;
      if (e.readonly || S != null && S.isReadonly.value)
        return;
      const Q = l.value.selectionStart, ce = p.value.length;
      if ((c.value > -1 || ["Enter", "ArrowDown", "ArrowUp"].includes(M.key)) && M.preventDefault(), ["Enter", "ArrowDown"].includes(M.key) && (d.value = !0), ["Escape"].includes(M.key) && (d.value = !1), $.value && ["Enter", "Tab"].includes(M.key) && le(I.value[0]), M.key === "ArrowDown" && $.value && ((xe = L.value) == null || xe.focus("next")), !!e.multiple) {
        if (["Backspace", "Delete"].includes(M.key)) {
          if (c.value < 0) {
            M.key === "Backspace" && !A.value && (c.value = ce - 1);
            return;
          }
          const me = c.value, Ee = p.value[c.value];
          Ee && !Ee.props.disabled && le(Ee), c.value = me >= ce - 1 ? ce - 2 : me;
        }
        if (M.key === "ArrowLeft") {
          if (c.value < 0 && Q > 0)
            return;
          const me = c.value > -1 ? c.value - 1 : ce - 1;
          p.value[me] ? c.value = me : (c.value = -1, l.value.setSelectionRange((ae = A.value) == null ? void 0 : ae.length, (Se = A.value) == null ? void 0 : Se.length));
        }
        if (M.key === "ArrowRight") {
          if (c.value < 0)
            return;
          const me = c.value + 1;
          p.value[me] ? c.value = me : (c.value = -1, l.value.setSelectionRange(0, 0));
        }
      }
    }
    function G(M) {
      if (bt(l.value, ":autofill") || bt(l.value, ":-webkit-autofill")) {
        const Q = y.value.find((ce) => ce.title === M.target.value);
        Q && le(Q);
      }
    }
    function ee() {
      var M;
      i.value && (o.value = !0, (M = l.value) == null || M.focus());
    }
    function R(M) {
      i.value = !0, setTimeout(() => {
        s.value = !0;
      });
    }
    function Y(M) {
      s.value = !1;
    }
    function te(M) {
      (M == null || M === "" && !e.multiple) && (p.value = []);
    }
    const U = z(!1);
    function le(M) {
      let Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!M.props.disabled)
        if (e.multiple) {
          const ce = p.value.findIndex((xe) => e.valueComparator(xe.value, M.value));
          if (ce === -1)
            p.value = [...p.value, M];
          else {
            const xe = [...p.value];
            xe.splice(ce, 1), p.value = xe;
          }
        } else
          p.value = Q ? [M] : [], U.value = !0, A.value = Q ? M.title : "", d.value = !1, o.value = !0, de(() => U.value = !1);
    }
    return H(i, (M, Q) => {
      var ce;
      M !== Q && (M ? (U.value = !0, A.value = e.multiple ? "" : String(((ce = p.value.at(-1)) == null ? void 0 : ce.props.title) ?? ""), o.value = !0, de(() => U.value = !1)) : (!e.multiple && A.value == null ? p.value = [] : $.value && !s.value && !p.value.some((xe) => {
        let {
          value: ae
        } = xe;
        return ae === I.value[0].value;
      }) && le(I.value[0]), d.value = !1, A.value = "", c.value = -1));
    }), H(A, (M) => {
      !i.value || U.value || (M && (d.value = !0), o.value = !M);
    }), H(d, () => {
      if (!e.hideSelected && d.value && p.value.length) {
        const M = I.value.findIndex((Q) => p.value.some((ce) => Q.value === ce.value));
        se && window.requestAnimationFrame(() => {
          var Q;
          M >= 0 && ((Q = f.value) == null || Q.scrollToIndex(M));
        });
      }
    }), H(I, (M, Q) => {
      i.value && (!M.length && e.hideNoData && (d.value = !1), !Q.length && M.length && (d.value = !0));
    }), Z(() => {
      const M = !!(e.chips || t.chip), Q = !!(!e.hideNoData || I.value.length || t["prepend-item"] || t["append-item"] || t["no-data"]), ce = p.value.length > 0, xe = cn.filterProps(e);
      return u(cn, q({
        ref: l
      }, xe, {
        modelValue: A.value,
        "onUpdate:modelValue": [(ae) => A.value = ae, te],
        focused: i.value,
        "onUpdate:focused": (ae) => i.value = ae,
        validationValue: p.externalValue,
        counterValue: x.value,
        dirty: ce,
        onChange: G,
        class: ["v-autocomplete", `v-autocomplete--${e.multiple ? "multiple" : "single"}`, {
          "v-autocomplete--active-menu": d.value,
          "v-autocomplete--chips": !!e.chips,
          "v-autocomplete--selection-slot": !!t.selection,
          "v-autocomplete--selecting-index": c.value > -1
        }, e.class],
        style: e.style,
        readonly: e.readonly,
        placeholder: ce ? void 0 : e.placeholder,
        "onClick:clear": J,
        "onMousedown:control": _,
        onKeydown: O
      }), {
        ...t,
        default: () => u(ie, null, [u(Yi, q({
          ref: r,
          modelValue: d.value,
          "onUpdate:modelValue": (ae) => d.value = ae,
          activator: "parent",
          contentClass: "v-autocomplete__content",
          disabled: E.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterLeave: ee
        }, e.menuProps), {
          default: () => [Q && u(Hi, {
            ref: L,
            selected: T.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (ae) => ae.preventDefault(),
            onKeydown: X,
            onFocusin: R,
            onFocusout: Y,
            onScrollPassive: N,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, {
            default: () => {
              var ae, Se, me;
              return [(ae = t["prepend-item"]) == null ? void 0 : ae.call(t), !I.value.length && !e.hideNoData && (((Se = t["no-data"]) == null ? void 0 : Se.call(t)) ?? u(Ct, {
                title: a(e.noDataText)
              }, null)), u(Zi, {
                ref: f,
                renderless: !0,
                items: I.value
              }, {
                default: (Ee) => {
                  var ka;
                  let {
                    item: pe,
                    index: et,
                    itemRef: tt
                  } = Ee;
                  const pa = q(pe.props, {
                    ref: tt,
                    key: et,
                    active: $.value && et === 0 ? !0 : void 0,
                    onClick: () => le(pe)
                  });
                  return ((ka = t.item) == null ? void 0 : ka.call(t, {
                    item: pe,
                    index: et,
                    props: pa
                  })) ?? u(Ct, pa, {
                    prepend: (zt) => {
                      let {
                        isSelected: Ht
                      } = zt;
                      return u(ie, null, [e.multiple && !e.hideSelected ? u(Vi, {
                        key: pe.value,
                        modelValue: Ht,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, pe.props.prependAvatar && u(St, {
                        image: pe.props.prependAvatar
                      }, null), pe.props.prependIcon && u(ye, {
                        icon: pe.props.prependIcon
                      }, null)]);
                    },
                    title: () => {
                      var zt, Ht;
                      return o.value ? pe.title : Bu(pe.title, (zt = k(pe)) == null ? void 0 : zt.title, ((Ht = A.value) == null ? void 0 : Ht.length) ?? 0);
                    }
                  });
                }
              }), (me = t["append-item"]) == null ? void 0 : me.call(t)];
            }
          })]
        }), p.value.map((ae, Se) => {
          function me(tt) {
            tt.stopPropagation(), tt.preventDefault(), le(ae, !1);
          }
          const Ee = {
            "onClick:close": me,
            onMousedown(tt) {
              tt.preventDefault(), tt.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, pe = M ? !!t.chip : !!t.selection, et = pe ? ea(M ? t.chip({
            item: ae,
            index: Se,
            props: Ee
          }) : t.selection({
            item: ae,
            index: Se
          })) : void 0;
          if (!(pe && !et))
            return u("div", {
              key: ae.value,
              class: ["v-autocomplete__selection", Se === c.value && ["v-autocomplete__selection--selected", C.value]],
              style: Se === c.value ? V.value : {}
            }, [M ? t.chip ? u(he, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: ae.title
                }
              }
            }, {
              default: () => [et]
            }) : u(Ti, q({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: ae.title,
              disabled: ae.props.disabled
            }, Ee), null) : et ?? u("span", {
              class: "v-autocomplete__selection-text"
            }, [ae.title, e.multiple && Se < p.value.length - 1 && u("span", {
              class: "v-autocomplete__selection-comma"
            }, [hl(",")])])]);
        })]),
        "append-inner": function() {
          var Ee;
          for (var ae = arguments.length, Se = new Array(ae), me = 0; me < ae; me++)
            Se[me] = arguments[me];
          return u(ie, null, [(Ee = t["append-inner"]) == null ? void 0 : Ee.call(t, ...Se), e.menuIcon ? u(ye, {
            class: "v-autocomplete__menu-icon",
            icon: e.menuIcon,
            onMousedown: B,
            onClick: Eo,
            "aria-label": a(g.value),
            title: a(g.value)
          }, null) : void 0]);
        }
      });
    }), _t({
      isFocused: i,
      isPristine: o,
      menu: d,
      search: A,
      filteredItems: P,
      select: le
    }, l);
  }
});
const Fu = F({
  fluid: {
    type: Boolean,
    default: !1
  },
  ...ne(),
  ...ge()
}, "VContainer"), Uc = W()({
  name: "VContainer",
  props: Fu(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      rtlClasses: a
    } = Ge();
    return Z(() => u(e.tag, {
      class: ["v-container", {
        "v-container--fluid": e.fluid
      }, a.value, e.class],
      style: e.style
    }, t)), {};
  }
}), Ca = ["start", "end", "center"], eo = ["space-between", "space-around", "space-evenly"];
function xa(e, n) {
  return tu.reduce((t, a) => {
    const l = e + Kn(a);
    return t[l] = n(), t;
  }, {});
}
const Lu = [...Ca, "baseline", "stretch"], to = (e) => Lu.includes(e), no = xa("align", () => ({
  type: String,
  default: null,
  validator: to
})), Ou = [...Ca, ...eo], ao = (e) => Ou.includes(e), lo = xa("justify", () => ({
  type: String,
  default: null,
  validator: ao
})), Mu = [...Ca, ...eo, "stretch"], io = (e) => Mu.includes(e), oo = xa("alignContent", () => ({
  type: String,
  default: null,
  validator: io
})), fl = {
  align: Object.keys(no),
  justify: Object.keys(lo),
  alignContent: Object.keys(oo)
}, Ru = {
  align: "align",
  justify: "justify",
  alignContent: "align-content"
};
function Du(e, n, t) {
  let a = Ru[e];
  if (t != null) {
    if (n) {
      const l = n.replace(e, "");
      a += `-${l}`;
    }
    return a += `-${t}`, a.toLowerCase();
  }
}
const Nu = F({
  dense: Boolean,
  noGutters: Boolean,
  align: {
    type: String,
    default: null,
    validator: to
  },
  ...no,
  justify: {
    type: String,
    default: null,
    validator: ao
  },
  ...lo,
  alignContent: {
    type: String,
    default: null,
    validator: io
  },
  ...oo,
  ...ne(),
  ...ge()
}, "VRow"), Kc = W()({
  name: "VRow",
  props: Nu(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = h(() => {
      const l = [];
      let i;
      for (i in fl)
        fl[i].forEach((o) => {
          const s = e[o], r = Du(i, o, s);
          r && l.push(r);
        });
      return l.push({
        "v-row--no-gutters": e.noGutters,
        "v-row--dense": e.dense,
        [`align-${e.align}`]: e.align,
        [`justify-${e.justify}`]: e.justify,
        [`align-content-${e.alignContent}`]: e.alignContent
      }), l;
    });
    return () => {
      var l;
      return xt(e.tag, {
        class: ["v-row", a.value, e.class],
        style: e.style
      }, (l = t.default) == null ? void 0 : l.call(t));
    };
  }
});
const zu = F({
  scrollable: Boolean,
  ...ne(),
  ...ge({
    tag: "main"
  })
}, "VMain"), Yc = W()({
  name: "VMain",
  props: zu(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      mainStyles: a
    } = fs(), {
      ssrBootStyles: l
    } = sa();
    return Z(() => u(e.tag, {
      class: ["v-main", {
        "v-main--scrollable": e.scrollable
      }, e.class],
      style: [a.value, l.value, e.style]
    }, {
      default: () => {
        var i, o;
        return [e.scrollable ? u("div", {
          class: "v-main__scroller"
        }, [(i = t.default) == null ? void 0 : i.call(t)]) : (o = t.default) == null ? void 0 : o.call(t)];
      }
    })), {};
  }
});
function Hu(e) {
  let {
    rootEl: n,
    isSticky: t,
    layoutItemStyles: a
  } = e;
  const l = z(!1), i = z(0), o = h(() => {
    const f = typeof l.value == "boolean" ? "top" : l.value;
    return [t.value ? {
      top: "auto",
      bottom: "auto",
      height: void 0
    } : void 0, l.value ? {
      [f]: j(i.value)
    } : {
      top: a.value.top
    }];
  });
  He(() => {
    H(t, (f) => {
      f ? window.addEventListener("scroll", r, {
        passive: !0
      }) : window.removeEventListener("scroll", r);
    }, {
      immediate: !0
    });
  }), Ie(() => {
    window.removeEventListener("scroll", r);
  });
  let s = 0;
  function r() {
    const f = s > window.scrollY ? "up" : "down", v = n.value.getBoundingClientRect(), d = parseFloat(a.value.top ?? 0), c = window.scrollY - Math.max(0, i.value - d), m = v.height + Math.max(i.value, d) - window.scrollY - window.innerHeight, g = parseFloat(getComputedStyle(n.value).getPropertyValue("--v-body-scroll-y")) || 0;
    v.height < window.innerHeight - d ? (l.value = "top", i.value = d) : f === "up" && l.value === "bottom" || f === "down" && l.value === "top" ? (i.value = window.scrollY + v.top - g, l.value = !0) : f === "down" && m <= 0 ? (i.value = 0, l.value = "bottom") : f === "up" && c <= 0 && (g ? l.value !== "top" && (i.value = -c + g + d, l.value = "top") : (i.value = v.top + c, l.value = "top")), s = window.scrollY;
  }
  return {
    isStuck: l,
    stickyStyles: o
  };
}
const ju = 100, Wu = 20;
function vl(e) {
  const n = 1.41421356237;
  return (e < 0 ? -1 : 1) * Math.sqrt(Math.abs(e)) * n;
}
function ml(e) {
  if (e.length < 2)
    return 0;
  if (e.length === 2)
    return e[1].t === e[0].t ? 0 : (e[1].d - e[0].d) / (e[1].t - e[0].t);
  let n = 0;
  for (let t = e.length - 1; t > 0; t--) {
    if (e[t].t === e[t - 1].t)
      continue;
    const a = vl(n), l = (e[t].d - e[t - 1].d) / (e[t].t - e[t - 1].t);
    n += (l - a) * Math.abs(l), t === e.length - 1 && (n *= 0.5);
  }
  return vl(n) * 1e3;
}
function Gu() {
  const e = {};
  function n(l) {
    Array.from(l.changedTouches).forEach((i) => {
      (e[i.identifier] ?? (e[i.identifier] = new To(Wu))).push([l.timeStamp, i]);
    });
  }
  function t(l) {
    Array.from(l.changedTouches).forEach((i) => {
      delete e[i.identifier];
    });
  }
  function a(l) {
    var f;
    const i = (f = e[l]) == null ? void 0 : f.values().reverse();
    if (!i)
      throw new Error(`No samples for touch id ${l}`);
    const o = i[0], s = [], r = [];
    for (const v of i) {
      if (o[0] - v[0] > ju)
        break;
      s.push({
        t: v[0],
        d: v[1].clientX
      }), r.push({
        t: v[0],
        d: v[1].clientY
      });
    }
    return {
      x: ml(s),
      y: ml(r),
      get direction() {
        const {
          x: v,
          y: d
        } = this, [c, m] = [Math.abs(v), Math.abs(d)];
        return c > m && v >= 0 ? "right" : c > m && v <= 0 ? "left" : m > c && d >= 0 ? "down" : m > c && d <= 0 ? "up" : Uu();
      }
    };
  }
  return {
    addMovement: n,
    endTouch: t,
    getVelocity: a
  };
}
function Uu() {
  throw new Error();
}
function Ku(e) {
  let {
    isActive: n,
    isTemporary: t,
    width: a,
    touchless: l,
    position: i
  } = e;
  He(() => {
    window.addEventListener("touchstart", w, {
      passive: !0
    }), window.addEventListener("touchmove", C, {
      passive: !1
    }), window.addEventListener("touchend", V, {
      passive: !0
    });
  }), Ie(() => {
    window.removeEventListener("touchstart", w), window.removeEventListener("touchmove", C), window.removeEventListener("touchend", V);
  });
  const o = h(() => ["left", "right"].includes(i.value)), {
    addMovement: s,
    endTouch: r,
    getVelocity: f
  } = Gu();
  let v = !1;
  const d = z(!1), c = z(0), m = z(0);
  let g;
  function y(p, x) {
    return (i.value === "left" ? p : i.value === "right" ? document.documentElement.clientWidth - p : i.value === "top" ? p : i.value === "bottom" ? document.documentElement.clientHeight - p : ht()) - (x ? a.value : 0);
  }
  function b(p) {
    let x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    const S = i.value === "left" ? (p - m.value) / a.value : i.value === "right" ? (document.documentElement.clientWidth - p - m.value) / a.value : i.value === "top" ? (p - m.value) / a.value : i.value === "bottom" ? (document.documentElement.clientHeight - p - m.value) / a.value : ht();
    return x ? Math.max(0, Math.min(1, S)) : S;
  }
  function w(p) {
    if (l.value)
      return;
    const x = p.changedTouches[0].clientX, S = p.changedTouches[0].clientY, P = 25, k = i.value === "left" ? x < P : i.value === "right" ? x > document.documentElement.clientWidth - P : i.value === "top" ? S < P : i.value === "bottom" ? S > document.documentElement.clientHeight - P : ht(), I = n.value && (i.value === "left" ? x < a.value : i.value === "right" ? x > document.documentElement.clientWidth - a.value : i.value === "top" ? S < a.value : i.value === "bottom" ? S > document.documentElement.clientHeight - a.value : ht());
    (k || I || n.value && t.value) && (v = !0, g = [x, S], m.value = y(o.value ? x : S, n.value), c.value = b(o.value ? x : S), r(p), s(p));
  }
  function C(p) {
    const x = p.changedTouches[0].clientX, S = p.changedTouches[0].clientY;
    if (v) {
      if (!p.cancelable) {
        v = !1;
        return;
      }
      const k = Math.abs(x - g[0]), I = Math.abs(S - g[1]);
      (o.value ? k > I && k > 3 : I > k && I > 3) ? (d.value = !0, v = !1) : (o.value ? I : k) > 3 && (v = !1);
    }
    if (!d.value)
      return;
    p.preventDefault(), s(p);
    const P = b(o.value ? x : S, !1);
    c.value = Math.max(0, Math.min(1, P)), P > 1 ? m.value = y(o.value ? x : S, !0) : P < 0 && (m.value = y(o.value ? x : S, !1));
  }
  function V(p) {
    if (v = !1, !d.value)
      return;
    s(p), d.value = !1;
    const x = f(p.changedTouches[0].identifier), S = Math.abs(x.x), P = Math.abs(x.y);
    (o.value ? S > P && S > 400 : P > S && P > 3) ? n.value = x.direction === ({
      left: "right",
      right: "left",
      top: "down",
      bottom: "up"
    }[i.value] || ht()) : n.value = c.value > 0.5;
  }
  const A = h(() => d.value ? {
    transform: i.value === "left" ? `translateX(calc(-100% + ${c.value * a.value}px))` : i.value === "right" ? `translateX(calc(100% - ${c.value * a.value}px))` : i.value === "top" ? `translateY(calc(-100% + ${c.value * a.value}px))` : i.value === "bottom" ? `translateY(calc(100% - ${c.value * a.value}px))` : ht(),
    transition: "none"
  } : void 0);
  return {
    isDragging: d,
    dragProgress: c,
    dragStyles: A
  };
}
function ht() {
  throw new Error();
}
const Yu = ["start", "end", "left", "right", "top", "bottom"], qu = F({
  color: String,
  disableResizeWatcher: Boolean,
  disableRouteWatcher: Boolean,
  expandOnHover: Boolean,
  floating: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  permanent: Boolean,
  rail: {
    type: Boolean,
    default: null
  },
  railWidth: {
    type: [Number, String],
    default: 56
  },
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  image: String,
  temporary: Boolean,
  touchless: Boolean,
  width: {
    type: [Number, String],
    default: 256
  },
  location: {
    type: String,
    default: "start",
    validator: (e) => Yu.includes(e)
  },
  sticky: Boolean,
  ...ct(),
  ...ne(),
  ...lu(),
  ...ft(),
  ...ds(),
  ...$e(),
  ...ge({
    tag: "nav"
  }),
  ...ve()
}, "VNavigationDrawer"), qc = W()({
  name: "VNavigationDrawer",
  props: qu(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:rail": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      emit: a,
      slots: l
    } = n;
    const {
      isRtl: i
    } = Ge(), {
      themeClasses: o
    } = be(e), {
      borderClasses: s
    } = dt(e), {
      backgroundColorClasses: r,
      backgroundColorStyles: f
    } = We(K(e, "color")), {
      elevationClasses: v
    } = vt(e), {
      displayClasses: d,
      mobile: c
    } = ha(e), {
      roundedClasses: m
    } = Fe(e), g = vi(), y = oe(e, "modelValue", null, (O) => !!O), {
      ssrBootStyles: b
    } = sa(), {
      scopeId: w
    } = Sn(), C = D(), V = z(!1), A = h(() => e.rail && e.expandOnHover && V.value ? Number(e.width) : Number(e.rail ? e.railWidth : e.width)), p = h(() => Fn(e.location, i.value)), x = h(() => !e.permanent && (c.value || e.temporary)), S = h(() => e.sticky && !x.value && p.value !== "bottom");
    Ne(() => e.expandOnHover && e.rail != null, () => {
      H(V, (O) => a("update:rail", !O));
    }), Ne(() => !e.disableResizeWatcher, () => {
      H(x, (O) => !e.permanent && de(() => y.value = !O));
    }), Ne(() => !e.disableRouteWatcher && !!g, () => {
      H(g.currentRoute, () => x.value && (y.value = !1));
    }), H(() => e.permanent, (O) => {
      O && (y.value = !0);
    }), Xn(() => {
      e.modelValue != null || x.value || (y.value = e.permanent || !c.value);
    });
    const {
      isDragging: P,
      dragProgress: k,
      dragStyles: I
    } = Ku({
      isActive: y,
      isTemporary: x,
      width: A,
      touchless: K(e, "touchless"),
      position: p
    }), T = h(() => {
      const O = x.value ? 0 : e.rail && e.expandOnHover ? Number(e.railWidth) : A.value;
      return P.value ? O * k.value : O;
    }), {
      layoutItemStyles: $,
      layoutItemScrimStyles: E
    } = vs({
      id: e.name,
      order: h(() => parseInt(e.order, 10)),
      position: p,
      layoutSize: T,
      elementSize: A,
      active: h(() => y.value || P.value),
      disableTransitions: h(() => P.value),
      absolute: h(() => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        e.absolute || S.value && typeof L.value != "string"
      ))
    }), {
      isStuck: L,
      stickyStyles: N
    } = Hu({
      rootEl: C,
      isSticky: S,
      layoutItemStyles: $
    }), X = We(h(() => typeof e.scrim == "string" ? e.scrim : null)), J = h(() => ({
      ...P.value ? {
        opacity: k.value * 0.2,
        transition: "none"
      } : void 0,
      ...E.value
    }));
    ut({
      VList: {
        bgColor: "transparent"
      }
    });
    function _() {
      V.value = !0;
    }
    function B() {
      V.value = !1;
    }
    return Z(() => {
      const O = l.image || e.image;
      return u(ie, null, [u(e.tag, q({
        ref: C,
        onMouseenter: _,
        onMouseleave: B,
        class: ["v-navigation-drawer", `v-navigation-drawer--${p.value}`, {
          "v-navigation-drawer--expand-on-hover": e.expandOnHover,
          "v-navigation-drawer--floating": e.floating,
          "v-navigation-drawer--is-hovering": V.value,
          "v-navigation-drawer--rail": e.rail,
          "v-navigation-drawer--temporary": x.value,
          "v-navigation-drawer--active": y.value,
          "v-navigation-drawer--sticky": S.value
        }, o.value, r.value, s.value, d.value, v.value, m.value, e.class],
        style: [f.value, $.value, I.value, b.value, N.value, e.style]
      }, w, t), {
        default: () => {
          var G, ee, R, Y;
          return [O && u("div", {
            key: "image",
            class: "v-navigation-drawer__img"
          }, [l.image ? (G = l.image) == null ? void 0 : G.call(l, {
            image: e.image
          }) : u("img", {
            src: e.image,
            alt: ""
          }, null)]), l.prepend && u("div", {
            class: "v-navigation-drawer__prepend"
          }, [(ee = l.prepend) == null ? void 0 : ee.call(l)]), u("div", {
            class: "v-navigation-drawer__content"
          }, [(R = l.default) == null ? void 0 : R.call(l)]), l.append && u("div", {
            class: "v-navigation-drawer__append"
          }, [(Y = l.append) == null ? void 0 : Y.call(l)])];
        }
      }), u(Ke, {
        name: "fade-transition"
      }, {
        default: () => [x.value && (P.value || y.value) && !!e.scrim && u("div", q({
          class: ["v-navigation-drawer__scrim", X.backgroundColorClasses.value],
          style: [J.value, X.backgroundColorStyles.value],
          onClick: () => y.value = !1
        }, w), null)]
      })]);
    }), {
      isStuck: L
    };
  }
});
function Xu(e) {
  const n = z(e);
  let t = -1;
  function a() {
    clearInterval(t);
  }
  function l() {
    a(), de(() => n.value = e);
  }
  function i(o) {
    const s = o ? getComputedStyle(o) : {
      transitionDuration: 0.2
    }, r = parseFloat(s.transitionDuration) * 1e3 || 200;
    if (a(), n.value <= 0)
      return;
    const f = performance.now();
    t = window.setInterval(() => {
      const v = performance.now() - f + r;
      n.value = Math.max(e - v, 0), n.value <= 0 && a();
    }, r);
  }
  return Ce(a), {
    clear: a,
    time: n,
    start: i,
    reset: l
  };
}
const Zu = F({
  multiLine: Boolean,
  text: String,
  timer: [Boolean, String],
  timeout: {
    type: [Number, String],
    default: 5e3
  },
  vertical: Boolean,
  ...ra({
    location: "bottom"
  }),
  ...di(),
  ...$e(),
  ...Qe(),
  ...ve(),
  ...Xe(ya({
    transition: "v-snackbar-transition"
  }), ["persistent", "noClickAnimation", "scrim", "scrollStrategy"])
}, "VSnackbar"), Xc = W()({
  name: "VSnackbar",
  props: Zu(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = oe(e, "modelValue"), {
      locationStyles: l
    } = ua(e), {
      positionClasses: i
    } = fi(e), {
      scopeId: o
    } = Sn(), {
      themeClasses: s
    } = be(e), {
      colorClasses: r,
      colorStyles: f,
      variantClasses: v
    } = Rt(e), {
      roundedClasses: d
    } = Fe(e), c = Xu(Number(e.timeout)), m = D(), g = D(), y = z(!1);
    H(a, w), H(() => e.timeout, w), He(() => {
      a.value && w();
    });
    let b = -1;
    function w() {
      c.reset(), window.clearTimeout(b);
      const p = Number(e.timeout);
      if (!a.value || p === -1)
        return;
      const x = Et(g.value);
      c.start(x), b = window.setTimeout(() => {
        a.value = !1;
      }, p);
    }
    function C() {
      c.reset(), window.clearTimeout(b);
    }
    function V() {
      y.value = !0, C();
    }
    function A() {
      y.value = !1, w();
    }
    return Z(() => {
      const p = un.filterProps(e), x = !!(t.default || t.text || e.text);
      return u(un, q({
        ref: m,
        class: ["v-snackbar", {
          "v-snackbar--active": a.value,
          "v-snackbar--multi-line": e.multiLine && !e.vertical,
          "v-snackbar--timer": !!e.timer,
          "v-snackbar--vertical": e.vertical
        }, i.value, e.class],
        style: e.style
      }, p, {
        modelValue: a.value,
        "onUpdate:modelValue": (S) => a.value = S,
        contentProps: q({
          class: ["v-snackbar__wrapper", s.value, r.value, d.value, v.value],
          style: [l.value, f.value],
          onPointerenter: V,
          onPointerleave: A
        }, p.contentProps),
        persistent: !0,
        noClickAnimation: !0,
        scrim: !1,
        scrollStrategy: "none",
        _disableGlobalStack: !0
      }, o), {
        default: () => {
          var S, P;
          return [Mt(!1, "v-snackbar"), e.timer && u("div", {
            key: "timer",
            class: "v-snackbar__timer"
          }, [u(ri, {
            ref: g,
            active: !y.value,
            color: typeof e.timer == "string" ? e.timer : "info",
            max: e.timeout,
            "model-value": c.time.value
          }, null)]), x && u("div", {
            key: "content",
            class: "v-snackbar__content",
            role: "status",
            "aria-live": "polite"
          }, [((S = t.text) == null ? void 0 : S.call(t)) ?? e.text, (P = t.default) == null ? void 0 : P.call(t)]), t.actions && u(he, {
            defaults: {
              VBtn: {
                variant: "text",
                ripple: !1,
                slim: !0
              }
            }
          }, {
            default: () => [u("div", {
              class: "v-snackbar__actions"
            }, [t.actions()])]
          })];
        },
        activator: t.activator
      });
    }), _t({}, m);
  }
});
const Ju = F({
  indeterminate: Boolean,
  inset: Boolean,
  flat: Boolean,
  loading: {
    type: [Boolean, String],
    default: !1
  },
  ...bn(),
  ...va()
}, "VSwitch"), Zc = W()({
  name: "VSwitch",
  inheritAttrs: !1,
  props: Ju(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const l = oe(e, "indeterminate"), i = oe(e, "modelValue"), {
      loaderClasses: o
    } = ca(e), {
      isFocused: s,
      focus: r,
      blur: f
    } = yn(e), v = D(), d = h(() => typeof e.loading == "string" && e.loading !== "" ? e.loading : e.color), c = Be(), m = h(() => e.id || `switch-${c}`);
    function g() {
      l.value && (l.value = !1);
    }
    function y(b) {
      var w, C;
      b.stopPropagation(), b.preventDefault(), (C = (w = v.value) == null ? void 0 : w.input) == null || C.click();
    }
    return Z(() => {
      const [b, w] = fn(t), C = wt.filterProps(e), V = sn.filterProps(e);
      return u(wt, q({
        class: ["v-switch", {
          "v-switch--inset": e.inset
        }, {
          "v-switch--indeterminate": l.value
        }, o.value, e.class]
      }, b, C, {
        modelValue: i.value,
        "onUpdate:modelValue": (A) => i.value = A,
        id: m.value,
        focused: s.value,
        style: e.style
      }), {
        ...a,
        default: (A) => {
          let {
            id: p,
            messagesId: x,
            isDisabled: S,
            isReadonly: P,
            isValid: k
          } = A;
          return u(sn, q({
            ref: v
          }, V, {
            modelValue: i.value,
            "onUpdate:modelValue": [(I) => i.value = I, g],
            id: p.value,
            "aria-describedby": x.value,
            type: "checkbox",
            "aria-checked": l.value ? "mixed" : void 0,
            disabled: S.value,
            readonly: P.value,
            onFocus: r,
            onBlur: f
          }, w), {
            ...a,
            default: (I) => {
              let {
                backgroundColorClasses: T,
                backgroundColorStyles: $
              } = I;
              return u("div", {
                class: ["v-switch__track", ...T.value],
                style: $.value,
                onClick: y
              }, null);
            },
            input: (I) => {
              let {
                inputNode: T,
                icon: $,
                backgroundColorClasses: E,
                backgroundColorStyles: L
              } = I;
              return u(ie, null, [T, u("div", {
                class: ["v-switch__thumb", {
                  "v-switch__thumb--filled": $ || e.loading
                }, e.inset ? void 0 : E.value],
                style: e.inset ? void 0 : L.value
              }, [u(_s, null, {
                default: () => [e.loading ? u(ci, {
                  name: "v-switch",
                  active: !0,
                  color: k.value === !1 ? void 0 : d.value
                }, {
                  default: (N) => a.loader ? a.loader(N) : u(si, {
                    active: N.isActive,
                    color: N.color,
                    indeterminate: !0,
                    size: "16",
                    width: "2"
                  }, null)
                }) : $ && u(ye, {
                  key: $,
                  icon: $,
                  size: "x-small"
                }, null)]
              })])]);
            }
          });
        }
      });
    }), {};
  }
});
const Qu = F({
  autoGrow: Boolean,
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: Function,
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  noResize: Boolean,
  rows: {
    type: [Number, String],
    default: 5,
    validator: (e) => !isNaN(parseFloat(e))
  },
  maxRows: {
    type: [Number, String],
    validator: (e) => !isNaN(parseFloat(e))
  },
  suffix: String,
  modelModifiers: Object,
  ...bn(),
  ...ba()
}, "VTextarea"), Jc = W()({
  name: "VTextarea",
  directives: {
    Intersect: ia
  },
  inheritAttrs: !1,
  props: Qu(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      emit: a,
      slots: l
    } = n;
    const i = oe(e, "modelValue"), {
      isFocused: o,
      focus: s,
      blur: r
    } = yn(e), f = h(() => typeof e.counterValue == "function" ? e.counterValue(i.value) : (i.value || "").toString().length), v = h(() => {
      if (t.maxlength)
        return t.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    });
    function d(T, $) {
      var E, L;
      !e.autofocus || !T || (L = (E = $[0].target) == null ? void 0 : E.focus) == null || L.call(E);
    }
    const c = D(), m = D(), g = z(""), y = D(), b = h(() => e.persistentPlaceholder || o.value || e.active);
    function w() {
      var T;
      y.value !== document.activeElement && ((T = y.value) == null || T.focus()), o.value || s();
    }
    function C(T) {
      w(), a("click:control", T);
    }
    function V(T) {
      a("mousedown:control", T);
    }
    function A(T) {
      T.stopPropagation(), w(), de(() => {
        i.value = "", pl(e["onClick:clear"], T);
      });
    }
    function p(T) {
      var E;
      const $ = T.target;
      if (i.value = $.value, (E = e.modelModifiers) != null && E.trim) {
        const L = [$.selectionStart, $.selectionEnd];
        de(() => {
          $.selectionStart = L[0], $.selectionEnd = L[1];
        });
      }
    }
    const x = D(), S = D(+e.rows), P = h(() => ["plain", "underlined"].includes(e.variant));
    Te(() => {
      e.autoGrow || (S.value = +e.rows);
    });
    function k() {
      e.autoGrow && de(() => {
        if (!x.value || !m.value)
          return;
        const T = getComputedStyle(x.value), $ = getComputedStyle(m.value.$el), E = parseFloat(T.getPropertyValue("--v-field-padding-top")) + parseFloat(T.getPropertyValue("--v-input-padding-top")) + parseFloat(T.getPropertyValue("--v-field-padding-bottom")), L = x.value.scrollHeight, N = parseFloat(T.lineHeight), X = Math.max(parseFloat(e.rows) * N + E, parseFloat($.getPropertyValue("--v-input-control-height"))), J = parseFloat(e.maxRows) * N + E || 1 / 0, _ = lt(L ?? 0, X, J);
        S.value = Math.floor((_ - E) / N), g.value = j(_);
      });
    }
    He(k), H(i, k), H(() => e.rows, k), H(() => e.maxRows, k), H(() => e.density, k);
    let I;
    return H(x, (T) => {
      T ? (I = new ResizeObserver(k), I.observe(x.value)) : I == null || I.disconnect();
    }), Ie(() => {
      I == null || I.disconnect();
    }), Z(() => {
      const T = !!(l.counter || e.counter || e.counterValue), $ = !!(T || l.details), [E, L] = fn(t), {
        modelValue: N,
        ...X
      } = wt.filterProps(e), J = Xi(e);
      return u(wt, q({
        ref: c,
        modelValue: i.value,
        "onUpdate:modelValue": (_) => i.value = _,
        class: ["v-textarea v-text-field", {
          "v-textarea--prefixed": e.prefix,
          "v-textarea--suffixed": e.suffix,
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-textarea--auto-grow": e.autoGrow,
          "v-textarea--no-resize": e.noResize || e.autoGrow,
          "v-input--plain-underlined": P.value
        }, e.class],
        style: e.style
      }, E, X, {
        centerAffix: S.value === 1 && !P.value,
        focused: o.value
      }), {
        ...l,
        default: (_) => {
          let {
            id: B,
            isDisabled: O,
            isDirty: G,
            isReadonly: ee,
            isValid: R
          } = _;
          return u(Sa, q({
            ref: m,
            style: {
              "--v-textarea-control-height": g.value
            },
            onClick: C,
            onMousedown: V,
            "onClick:clear": A,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"]
          }, J, {
            id: B.value,
            active: b.value || G.value,
            centerAffix: S.value === 1 && !P.value,
            dirty: G.value || e.dirty,
            disabled: O.value,
            focused: o.value,
            error: R.value === !1
          }), {
            ...l,
            default: (Y) => {
              let {
                props: {
                  class: te,
                  ...U
                }
              } = Y;
              return u(ie, null, [e.prefix && u("span", {
                class: "v-text-field__prefix"
              }, [e.prefix]), Ve(u("textarea", q({
                ref: y,
                class: te,
                value: i.value,
                onInput: p,
                autofocus: e.autofocus,
                readonly: ee.value,
                disabled: O.value,
                placeholder: e.placeholder,
                rows: e.rows,
                name: e.name,
                onFocus: w,
                onBlur: r
              }, U, L), null), [[qe("intersect"), {
                handler: d
              }, null, {
                once: !0
              }]]), e.autoGrow && Ve(u("textarea", {
                class: [te, "v-textarea__sizer"],
                id: `${U.id}-sizer`,
                "onUpdate:modelValue": (le) => i.value = le,
                ref: x,
                readonly: !0,
                "aria-hidden": "true"
              }, null), [[So, i.value]]), e.suffix && u("span", {
                class: "v-text-field__suffix"
              }, [e.suffix])]);
            }
          });
        },
        details: $ ? (_) => {
          var B;
          return u(ie, null, [(B = l.details) == null ? void 0 : B.call(l, _), T && u(ie, null, [u("span", null, null), u(qi, {
            active: e.persistentCounter || o.value,
            value: f.value,
            max: v.value
          }, l.counter)])]);
        } : void 0
      });
    }), _t({}, c, m, y);
  }
});
export {
  ds as $,
  Fe as A,
  ze as B,
  mn as C,
  Mt as D,
  ye as E,
  he as F,
  bn as G,
  Xe as H,
  re as I,
  ur as J,
  yn as K,
  Be as L,
  fn as M,
  wt as N,
  Vi as O,
  It as P,
  We as Q,
  Cc as R,
  Ia as S,
  Ue as T,
  ut as U,
  Rc as V,
  ct as W,
  lu as X,
  dt as Y,
  ha as Z,
  St as _,
  ks as a,
  Ct as a$,
  Jl as a0,
  sa as a1,
  vs as a2,
  ti as a3,
  j as a4,
  ai as a5,
  ya as a6,
  Wl as a7,
  Sn as a8,
  se as a9,
  Jo as aA,
  Tl as aB,
  vc as aC,
  oc as aD,
  Vo as aE,
  _s as aF,
  nc as aG,
  Ii as aH,
  xi as aI,
  tc as aJ,
  fc as aK,
  Re as aL,
  Qo as aM,
  kt as aN,
  gc as aO,
  st as aP,
  Au as aQ,
  Qi as aR,
  wa as aS,
  Ni as aT,
  ma as aU,
  Hn as aV,
  Eu as aW,
  Ji as aX,
  cn as aY,
  Yi as aZ,
  Hi as a_,
  _t as aa,
  Bn as ab,
  un as ac,
  fa as ad,
  da as ae,
  ui as af,
  hn as ag,
  ca as ah,
  Xl as ai,
  ci as aj,
  ac as ak,
  Ge as al,
  ri as am,
  Ql as an,
  ou as ao,
  ei as ap,
  su as aq,
  Bs as ar,
  Ot as as,
  lt as at,
  vn as au,
  uc as av,
  mc as aw,
  wn as ax,
  rt as ay,
  dc as az,
  Vs as b,
  Kt as b$,
  Zi as b0,
  ea as b1,
  Ti as b2,
  Eo as b3,
  Ae as b4,
  ic as b5,
  Tn as b6,
  fe as b7,
  sc as b8,
  Me as b9,
  Sc as bA,
  iu as bB,
  lc as bC,
  Jt as bD,
  Ml as bE,
  va as bF,
  sn as bG,
  ki as bH,
  Dc as bI,
  yt as bJ,
  tn as bK,
  En as bL,
  Nt as bM,
  fr as bN,
  vr as bO,
  xc as bP,
  Gc as bQ,
  Za as bR,
  Lc as bS,
  Hc as bT,
  ii as bU,
  Ja as bV,
  Uc as bW,
  kc as bX,
  Vc as bY,
  Kl as bZ,
  pc as b_,
  cc as ba,
  Oe as bb,
  Dt as bc,
  Wc as bd,
  yc as be,
  Ln as bf,
  De as bg,
  Br as bh,
  pu as bi,
  ku as bj,
  wu as bk,
  Pc as bl,
  Ul as bm,
  ba as bn,
  rc as bo,
  Xi as bp,
  Sa as bq,
  qi as br,
  pl as bs,
  Xr as bt,
  Zr as bu,
  oi as bv,
  si as bw,
  cs as bx,
  gs as by,
  ia as bz,
  Fl as c,
  Oc as c0,
  nl as c1,
  Pr as c2,
  Ir as c3,
  Tr as c4,
  Yc as c5,
  dr as c6,
  qc as c7,
  Xa as c8,
  Kc as c9,
  tu as cA,
  Nc as cB,
  zc as cC,
  _c as ca,
  Ic as cb,
  Tc as cc,
  Ac as cd,
  Bc as ce,
  Ec as cf,
  $c as cg,
  Gl as ch,
  Xc as ci,
  li as cj,
  Zc as ck,
  Jc as cl,
  Fc as cm,
  fu as cn,
  hc as co,
  jc as cp,
  wc as cq,
  Mc as cr,
  bc as cs,
  en as ct,
  nu as cu,
  Rn as cv,
  Hs as cw,
  ln as cx,
  Fs as cy,
  Ne as cz,
  ne as d,
  Ze as e,
  Vt as f,
  W as g,
  ft as h,
  Jn as i,
  ra as j,
  di as k,
  $e as l,
  lr as m,
  ge as n,
  ve as o,
  F as p,
  Qe as q,
  oe as r,
  be as s,
  Rt as t,
  Z as u,
  Je as v,
  Pt as w,
  vt as x,
  ua as y,
  fi as z
};
